import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  Box,
  TextField,
  Tooltip
} from "@material-ui/core";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import VesselContractForm from "../../../components/Calculator/AddCalculatorFleet/createVesselContractModel";
import ExpenseBreakdownModal from "../../../components/Calculator/ExpenseBreakdownModal";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomShowModal from "../../../components/Common/CustomShowModal";
import {
  initialContractFields,
  initialVesselContractFields,
} from "../Calculator/Contracts";
import CreateCargoContractForm from "../Orders/createCargoContractModel";
import "./../../../styles/custom.scss";
import { calculateOperation, checkTripEligibility, endTrip, getOperationById } from "./action";
import CargoOperationTable from "./CargoOperationTable";
import FualSupplyTable from "./FualSupplyTable";
import HireExpenseCalculations from "./HireExpenseCalculations";
import NextTripCargoSelectionModal from "./NextTripCargoSelectionModal";
import { extractEstimatePortList, mergeCargoWithEstimate } from "./operationUtils";
import TripEndWarningModal, { normalizeTripEligibilityResponse } from "./TripEndWarningModal";

import _, { debounce } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { SavedOperation } from "../..";
import CustomTabs from "../../../common/Tabs";
import CustomTooltip from "../../../common/Tooltip";
import AddOperationsModal from "../../../components/Calculator/AddOperationsModal";
import {
  toastError,
  toastSuccess,
  toastWarning,
} from "../../../utils";
import {
  getPostedInvoiceByUserId,
} from "../Accounting/actions";
import { portsByChar, updateCargoContract, updateVesselContract } from "../Calculator/actions";
import CargoViewModel from "../Calculator/Contracts/CargoViewModel";
import SavedContracts from "../Calculator/Contracts/savedContracts";
import VesselViewModel from "../Calculator/Contracts/VesselViewModel";
import {
  createElectricLaytimePdf,
  createElectricSofPdf,
} from "../Electric/action";
import AdditionalRevenueModel from "./AdditionalRevenueModel";
import DateChangeModal from "./DateChangeModal";
import ExpensesInvoiceModel from "./ExpensesInvoiceModel";
import FinalInvoiceModel from "./FinalInvoiceModel";
import FuelExpenseTable from "./FuelExpenseTable";
import FuelSupplyReqModel from "./FuelSupplyReqModel";
import InsightsTable from "./InsightsTable";
import IssueInvoiceModel from "./IssueInvoiceModel";
import LaytimeSettlementModel from "./LaytimeSettlementModel";
import LaytimeStatement from "./LaytimeStatement";
import OtherExpensesModal from "./OtherExpensesModal";
import PortSelectInvoiceModal from "./PortSelectInvoiceModal";
import PricingTable from "./PricingTable";
import SeaTable from "./SeaTable";
import StatementOfFactsModel from "./StatementofFactsModel";
import SustainabilityModel from "./sustainabilityModel";


const revenueFields = [
  { label: "Gross Freight", key: "grossFreight" },
  { label: "Charterer's Adcom", key: "charterersAdcom" },
  { label: "Brokerage", key: "brokerage" },
  { label: "% Taxes, Others, etc", key: "taxesOthers" },
  { label: "Laytime (Demurrage/Despatch)", key: "laytime" },
  { label: "Additional", key: "additional", link: true },
  { label: "Net Revenue", key: "netFreightRevenue" },
];

const expensesFields = [
  { label: "Gross Hire Amount", key: "grossHireAmount" },
  { label: "Adcom", key: "adCom" },
  { label: "Brokerage Exp", key: "brokerageExp" },
  { label: "Deduction", key: "deduction" },
  { label: "Total Net Hire Expense", key: "totalNetHireExpense" },
  { label: "CVE", key: "cve" },
  { label: "Port Expenses", key: "portExpenses" },
  { label: "Other Exp", key: "otherExp", link: true },
  { label: "HSFO (Main Fuel Expenses)", key: "MainFuelExpHSFO" },
  { label: "LSFO (ECA Fuel Expense)", key: "ECAFuelExpLSFO" },
  { label: "MGO (Light Fuel Expense)", key: "lightFuelExpMGO" },
  { label: "Total Fuel Expenses", key: "totalFuelExpenses" },
  { label: "Total Trip Exp", key: "totalTripExp" },
];

const profitFileds = [
  // { label: "Fuel Settlement Profit HSFO", key: "fuelSettlementProfitHSFO" },
  // { label: "Fuel Settlement Profit LSFO", key: "fuelSettlementProfitLSFO" },
  // { label: "Fuel Settlement Profit MGO", key: "fuelSettlementProfitMGO" },
  { label: "Fuel Settlement Profit Total", key: "fuelSettlementProfitTotal" },
  { label: "Net Profit", key: "netProfit" },
  { label: "TCE Net", key: "tceNet" },
  { label: "Total Trip Duration", key: "totalTripDuration" },
  { label: "Off-hire Duration ", key: "OffhireDuration" },
  { label: "Hire Duration", key: "hireDuration" },
  { label: "Ballast Passage", key: "ballastPassage" },
  { label: "Laden Passage", key: "ladenPassage" },
  { label: "Port Stay Total", key: "portStayTotal" },
  { label: "HSFO (Main Fuel) Qty", key: "hsfoQty" },
  { label: "LSFO Qty", key: "lsfoQty" },
  { label: "MGO Qty", key: "mgoQty" },
];

const columns = [
  {
    key: "operation",
    label: "Operation",
    width: "40px",
    editable: false,
    bg: "#ffefdc",
  },
  {
    key: "port",
    label: "Port",
    width: "40px",
    editable: false,
    bg: "#fff0ec",
  },
  {
    key: "cargoTx",
    label: "Cargo Tx Input/Manual",
    width: "40px",
    editable: true,
  },
  {
    key: "cargoDescription",
    label: "Cargo Description",
    width: "50px",
    editable: true,
  },
  {
    key: "billOfLadingDate",
    label: "Bill of Lading Date",
    width: "40px",
    editable: true,
    type: "datetime",
  },
  { key: "blNumber", label: "B/L Number", width: "30px", editable: true },
  { key: "remarks", label: "Remarks", width: "70px", editable: true },
  {
    key: "issueInvoice",
    label: "Issue Invoice",
    editable: true,
    width: "70px",
    isBtn: true,
  },
  {
    key: "statementOfFacts",
    label: "Statement of Facts",
    width: "40px",
    editable: true,
    isBtn: true,
  },
  {
    key: "laytimes",
    label: "Laytimes (Hours)",
    width: "30px",
    editable: true,
    isBtn: true,
  },
  { key: "remarks2", label: "Remarks", width: "40px", editable: true },
  { key: "portExp", label: "Port Exp", width: "30px", editable: true },
  { key: "sulfur", label: "Port Emission", width: "30px", type: "selection", options: ['Normal', "ECA"], editable: true },
  { key: "loadline", label: "Loadline", width: "30px", type: "selection", options: ['S-Summer', "TF-Tropical", "F-FW", "T-Tropical", "W-Winter", "WNA-Winter"], editable: true },
  {
    key: "draftRestriction",
    label: "Draft Restriction",
    width: "25px",
    editable: true,
  },
  {
    key: "waterDensity",
    label: "Water Density",
    width: "25px",
    editable: true,
  },
];

const insightsColumns = [
  {
    key: "operation",
    label: "Operation",
    tooltip: "Operation",
    width: "105px",
    editable: false,
    bg: "#ffefdc",
  },
  {
    key: "port",
    label: "Port",
    tooltip: "Port",
    width: "105px",
    editable: false,
    bg: "#fff0ec",
  },
];

const seaTableColumns = [
  {
    key: "operation",
    label: "Operation",
    tooltip: "Operation",
    width: "105px",
    editable: false,
    bg: "#ffefdc",
  },
  {
    key: "port",
    label: "Port",
    tooltip: "Port",
    width: "105px",
    editable: false,
    bg: "#fff0ec",
  },
  {
    key: "distNormal",
    label: "Dist (HSFO)",
    tooltip: "Distance Normal (HSFO)",
    width: "20px",
    editable: true,
    innerField: true,
  },
  {
    key: "distEca",
    label: "Dist (LSFO)",
    tooltip: "Distance ECA (LSFO)",
    width: "20px",
    editable: true,
    innerField: true,
  },
  {
    key: "observedDistanceNormal",
    label: "Obs Dist (Norm)",
    tooltip: "Observed Distance (Normal)",
    width: "20px",
    editable: true,
  },
  {
    key: "totalTimeTaken",
    label: "Tot Time",
    tooltip: "Total Time Taken",
    width: "20px",
    editable: true,
  },
  {
    key: "weatherDistance",
    label: "GW Dist",
    tooltip: "Good Weather Distance",
    width: "20px",
    editable: true,
  },
  {
    key: "weatherTimeDuration",
    label: "GW Time",
    tooltip: "Good Weather Time Duration (Days)",
    editable: true,
    width: "20px",
  },
  {
    key: "WeatherSpeed",
    label: "GW Spd",
    tooltip: "Good Weather Speed",
    width: "20px",
    editable: true,
  },
  {
    key: "badWeatherDistance",
    label: "BW Dist",
    tooltip: "Bad Weather Distance",
    width: "20px",
    editable: true,
  },
  {
    key: "badWeatherTimeDuration",
    label: "BW Time",
    tooltip: "Bad Weather Time Duration (Days)",
    editable: true,
    width: "20px",
  },
  {
    key: "badWeatherSpeed",
    label: "BW Spd",
    tooltip: "Bad Weather Speed",
    width: "20px",
    editable: true,
  },
  {
    key: "observedDistanceECA",
    label: "Obs Dist (ECA)",
    tooltip: "Observed Distance (ECA)",
    width: "20px",
    editable: true,
  },
  {
    key: "totalTimeTakenECA",
    label: "Tot Time (ECA)",
    tooltip: "Total Time Taken (ECA)",
    width: "20px",
    editable: true,
  },
  {
    key: "goodWeatherDistanceECA",
    label: "GW Dist (ECA)",
    tooltip: "Good Weather Distance (ECA)",
    width: "20px",
    editable: true,
  },
  {
    key: "goodWeatherTimeDurationECA",
    label: "GW Time (ECA)",
    tooltip: "Good Weather Time Duration (Days, ECA)",
    width: "20px",
    editable: true,
  },
  {
    key: "goodWeatherSpeedECA",
    label: "GW Spd (ECA)",
    tooltip: "Good Weather Speed (ECA)",
    width: "20px",
    editable: true,
  },
  {
    key: "badWeatherDistanceECA",
    label: "BW Dist (ECA)",
    tooltip: "Bad Weather Distance (ECA)",
    width: "20px",
    editable: true,
  },
  {
    key: "badWeatherTimeDurationECA",
    label: "BW Time (ECA)",
    tooltip: "Bad Weather Time Duration (Days, ECA)",
    width: "20px",
    editable: true,
  },
  {
    key: "badWeatherSpeedECA",
    label: "BW Spd (ECA)",
    tooltip: "Bad Weather Speed (ECA)",
    width: "20px",
    editable: true,
  },
];

const pricingColumns = [
  {
    key: "operation",
    label: "Operation",
    tooltip: "Operation",
    width: "105px",
    editable: false,
    bg: "#ffefdc",
  },
  {
    key: "port",
    label: "Port",
    tooltip: "Port",
    width: "105px",
    editable: false,
    bg: "#fff0ec",
  },
  {
    key: "name",
    label: "Cargo",
    tooltip: "Cargo",
    width: "30px",
    editable: false,
    outerValue: true,
  },
  {
    key: "stowFactor",
    label: "Stow F.",
    tooltip: "Stow Factor",
    width: "30px",
    editable: true,
  },
  {
    key: "min",
    label: "Min",
    tooltip: "Minimum",
    width: "30px",
    editable: true,
  },
  {
    key: "max",
    label: "Max",
    tooltip: "Maximum",
    width: "30px",
    editable: true,
  },
  {
    key: "ratePerDay",
    label: "Rate MT/d",
    tooltip: "Rate MT/day",
    width: "30px",
    editable: true,
  },
  {
    key: "terms",
    label: "Terms",
    tooltip: "Terms",
    width: "30px",
    editable: true,
  },
  {
    key: "turnTime",
    label: "Turn Time",
    tooltip: "Turn Time (days)",
    width: "30px",
    editable: true,
  },
  {
    key: "demurrage",
    label: "Demurrage",
    tooltip: "Demurrage Per Day",
    width: "30px",
    editable: true,
  },
  {
    key: "despatch",
    label: "Despatch",
    tooltip: "Despatch Per Day",
    width: "30px",
    editable: true,
  },
  {
    key: "freight",
    label: "Freight",
    tooltip: "Freight",
    width: "30px",
    editable: true,
  },
  {
    key: "lumpsumFreight",
    label: "Lumpsum",
    tooltip: "Lumpsum Freight",
    width: "30px",
    editable: true,
  },
  {
    key: "adcom",
    label: "Adcom",
    tooltip: "Adcom",
    width: "30px",
    editable: true,
  },
  {
    key: "other",
    label: "Other(%)",
    tooltip: "Other (%), Tax, ILOW, etc.",
    width: "30px",
    editable: true,
  },
  {
    key: "brokerage",
    label: "Brokerage",
    tooltip: "Brokerage",
    width: "30px",
    editable: true,
  },
  {
    key: "additionalRate",
    label: "Additional Rate",
    tooltip: "Additional Rate",
    width: "30px",
    editable: true,
  },
  {
    key: "lumpsumTypeRevenue",
    label: "LTR",
    tooltip: "Lumpsum Type Revenue",
    width: "30px",
    editable: true,
  },
  {
    key: "grossRevenue",
    label: "Gross Rev",
    tooltip: "Gross Revenue",
    width: "30px",
    editable: true,
  },
  {
    key: "adcomAmt",
    label: "Adcom Amt",
    tooltip: "Adcom Amount",
    width: "30px",
    editable: true,
  },
  {
    key: "otherAmt",
    label: "Other Amt",
    tooltip: "Other (%) Amount",
    width: "30px",
    editable: true,
  },
  {
    key: "brokerageAmt",
    label: "Broker Amt",
    tooltip: "Brokerage Amount",
    width: "30px",
    editable: true,
  },
  {
    key: "netRevenue",
    label: "Net Rev",
    tooltip: "Net Revenue",
    width: "30px",
    editable: true,
  },
  {
    key: "counterparty",
    label: "Ctrpty",
    tooltip: "Counterparty",
    width: "30px",
    editable: true,
  },
  {
    key: "laytime",
    label: "Laytime",
    tooltip: "Laytime Amount (Demurrage/Despatch)",
    width: "30px",
    editable: true,
  },
];

const expenseVesselFields = [
  { label: "Vessel Name", key: "vesselName", type: "text", disabled: true },
  { label: "Vessel ID", key: "vesselId", type: "text", disabled: true },
  { label: "Voyage Number", key: "voyageNumber", type: "text", disabled: true },
  { label: "CP Date (Expense)", key: "cpDate", type: "date", disabled: true },
  {
    label: "Counterparty",
    key: "counterpartyExpense",
    type: "text",
    disabled: true,
  },
  { label: "Ops Type", key: "contractType", type: "text", disabled: true },
];

const shipmentsFileds = [
  { label: "Ops ID", key: "opsId", type: "text", disabled: true },
  { label: "Ops Id (user)", key: "opsIdUser", type: "text", disabled: false },
  {
    label: "Commenced (Z)",
    key: "commencedZ",
    type: "datetime-local",
    disabled: true,
  },
  { label: "Commence Port", key: "commencePort", type: "text", disabled: true },
  {
    label: "First Load Port",
    key: "firstLoadPort",
    type: "text",
    disabled: true,
  },
  {
    label: "Last Disch Port",
    key: "lastDischPort",
    type: "text",
    disabled: true,
  },
  {
    label: "Completed (Z)",
    key: "completedZ",
    type: "datetime-local",
    disabled: true,
  },
  { label: "No. of Days", key: "noOfDays", type: "text", disabled: true },
  { label: "Total Revenue", key: "totalRevenue", type: "text", disabled: true },
  {
    label: "Total Expenditure",
    key: "totalExpenditure",
    type: "text",
    disabled: true,
  },
  { label: "Total Profit", key: "totalProfit", type: "text", disabled: true },
  {
    label: "Daily Returns (TCE)",
    key: "dailyReturnsTCE",
    type: "text",
    disabled: true,
  },
  { label: "Ops-PIC", key: "opsPIC", type: "text", disabled: true },
  {
    label: "Chartering-PIC",
    key: "charteringPIC",
    type: "text",
    disabled: true,
  },
  { label: "Vessel Type", key: "vesselType", type: "text", disabled: true },
  { label: "Status", key: "status", type: "text", disabled: true },
  {
    label: "Closure Date/Time",
    key: "closureDateTime",
    type: "datetime-local",
    disabled: true,
  },
  {
    label: "Cargo Description",
    key: "cargoDescription",
    type: "text",
    disabled: true,
  },
];

const revenueCargoFields = [
  {
    label: "CP Date (Revenue)",
    key: "cpDateRevenue",
    type: "date",
    disabled: true,
  },
  {
    label: "Counterparty",
    key: "counterpartyRevenue",
    type: "text",
    disabled: true,
  },
  {
    label: "Cargo Contract ID",
    key: "cargoContractId",
    type: "text",
    disabled: true,
  },
  {
    label: "Shipment Number",
    key: "shipmentNumber",
    type: "text",
    disabled: true,
  },
  {
    label: "Contract ID (user)",
    key: "contractIdUser",
    type: "text",
    disabled: true,
  },
  {
    label: "Shipment Number (user)",
    key: "shipmentNumberUser",
    type: "text",
    disabled: false,
  },
  { label: "PO No.", key: "poNo", type: "text", disabled: false },
  {
    label: "Shipper / Vendor",
    key: "shipperVendor",
    type: "text",
    disabled: false,
  },
  { label: "Shipper Code", key: "shipperCode", type: "text", disabled: false },
  { label: "User Ref", key: "userRef", type: "text", disabled: false },
];

const initialsustainabilityData = {
  voyageNumber: "",
  vesselName: "",
  vesselCpDate: "",
  cargoPartyId: "",
  cargoCpDate: "",
  fuelRows: [
    {
      type: "HFO",
      description: "Main Engine",
      selectedFuel: "Heavy Fuel Oil (HFO)",
    },
    {
      type: "ECA",
      description: "Auxiliary Engine",
      selectedFuel: "Diesel/Gas Oil",
    },
    { type: "MGO", description: "Boiler", selectedFuel: "Diesel/Gas Oil" },
  ],
  carbonRows: [],
  preVoyagePort: "",
  postVoyagePort: "",
  agreedEtsCo2: "",
  agreedEtsCost: "",
};

const OperationCalc = (props) => {
  const { setLoader, loader } = props;
  const { id = "" } = useParams();
  const isReadOnly = window.location.pathname.includes("/ops-calc/") || false;
  const [openSustainabilityModel, setOpenSustainabilityModel] = useState(false);
  const [cargoOperationTableData, setCargoOperationTableData] = useState({
    cargoList: [],
  });
  const [sustainabilityData, setSustainabilityData] = useState(
    initialsustainabilityData
  );
  const [uniqIds, setUniqIds] = useState({});
  const [selectedCargoIndex, setSelectedCargoIndex] = useState(0);
  const [isIssueInvoiceModelOpen, setIsIssueInvoiceModelOpen] = useState(false);
  const [isPortSelectModalOpen, setIsPortSelectModalOpen] = useState(false);
  const [openedFromPortSelect, setOpenedFromPortSelect] = useState(false);
  const [nextTripModalOpen, setNextTripModalOpen] = useState(false);
  const [tripEndWarningOpen, setTripEndWarningOpen] = useState(false);
  const [tripEndWarningReason, setTripEndWarningReason] = useState("");
  const [tripEndWarningMode, setTripEndWarningMode] = useState("blocked");

  const handleSelectPortForInvoice = (portItem, index) => {
    setSelectedCargoIndex(index);
    setOpenedFromPortSelect(true);
    setIsPortSelectModalOpen(false);
    setIsIssueInvoiceModelOpen(true);
  };
  const [subModelData, setSubModelData] = useState({
    margins: {
      dwf: 0,
      consumptionMargin: 0,
      speedMargin: 0,
      speedReduction: 0,
    },
    revenue: {
      misc: [
        { id: 1, label: "Misc 1", amount: 0 },
        { id: 2, label: "Misc 2", amount: 0 },
        { id: 3, label: "Misc 3", amount: 0 },
      ],
    },
    expenses: {
      cvePerDay: 0,
      insurancePerDay: 0,
      hireSurvey: 0,
      canalExpenses: 0,
      additionalPremium: 0,
      ilohc: 0,
      manoevringExp: 0,
      miscExp: [
        { id: 1, label: "Misc Exp-1", amount: 0 },
        { id: 2, label: "Misc Exp-2", amount: 0 },
      ],
    },
    fuelExpenseData: {
      hsfoShortfall: 0,
      lsfoShortfall: 0,
      mgoShortfall: 0,
      hsfoExcess: 0,
      lsfoExcess: 0,
      mgoExcess: 0,
      reserveInternalQtyHsfo: 0,
      reserveExternalQtyHsfo: 0,
      reserveInternalQtyLsfo: 0,
      redeliveryShortagePriceQtyHsfo: 0,
      settlementShortagePriceQtyHsfo: 0,
      withIntoleranceShortageCostHsfo: 0,
      outSidetoleranceShortageCostHsfo: 0,
      redeliveryExcessPriceQtyHsfo: 0,
      settlementExcessPriceQtyHsfo: 0,
      withIntoleranceExcessRevenueHsfo: 0,
      outSidetoleranceExcessRevenueHsfo: 0,
      redeliveryShortagePriceQtyLsfo: 0,
      settlementShortagePriceQtyLsfo: 0,
      withIntoleranceShortageCostLsfo: 0,
      outSidetoleranceShortageCostLsfo: 0,
      redeliveryExcessPriceQtyLsfo: 0,
      settlementExcessPriceQtyLsfo: 0,
      withIntoleranceExcessRevenueLsfo: 0,
      outSidetoleranceExcessRevenueLsfo: 0,
      costExcessLsfo: 0,
      reserveExternalQtyHsfo: 0,
      reserveInternalQtyMgo: 0,
      redeliveryShortagePriceQtyMgo: 0,
      settlementShortagePriceQtyMgo: 0,
      withIntoleranceShortageCostMgo: 0,
      outSidetoleranceShortageCostMgo: 0,
      redeliveryExcessPriceQtyMgo: 0,
      settlementExcessPriceQtyMgo: 0,
      withIntoleranceExcessRevenueMgo: 0,
      outSidetoleranceExcessRevenueMgo: 0,
      costExcessMgo: 0,
      reserveExternalQtyMgo: 0,
      reserveInternalCostHsfo: 0,
      reserveInternalCostLsfo: 0,
      reserveInternalCostMgo: 0,
      tripSupplyQtyHsfo: 0,
      tripSupplyCostHsfo: 0,
      averagePricePMTHsfo: 0,
      voyageConsumptionQtyHsfo: 0,
      appliedQuantityHsfo: 0,
      selectedAppliedCostHsfo: 0,
      appliedCostLIFOHsfo: 0,
      appliedCostFIFOHsfo: 0,
      appliedCostAverageHsfo: 0,
      expenditureforShortageHsfo: 0,
      voyagePricePMTHsfo: 0,
      excessCostHsfo: 0,
      revenueExcessHsfo: 0,
      shortageQtyHsfo: 0,
      excessQtyHsfo: 0,
      voyageFuelExpenditureHsfo: 0,
      fuelSettlementProfitHsfo: 0,
      qtyBalanceOnboardHsfo: 0,
      deliveryPricesHsfo: 0,
      tripSupplyQtyLsfo: 0,
      tripSupplyCostLsfo: 0,
      averagePricePMTLsfo: 0,
      voyageConsumptionQtyLsfo: 0,
      appliedQuantityLsfo: 0,
      selectedAppliedCostLsfo: 0,
      appliedCostLIFOLsfo: 0,
      appliedCostFIFOLsfo: 0,
      appliedCostAverageLsfo: 0,
      expenditureforShortageLsfo: 0,
      voyagePricePMTLsfo: 0,
      excessCostLsfo: 0,
      revenueExcessLsfo: 0,
      shortageQtyLsfo: 0,
      excessQtyLsfo: 0,
      voyageFuelExpenditureLsfo: 0,
      fuelSettlementProfitLsfo: 0,
      qtyBalanceOnboardLsfo: 0,
      deliveryPricesLsfo: 0,
      tripSupplyQtyMgo: 0,
      tripSupplyCostMgo: 0,
      averagePricePMTMgo: 0,
      voyageConsumptionQtyMgo: 0,
      appliedQuantityMgo: 0,
      selectedAppliedCostMgo: 0,
      appliedCostLIFOMgo: 0,
      appliedCostFIFOMgo: 0,
      appliedCostAverageMgo: 0,
      expenditureforShortageMgo: 0,
      voyagePricePMTMgo: 0,
      excessCostMgo: 0,
      revenueExcessMgo: 0,
      shortageQtyMgo: 0,
      excessQtyMgo: 0,
      voyageFuelExpenditureMgo: 0,
      fuelSettlementProfitMgo: 0,
      qtyBalanceOnboardMgo: 0,
      deliveryPricesMgo: 0,
      fuelMethodHsfo: "LIFO",
      fuelMethodLsfo: "LIFO",
      fuelMethodMgo: "LIFO",
      hsfoDeliveryPrice: 0,
      lsfoDeliveryPrice: 0,
      mgoDeliveryPrice: 0,
    },
  });
  const isSaved = useRef(false);
  const [warning, setWarning] = useState({});
  const isChanged = useRef(false);
  const [values, setValues] = useState({
    Revenue: {},
    Revised: {},
    Actual: [],
    Settled: [],
  });
  const unchangedValues = useRef(null);
  const [paymentInfo, setPaymentInfo] = useState({
    paymentOrderDate: "12 May 2023",
    paymentOrderRefNo: "PO-2023-05678",
    paymentEffectedDate: "15 May 2023",
    paymentReferenceNo: "UTR73948723984723",
  });
  const [selectedSettledAmt, setSelectedSettledAmt] = useState(null);
  const [offHireDeductions, setOffHireDeductions] = useState([
    {
      id: 1,
      from: "21-04-2025 03:56",
      fromTz: 5.5,
      to: "21-04-2025 18:32",
      toTz: 5,
      duration: 0.6297,
      offHireDeducation: 75,
      netDaysDedn: 2203.93,
      remarks: "",
    },
    {
      id: 2,
      from: "22-04-2025 05:56",
      fromTz: 6.5,
      to: "22-04-2025 07:32",
      toTz: 6,
      duration: 0.088,
      offHireDeducation: 50,
      netDaysDedn: 308.11,
      remarks: "",
    },
  ]);
  const [fuelDeductions, setFuelDeductions] = useState([
    {
      id: 1,
      parentId: 1,
      from: "",
      fromTz: 0,
      to: "",
      toTz: 0,
      fuelGrade: "Main",
      quantity: 0,
      price: 0,
      fuelDeducation: 0,
      amount: 0,
      remarks: "",
    },
    {
      id: 2,
      parentId: 1,
      from: " ",
      fromTz: 0,
      to: " ",
      toTz: 0,
      fuelGrade: "ECA",
      quantity: 0,
      price: 0,
      fuelDeducation: 0,
      amount: 0,
      remarks: "",
    },
    {
      id: 3,
      parentId: 1,
      from: " ",
      fromTz: 0,
      to: " ",
      toTz: 0,
      fuelGrade: "MGO",
      quantity: 0,
      price: 0,
      fuelDeducation: 0,
      amount: 0,
      remarks: "",
    },
  ]);
  const [miscDeductions, setMiscDeductions] = useState([
    {
      id: 1,
      remarks:
        "Detailed Narration text shall be entered by user for the hire deduction here (256 characters)",
      amount: 0,
    },
  ]);

  const mockData = {
    vesselName: "",
    vesselId: "",
    voyageNumber: "",
    cpDate: "",
    counterpartyExpense: "",
    opsType: "",
    opsId: "",
    opsIdUser: "",
    commencedZ: "",
    commencePort: "",
    firstLoadPort: "",
    lastDischPort: "",
    completedZ: "",
    noOfDays: "",
    totalRevenue: "",
    totalExpenditure: "",
    totalProfit: "",
    dailyReturnsTCE: "",
    opsPIC: "",
    charteringPIC: "",
    vesselType: "",
    status: "",
    closureDateTime: "",
    cargoDescription: "",
    cpDateRevenue: "",
    counterpartyRevenue: "",
    cargoContractId: "",
    shipmentNumber: "",
    contractIdUser: "",
    shipmentNumberUser: "",
    poNo: "",
    shipperVendor: "",
    shipperCode: "",
    userRef: [{ id: 1, label: "User Ref-1", value: "" }],
  };

  const [vesselCargoDetailsTableData, setVesselCargoDetailsTableData] =
    useState(mockData);

  const [invoiceInfo, setInvoiceInfo] = useState({
    dateOfInvoice: "05 May 2023",
    invoiceNumber: "INV-2023-1245",
    invoiceAmount: "1,245.00",
    paymentReceivedDate: "15 May 2023",
    paymentReferenceNumber: "SWIFTCH23456",
    remarks: "Final payment for Q2 services",
  });
  const [cargoContractDetails, setCargoContractDetails] = useState(
    initialContractFields
  );
  const [vesselContractDetails, setVesselContractDetails] = useState(
    initialVesselContractFields
  );
  const [selectedOperationIndex, setSelectedOperationIndex] = useState(0);
  const fuelSettlementList = [
    { label: "Redelivery", value: "redelivery" },
    { label: "Relay", value: "relay" },
  ];
  const operationStatusList = [
    { label: "Planned", value: "planned" },
    { label: "In Progress", value: "in-progress" },
    { label: "Completed", value: "completed" },
    { label: "Closed", value: "closed" },
  ];
  const [pendingDateChange, setPendingDateChange] = useState(null);
  const addQueryModalRef = useRef();
  const vesselCargoContainerRef = useRef(null);

  // handler states
  const [cargoInvoices, setCargoInvoices] = useState([]);

  const [vesselAttachments, setVesselAttachments] = useState([]);
  const [prevAttachments, setPrevAttachments] = useState([]);
  const [calculatedExpenses, setCalculatedExpenses] = useState({});
  const [vesselTextContract, setVesselTextContract] = useState();
  const [cargoAttachments, setCargoAttachments] = useState();
  const [cargoTextContract, setCargoTextContract] = useState();
  const [splitHireModal, setSplitHireModal] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [prevTab, setPrevTab] = useState(null);
  const [activeCargoModelTab, setActiveCargoModelTab] = useState(0);
  const [fuelSettlementMode, setFuelSettlementMode] = useState("redelivery");
  const [operationStatus, setOperationStatus] = useState("planned");
  const [rawContractData, setRawContractData] = useState({});
  const [nextOperationId, setNextOperationId] = useState(null);

  const [expenseInvoices, setExpenseInvoices] = useState([]);
  const [usedCounterparties, setUsedCounterparties] = useState({});

  const [editVesselContractModelOpen, setEditVesselContractModelOpen] =
    useState(false);
  const [openFuelExpenseModel, setOpenFuelExpenseModel] = useState(false);
  const [openAddOperation, setOpenAddOperation] = useState({
    isOpen: false,
    index: null,
  });
  const [openExpensesInvoiceModel, setOpenExpensesInvoiceModel] =
    useState(false);
  const [freightMode, setFreightMode] = useState("Single Freight");
  const [openAdditionalRevenueModel, setOpenAdditionalRevenueModel] =
    useState(false);
  const [isLaytimesModelOpen, setIsLaytimesModelOpen] = useState(false);
  const [isLaytimeSettlementsModelOpen, setIsLaytimeSettlementsModelOpen] =
    useState(false);
  const [isFinalInvoiceModelOpen, setIsFinalInvoiceModelOpen] = useState(false);
  const [isFuelSupplyRequestModelOpen, setIsFuelSupplyRequestModelOpen] =
    useState(false);
  const [isStatementOfFactsModelOpen, setIsStatementOfFactsModelOpen] =
    useState(false);
  const [openOtherExpModel, setOpenOtherExpModel] = useState(false);
  const [optimumSpeedModelOpen, setOptimumSpeedModelOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [editCargoContractModelOpen, setEditCargoContractModelOpen] =
    useState(false);
  const [showDateChangeModal, setShowDateChangeModal] = useState(false);
  const [expenseModalField, setExpenseModalField] = useState(null);
  const transitionTimeoutRef = useRef(null);
  const [portOptions, setPortOptions] = useState([]);
  const [portLoading, setPortLoading] = useState(false);
  const [initialAddOperation, setInitialAddOperation] = useState({
    operation: "Bunkering",
    port: "",
    portExp: 0,
    extraDays: 0,
    lat: 0,
    lng: 0,
  });
  const reCalculate = useRef(false);
  const [selectedPorts, setSelectedPorts] = useState([]);
  const [vesselActiveTab, setVesselActiveTab] = React.useState(0);
  useEffect(() => {
    setSustainabilityData((prev) => ({
      ...prev,
      vesselName: vesselContractDetails?.vesselDetails?.vesselName || "",
      vesselCpDate: vesselContractDetails?.cpDate || "",
      cargoCpDate: cargoContractDetails?.cpDate || "",
      voyageNumber: uniqIds?.voyageNumber || "",
    }));
  }, [uniqIds, vesselContractDetails, cargoContractDetails]);
  const [selectedQuery, setSelectedQuery] = useState({});
  const [selectedPortsCommence, setSelectedPortsCommence] = useState([]);
  const [finalState, setFinalState] = useState({
    groups: [
      { id: "group-1", name: "Port A", operations: [], totalStats: {} },
      { id: "group-2", name: "Port B", operations: [], totalStats: {} },
    ],
    ungroupedOperations: [],
    allOperations: [],
    globalStats: {},
  });
  const [pdfData, setPdfData] = useState([]);
  const [mainTab, setMainTab] = useState(2);
  const [isRevised, setIsRevised] = useState(false);
  // Calculate totals
  const totalOffHireDuration = useMemo(
    () => offHireDeductions.reduce((sum, item) => sum + item.netDaysDedn, 0),
    [offHireDeductions]
  );
  const totalFuelDeductions = useMemo(
    () => fuelDeductions.reduce((sum, item) => sum + item.amount, 0),
    [fuelDeductions]
  );
  const totalMiscDeductions = useMemo(
    () => miscDeductions.reduce((sum, item) => sum + item.amount, 0),
    [miscDeductions]
  );
  const totalDeductions = useMemo(
    () => totalFuelDeductions + totalMiscDeductions,
    [offHireDeductions, totalFuelDeductions, totalMiscDeductions]
  );

  const totalMiscExpenses =
    Number(subModelData?.expenses?.hireSurvey || 0) +
    Number(subModelData?.expenses?.canalExpenses || 0) +
    Number(subModelData?.expenses?.additionalPremium || 0) +
    Number(subModelData?.expenses?.ilohc || 0) +
    Number(subModelData?.expenses?.manoevringExp || 0) +
    (subModelData?.expenses?.miscExp?.reduce(
      (sum, item) => sum + Number(item.amount || 0),
      0
    ) || 0);

  const additionalRevenue = useMemo(() => {
    return subModelData?.revenue?.misc?.reduce(
      (sum, item) => sum + Number(item.amount || 0),
      0
    );
  }, [subModelData?.revenue?.misc]);
  const handleMainTabChange = (event, newValue) => {
    setMainTab(newValue);
  };

  const setIntialCargoInvoiceDetails = (cargoContract) => {
    const cargoData =
      // cargoContract?.cargoDetails?.customerCargo ||
      cargoContract?.cargoDetails ||
      cargoContract;
    const cargoList = cargoData?.cargoList || [];

    const initialCargoInvoiceDetails = cargoList.reduce((acc, item) => {
      if (item?.operation?.toLowerCase() === "loading") {
        // default invoice detail template
        const defaultInvoiceDetail = {
          _id: uuidv4(),
          cargoContractId: cargoContract?.cargoContractId,
          label: cargoData?.name || "",
          section: "",
          cargoName: cargoData?.name || "",
          cargoQty: 0,
          unit: "",
          rate: 0,
          amount: 0,
          payReceive: "",
          counterParty: "",
          description: "",
          hsn: "",
          isDefault: false,
          isCargo: true,
        };

        // merge invoiceDetails from cargoList (if exist)
        let invoiceDetails = [];

        if (item?.invoiceDetails?.length > 0) {
          invoiceDetails = item.invoiceDetails
            .filter((detail) => Number(detail.amount) > 0) // ✅ skip if amount is 0
            .map((detail) => ({
              ...defaultInvoiceDetail,
              ...detail,
              _id: detail._id || uuidv4(),
              cargoId: item._id, // ✅ link with cargoId
              isCargo: true, // ✅ ensure isCargo flag true
              amount: Number(detail.amount) || defaultInvoiceDetail.amount,
              label: detail.label || defaultInvoiceDetail.label,
              cargoContractId: cargoContract?.cargoContractId,
            }));
        }

        // push only if invoiceDetails left after filtering
        if (invoiceDetails.length > 0) {
          acc.push({
            cargoId: item._id,
            port: item.port,
            operation: item.operation,
            cargoName: cargoData?.name || "",
            totalAmt: invoiceDetails.reduce(
              (sum, d) => sum + (Number(d.amount) || 0),
              0
            ),
            invoiceDetails,
          });
        }
      }

      return acc;
    }, []);

    if (initialCargoInvoiceDetails.length > 0) {
      setCargoInvoices(initialCargoInvoiceDetails);
    }
  };
  const vesselRef = useRef(null);

  const handleUpdateVesselDetails = () => {
    vesselRef.current?.submit();
  };

  const fetchOperation = async () => {
    try {
      const { data } = await getOperationById({ id });
      setIsRevised(data?.isRevised || false);
      setNextOperationId(data?.nextOperationId || data?.operationCalculation?.nextOperationId || null);
      const {
        actualCalculation = {},
        calculatedExpenses = {},
        fuelSettlementMode = "redelivery",
        sustainabilityData = {},
        operationStatus = "planned",
        subModelCalculation = {},
        vesselCargoDetailsTableData = {},
        // cargoPrefixId = "",
        // opsId = "",
        // shipmentId = "",
        // voyageTripId = "",
        // vesselPrefixId = "",
      } = data?.operationCalculation || {};

      const transformIds = (id, type) => {
        const pad = (num, size) => {
          let s = num.toString();
          while (s.length < size) s = "0" + s;
          return s;
        };

        switch (type) {
          case "opsId":
            return `Ops-${pad(id, 6)}`;
          case "cargoPrefixId":
            return `C${pad(id, 6)}`;
          case "vesselPrefixId":
            return `V${pad(id, 6)}`;
          case "shipmentId":
            if (!transformedIds.cargoId) {
              throw new Error("cargoId must be transformed first");
            }
            return `${transformedIds.cargoId}S${pad(id, 3)}`;
          case "voyageTripId":
            if (!transformedIds.vesselId) {
              throw new Error("vesselId must be transformed first");
            }
            return `${transformedIds.vesselId}T${pad(id, 3)}`;
          default:
            return id.toString();
        }
      };

      const {
        cargoPrefixId = 1,
        opsId = 1,
        shipmentId = 1,
        voyageTripId = 1,
        vesselPrefixId = 1,
      } = data;

      const transformedIds = {};

      transformedIds.cargoId = transformIds(cargoPrefixId, "cargoPrefixId");
      transformedIds.opsId = transformIds(opsId, "opsId");
      transformedIds.vesselId = transformIds(vesselPrefixId, "vesselPrefixId");

      transformedIds.shipmentId = transformIds(shipmentId, "shipmentId");
      transformedIds.voyageNumber = transformIds(voyageTripId, "voyageTripId");

      setUniqIds(transformedIds);

      const cargoContract = {
        ...data?.cargoContractDetails,
        ...data?.cargoContractDetails?.actualCargoContract,
        cargoList:
          data?.cargoContractDetails?.actualCargoContract?.cargoList ||
          data?.cargoContractDetails?.cargoDetails?.cargoList ||
          [],
      };
      setVesselCargoDetailsTableData(
        (prev) => ({ ...prev, ...vesselCargoDetailsTableData } || {})
      );
      setCargoContractDetails(
        (prev) =>
        ({
          ...prev,
          ...cargoContract,
          cargoContractId: data?.cargoContractId,
        } || {})
      );
      setFreightMode(
        cargoContract?.cargoDetails?.freightMode || "Single Freight"
      );
      setVesselContractDetails(
        (prev) =>
        ({
          ...prev,
          ...data?.vesselContractDetails?.actualVesselContract,
          vesselContractId: data?.vesselContractId,
        } || {})
      );
      // Merge expenses: fall back to First Estimate if subModelCalculation expenses are empty
      let estimateClientQuery = {};
      if (data?.contractType === "vessel-vessel") {
        estimateClientQuery = data?.vesselContractDetails?.actualVesselContract?.clientQuery || data?.vesselContractDetails?.clientQuery || {};
      } else {
        estimateClientQuery = data?.cargoContractDetails?.actualCargoContract?.cargoDetails || data?.cargoContractDetails?.cargoDetails || {};
      }
      const savedExpenses = subModelCalculation?.expenses || {};
      const fallbackExpenses = estimateClientQuery || {};
      const expenseKeys = [
        { key: "cvePerDay", fbKey: "cve" },
        { key: "insurancePerDay", fbKey: "insurance" },
        { key: "hireSurvey", itemsKey: "hireSurveyItems" },
        { key: "canalExpenses", itemsKey: "canalExpensesItems" },
        { key: "additionalPremium", itemsKey: "additionalPremiumItems" },
        { key: "ilohc", itemsKey: "ilohcItems" },
        { key: "manoevringExp", itemsKey: "manoevringExpItems" },
      ];
      const mergedExpenses = { ...savedExpenses };
      expenseKeys.forEach(({ key, fbKey, itemsKey }) => {
        const fallbackValue = fallbackExpenses[key] !== undefined ? fallbackExpenses[key] : fallbackExpenses[fbKey];
        if (!mergedExpenses[key] && fallbackValue !== undefined) {
          mergedExpenses[key] = fallbackValue;
        }
        if (itemsKey && (!mergedExpenses[itemsKey] || mergedExpenses[itemsKey].length === 0) && fallbackExpenses[itemsKey]) {
          mergedExpenses[itemsKey] = fallbackExpenses[itemsKey];
        }
      });
      if (fallbackExpenses.dailyExpenses && (!mergedExpenses.dailyExpenses || mergedExpenses.dailyExpenses.length === 0)) {
        mergedExpenses.dailyExpenses = fallbackExpenses.dailyExpenses;
      }
      // If cve/insurance is still empty or 0, try to compute from dailyExpenses fallback
      if (!mergedExpenses.cvePerDay && mergedExpenses.dailyExpenses) {
        mergedExpenses.cvePerDay = mergedExpenses.dailyExpenses
          .filter(i => i.label?.toLowerCase()?.includes('cve'))
          .reduce((sum, i) => sum + (Number(i.value) || 0), 0);
      }
      if (!mergedExpenses.insurancePerDay && mergedExpenses.dailyExpenses) {
        mergedExpenses.insurancePerDay = mergedExpenses.dailyExpenses
          .filter(i => i.label?.toLowerCase()?.includes('insurance'))
          .reduce((sum, i) => sum + (Number(i.value) || 0), 0);
      }
      // Initialize expensesPerDay for the UI
      if (mergedExpenses.dailyExpenses && mergedExpenses.dailyExpenses.length > 0) {
        mergedExpenses.expensesPerDay = mergedExpenses.dailyExpenses.reduce((sum, i) => sum + (Number(i.value) || 0), 0);
      } else {
        mergedExpenses.expensesPerDay = (Number(mergedExpenses.cvePerDay) || 0) + (Number(mergedExpenses.insurancePerDay) || 0);
        mergedExpenses.dailyExpenses = [
          { label: "CVE per Day", value: Number(mergedExpenses.cvePerDay) || 0 },
          { label: "Insurance per Day", value: Number(mergedExpenses.insurancePerDay) || 0 },
        ];
      }
      if (!mergedExpenses.miscExp || !Array.isArray(mergedExpenses.miscExp) || mergedExpenses.miscExp.length === 0) {
        mergedExpenses.miscExp = fallbackExpenses.miscExpItems || (Array.isArray(fallbackExpenses.miscExp) ? fallbackExpenses.miscExp : null) || [
          { id: 1, label: "Misc Exp-1", amount: 0 },
          { id: 2, label: "Misc Exp-2", amount: 0 },
        ];
      }
      setSubModelData((prev) => ({
        ...prev,
        ...subModelCalculation,
        expenses: {
          ...prev.expenses,
          ...mergedExpenses,
        },
      }));

      const extractDetailedOutput = (detailedOutputObj) => {
        if (!detailedOutputObj || typeof detailedOutputObj !== "object") return {};
        const keys = Object.keys(detailedOutputObj);
        if (keys.length === 0) return {};
        const lastKey = keys[keys.length - 1];
        const dataObj = detailedOutputObj[lastKey];
        if (!dataObj) return {};

        const finalResult = dataObj.finalResultCalculationResult || {};
        const hireResult = dataObj.hireExpenseResult || {};
        const travelResult = dataObj.totalTravelDaysAndTotalTravelConsumption || {};
        const stayResult = dataObj.stayDurationResult || {};
        const revPivot = dataObj.revenueResultFreightPivot || {};

        const formatNum = (val) => {
          if (val === null || val === undefined || val === "") return "-";
          const num = parseFloat(val);
          if (!isNaN(num)) return num.toFixed(3);
          return val;
        };

        return {
          grossFreight: formatNum(revPivot.grossRevenueTotal),
          charterersAdcom: formatNum(revPivot.grossAdCommissionTotal),
          brokerage: formatNum(revPivot.grossBrokerageAmountTotal),
          taxesOthers: formatNum(revPivot.grossOtherTotal),
          laytime: "-",
          additional: "-",
          netFreightRevenue: formatNum(dataObj.netFrtRevenue ?? revPivot.grossNetRevenueTotal),
          grossHireAmount: formatNum(dataObj.hireExpense ?? hireResult.grossTotalHire),
          adCom: formatNum(hireResult.totalAdCommission),
          brokerageExp: "-",
          deduction: "-",
          totalNetHireExpense: formatNum(dataObj.hireExpense ?? finalResult.netHireExpenses ?? hireResult.totalNetHire),
          cve: formatNum(finalResult.cve),
          portExpenses: formatNum(finalResult.portExpenses),
          otherExp: formatNum(dataObj.otherExpense ?? finalResult.otherExpenses),
          MainFuelExpHSFO: formatNum(dataObj.fuelHsExpense ?? finalResult.totalFuelExpenses?.hsfo),
          ECAFuelExpLSFO: formatNum(dataObj.fuelLsExpense ?? finalResult.totalFuelExpenses?.lsfo),
          lightFuelExpMGO: formatNum(dataObj.fuelMgoExpense ?? finalResult.totalFuelExpenses?.mgo),
          totalFuelExpenses: formatNum(dataObj.fuelExpense ?? finalResult.totalFuelExpenses?.total),
          totalTripExp: formatNum(finalResult.tripExpense),
          fuelSettlementProfitTotal: formatNum(dataObj.fuelSettlementProfit ?? finalResult.fuelSettlementProfit),
          netProfit: formatNum(dataObj.profitNet ?? finalResult.profitNet),
          tceNet: formatNum(dataObj.tcEq ?? finalResult.tceCalculationResult?.tceNet),
          totalTripDuration: formatNum(dataObj.voyageDuration ?? finalResult.totalTripDuration),
          OffhireDuration: "-",
          hireDuration: "-",
          ballastPassage: formatNum(dataObj.ballastSeaDuration ?? travelResult.ballastTravelDays),
          ladenPassage: formatNum(dataObj.ladenSeaDuration ?? travelResult.ladenTravelDays),
          portStayTotal: formatNum(dataObj.portStayTotal ?? stayResult.total),
          hsfoQty: formatNum(dataObj.hsQuantity ?? finalResult.totalFuelConsumptionQty?.hsfo),
          lsfoQty: formatNum(dataObj.lsQuantity ?? finalResult.totalFuelConsumptionQty?.lsfo),
          mgoQty: formatNum(dataObj.mgoQuantity ?? finalResult.totalFuelConsumptionQty?.mgo),
        };
      };

      const revisedData = extractDetailedOutput(data?.detailed_output);
      const revenueData = extractDetailedOutput(data?.operationEstimateContract?.detailed_output);

      setValues((prev) => ({
        ...prev,
        Revenue: revenueData,
        Revised: revisedData,
        Actual: actualCalculation || [],
      }));
      unchangedValues.current = actualCalculation;
      setSustainabilityData(
        (prev) => ({ ...prev, ...sustainabilityData } || {})
      );
      setFuelSettlementMode(fuelSettlementMode || "redelivery");
      setOperationStatus(operationStatus || "planned");
      setCalculatedExpenses(
        (prev) => ({ ...prev, ...calculatedExpenses } || {})
      );
      const vesselName =
        data?.vesselContractDetails?.actualVesselContract?.vesselDetails
          ?.vessel &&
        JSON.parse(
          data?.vesselContractDetails?.actualVesselContract?.vesselDetails
            ?.vessel
        )?.vesselLabel;
      const initialExpenseAllocations = [
        "grossHireAmount",
        "adCom",
        "brokerageExp",
        "deduction",
        "totalNetHireExpense",
        "cve",
        "portExpenses",
        "otherExp",
      ].map((key) => ({
        vesselId: data?.vesselContractDetails?.actualVesselContract?.vesselId,
        key,
        totalAmt: values.Actual[key] || 0,
        vesselName,
        label: expensesFields.find((f) => f.key === key)?.label,
        invoiceDetails: [
          {
            _id: uuidv4(),
            vesselContractId: data?.vesselContractId,
            vesselName,
            label: expensesFields.find((f) => f.key === key)?.label,
            counterPartyId: "",
            name: "",
            amt: 0,
            isCargo: false,
          },
        ],
      }));
      setRawContractData(data || {});

      const expenseInvoices =
        data?.vesselContractDetails?.actualVesselContract?.vesselInvoiceDetails
          ?.length > 0
          ? data?.vesselContractDetails?.actualVesselContract
            ?.vesselInvoiceDetails
          : initialExpenseAllocations;

      const initialUsed = expenseInvoices.reduce((acc, item) => {
        acc[item.key] = new Set(
          item.invoiceDetails
            .map((detail) => detail.counterPartyId)
            .filter(Boolean)
        );
        return acc;
      }, {});

      setUsedCounterparties(() => initialUsed);
      setExpenseInvoices(expenseInvoices);
      const cargoData = cargoContract?.cargoDetails;
      const cargoList =
        cargoData?.cargoList || cargoData?.customerCargo?.cargoList || [];
      setIntialCargoInvoiceDetails(cargoContract);

      if (!cargoList || !Array.isArray(cargoList)) {
        setCargoOperationTableData([]);
        return;
      }
      // Extract estimate port data and merge with operations cargo rows
      const estimatePortList = extractEstimatePortList(data);
      const mergedCargoData = mergeCargoWithEstimate(cargoList, estimatePortList, convertToUTC);

      setCargoOperationTableData({
        ...cargoData,
        FuelSupplyRequests: cargoContract?.FuelSupplyRequests || [],
        cargoList: mergedCargoData,
      });

      const initialGroups = cargoContract?.counterPartyNames || [
        { id: "group-1", name: "Port A" },
        { id: "group-2", name: "Port B" },
      ];

      const processedData = cargoList
        .map((cargo) => {
          if (!cargo.laytimeStatement) return null;

          const statement = cargo.laytimeStatement;
          const operation = cargo.operation.toLowerCase();
          if (operation !== "loading" && operation !== "discharging")
            return null;

          return {
            Operation: cargo.operation || statement.norTerms || "Loading",
            Port: cargo.port || "",
            CargoDescription: statement.cargoDesc || cargo.cargo || "",
            CargoQty:
              parseFloat(statement.cargoQty).toFixed(3) || cargo.cargoQty || 0,
            RateMTday:
              parseFloat(statement.dischargingRate).toFixed(3) ||
              cargo.rate ||
              0,
            TurnTimeDays:
              parseFloat(statement.turnTimeAllowed).toFixed(3) ||
              cargo.turnTime ||
              0,
            BLDate:
              moment(
                cargo.billOfLadingDate || statement.norTendered || ""
              ).format("YYYY-MM-DD HH:mm") || "",
            CounterParty: cargo.charterer || "",
            DemurrageRate: parseFloat(statement.demurrageRate).toFixed(3) || 0,
            DespatchRate: parseFloat(statement.despatchRate).toFixed(3) || 0,
            TotalTimeAllowed:
              parseFloat(statement.totalTimeAllowed).toFixed(3) || 0,
            TotalTimeUsed: parseFloat(statement.totalTimeUsed).toFixed(3) || 0,
            Difference: parseFloat(statement.difference).toFixed(3) || 0,
            DemurrageDespatch: parseFloat(statement.demurrage).toFixed(3) || 0,
            vesselName: cargo.vesselName || "",
            terms: cargo.terms || statement.dischargingTerms || "",
            laytimeStarts: statement.laytimeStarts || "",
            laytimeStops: statement.laytimeStops || "",
          };
        })
        .filter(Boolean);

      const operations = processedData.map((op, index) => ({
        ...op,
        id: `op-${index}`,
        groupId: null,
        order: index,
      }));
      if (!Object.keys(cargoContract?.laytimeSettlementDetails || {}).length) {
        updateFinalState(operations, initialGroups);
      } else {
        setFinalState(cargoContract?.laytimeSettlementDetails);
      }
    } catch (error) {
      console.error("Error fetching operation:", error);
      setCargoOperationTableData([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (mainTab === 2) fetchOperation();
  }, [mainTab]);

  // Calculate stats for operations array
  const calculateStats = (operations) => {
    return {
      totalCargoQty: operations
        .reduce((sum, op) => sum + (parseFloat(op.CargoQty) || 0), 0)
        .toFixed(3),
      totalRateMTday: operations
        .reduce((sum, op) => sum + (parseFloat(op.RateMTday) || 0), 0)
        .toFixed(3),
      totalTurnTimeDays: operations
        .reduce((sum, op) => sum + (parseFloat(op.TurnTimeDays) || 0), 0)
        .toFixed(3),
      totalDemurrageRate: operations
        .reduce((sum, op) => sum + (parseFloat(op.DemurrageRate) || 0), 0)
        .toFixed(3),
      totalDespatchRate: operations
        .reduce((sum, op) => sum + (parseFloat(op.DespatchRate) || 0), 0)
        .toFixed(3),
      totalTimeAllowed: operations
        .reduce((sum, op) => sum + (parseFloat(op.TotalTimeAllowed) || 0), 0)
        .toFixed(3),
      totalTimeUsed: operations
        .reduce((sum, op) => sum + (parseFloat(op.TotalTimeUsed) || 0), 0)
        .toFixed(3),
      totalDifference: operations
        .reduce((sum, op) => sum + (parseFloat(op.Difference) || 0), 0)
        .toFixed(3),
      totalDemurrageDespatch: operations
        .reduce((sum, op) => sum + (parseFloat(op.DemurrageDespatch) || 0), 0)
        .toFixed(3),
      count: operations.length,
    };
  };

  const updateFinalState = (operations, groups) => {
    const ungroupedOps = operations.filter((op) => !op.groupId);
    const groupsWithOps = groups.map((group) => {
      const groupOps = operations
        .filter((op) => op.groupId === group.id)
        .sort((a, b) => a.order - b.order);

      return {
        ...group,
        operations: groupOps,
        totalStats: calculateStats(groupOps),
      };
    });

    setFinalState({
      groups: groupsWithOps,
      ungroupedOperations: ungroupedOps,
      allOperations: operations,
      globalStats: calculateStats(operations),
    });
  };

  useEffect(() => {
    setCargoContractDetails((prev) => ({
      ...prev,
      cargoDetails: {
        ...prev.cargoDetails,
        cargoList: cargoOperationTableData?.cargoList,
      },
    }));
  }, [cargoOperationTableData]);

  useEffect(() => {
    const cargoDetails = cargoContractDetails?.cargoDetails || {};
    const cargoList = cargoDetails?.cargoList || [];
    const rawVessel = vesselContractDetails?.vesselDetails?.vessel;

    const vesselName = rawVessel ? JSON.parse(rawVessel)?.vesselName : "";

    const updatedData = {
      vesselName,
      vesselId: vesselContractDetails?.vesselFixtureId || "",
      voyageNumber: vesselContractDetails?.voyageNumber || "",
      cpDate: vesselContractDetails?.cpDate || "",
      counterpartyExpense: vesselContractDetails?.counterParty || vesselContractDetails?.counterparty || "",
      opsType: vesselContractDetails?.contractType || vesselContractDetails?.opsType || rawContractData?.contractType || "",
      opsId: vesselContractDetails?.opsId || "",
      commencedZ: cargoList[0]?.arrivalTimeZ || cargoList[0]?.departureTimeZ || cargoList[0]?.arrivalTime || cargoList[0]?.departureTime
        ? moment(cargoList[0]?.arrivalTimeZ || cargoList[0]?.departureTimeZ || cargoList[0]?.arrivalTime || cargoList[0]?.departureTime).format("DD-MMM-YYYY HH:mm")
        : "",
      commencePort: cargoList[0]?.port || "",
      firstLoadPort: cargoList.find(c => c.operation?.toLowerCase() === "loading")?.port || "",
      lastDischPort: [...cargoList].reverse().find(c => c.operation?.toLowerCase() === "discharging")?.port || cargoList[cargoList.length - 1]?.port || "",
      completedZ: cargoList[cargoList.length - 1]?.arrivalTimeZ
        ? moment(cargoList[cargoList.length - 1].arrivalTimeZ).format(
          "DD-MMM-YYYY HH:mm"
        )
        : "",
      noOfDays:
        cargoList[0]?.arrivalTimeZ &&
          cargoList[cargoList.length - 1]?.arrivalTimeZ
          ? moment(cargoList[cargoList.length - 1].arrivalTimeZ).diff(
            moment(cargoList[0].arrivalTimeZ),
            "days"
          )
          : "",
      totalRevenue: values?.Actual?.netFreightRevenue || "",
      totalExpenditure: values?.Actual?.totalTripExp || "",
      totalProfit: values?.Actual?.netProfit || "",
      dailyReturnsTCE: values?.Actual?.tceNet || "",
      opsPIC: `${rawContractData?.assignedTo?.firstName || ""} ${rawContractData?.assignedTo?.lastName || ""
        }`.trim(),
      charteringPIC: `${rawContractData?.userId?.firstName || ""} ${rawContractData?.userId?.lastName || ""
        }`.trim(),
      vesselType: vesselContractDetails?.vesselType || "",
      status: vesselContractDetails?.status || "",
      closureDateTime: cargoContractDetails?.closureDateTime || "",
      cargoDescription: cargoDetails?.description || "",
      cpDateRevenue: cargoContractDetails?.cpDateRevenue || "",
      counterpartyRevenue: cargoContractDetails?.counterparty || "",
      cargoContractId: cargoContractDetails?.cargoContractId || "",
      shipmentNumber: cargoContractDetails?.shipmentNumber || "",
      contractIdUser: cargoContractDetails?.contractIdUser || "",
    };

    setVesselCargoDetailsTableData((prev) => ({
      ...prev,
      ...updatedData,
    }));
  }, [vesselContractDetails, cargoContractDetails, values, rawContractData]);

  useEffect(() => {
    const portOperation = cargoOperationTableData?.cargoList || [];
    setSelectedPortsCommence(
      portOperation.filter((item) => item.operation === "Commence")
    );
    setSelectedQuery(cargoOperationTableData);
    setSelectedPorts(
      portOperation.filter(
        (item) =>
          item.operation === "Loading" || item.operation === "Discharging"
      )
    );
  }, [cargoOperationTableData]);
  // onchange handlers

  const handlePaymentDateChange = (date, field) => {
    setPaymentInfo({
      ...paymentInfo,
      [field]: date ? date.format("DD MMM YYYY") : "",
    });
  };

  const handleInvoiceDateChange = (date, field) => {
    setInvoiceInfo({
      ...invoiceInfo,
      [field]: date ? date.format("DD MMM YYYY") : "",
    });
  };

  const handleTextChange = (e, section, field) => {
    const value = e.target.value;
    if (section === "payment") {
      setPaymentInfo({
        ...paymentInfo,
        [field]: value,
      });
    } else {
      setInvoiceInfo({
        ...invoiceInfo,
        [field]: value,
      });
    }
  };

  const handleChange = (category, field) => (event) => {
    if (category === "Actual" && field === "laytime") {
      setValues((prev) => ({
        ...prev,
        [category]: {
          ...prev[category],
          [field]: event.target.value,
        },
      }));
    }
  };
  const handleDateChangeForCargoOperationTable = (rowIndex, field, date) => {
    setCargoOperationTableData((prev) => {
      const newData = [...prev.cargoList];
      newData[rowIndex][field] = date
        ? moment(date).format("YYYY-MM-DD HH:mm:ss.S")
        : "";
      return {
        ...prev,
        cargoList: newData,
      };
    });
  };

  const handleDateChangeForFualSupplyTable = (rowIndex, field, date) => {
    setPendingDateChange({ rowIndex, field, date });
    setShowDateChangeModal(true);
  };

  function convertToUTC(dateTimeString, timezoneOffset) {
    const now = new Date();
    const fallbackUTC =
      now.toISOString().slice(0, 19).replace("T", " ") + ".000";

    if (!dateTimeString || typeof dateTimeString !== "string") {
      return fallbackUTC;
    }

    let normalizedDateTime = dateTimeString.trim();

    if (!normalizedDateTime.includes(" ")) {
      normalizedDateTime += " 00:00:00.000";
    } else {
      const [datePart, timePart] = normalizedDateTime.split(" ");
      const timeComponents = timePart.split(":");

      if (timeComponents.length === 2) {
        normalizedDateTime = `${datePart} ${timePart}:00.000`;
      } else if (timeComponents.length === 3) {
        const [hh, mm, ss] = timeComponents;
        if (!ss.includes(".")) {
          normalizedDateTime = `${datePart} ${hh}:${mm}:${ss}.000`;
        }
      }
    }
    let offsetHours = 0;
    let offsetMinutes = 0;

    if (timezoneOffset && typeof timezoneOffset === "string") {
      const offsetMatch = timezoneOffset.match(/^([+-]?)(\d+)(?:\.(\d+))?$/);
      if (offsetMatch) {
        const sign = offsetMatch[1] === "-" ? -1 : 1;
        offsetHours = (parseInt(offsetMatch[2]) || 0) * sign;
        offsetMinutes = (parseInt(offsetMatch[3]) || 0) * sign;
      }
    }

    let date;
    try {
      const [datePart, timePart] = normalizedDateTime.split(" ");
      const [hours, minutes, secondsWithMs] = timePart.split(":");
      const [seconds, milliseconds] = secondsWithMs.split(".").map(Number);
      let day, month, year;
      if (datePart.includes("/")) {
        [day, month, year] = datePart.split("/").map(Number);
      } else if (datePart.includes("-")) {
        [year, month, day] = datePart.split("-").map(Number);
      } else {
        throw new Error("Unknown date format");
      }

      date = new Date(
        Date.UTC(
          year || now.getUTCFullYear(),
          month ? month - 1 : now.getUTCMonth(),
          day || now.getUTCDate(),
          hours || 0,
          minutes || 0,
          seconds || 0,
          milliseconds || 0
        )
      );

      if (isNaN(date.getTime())) {
        date = new Date();
      }
    } catch (e) {
      date = new Date();
    }

    date.setUTCHours(date.getUTCHours() - offsetHours);
    date.setUTCMinutes(date.getUTCMinutes() - offsetMinutes);

    const pad = (num) => String(num).padStart(2, "0");

    return (
      `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(
        date.getUTCDate()
      )} ` +
      `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(
        date.getUTCSeconds()
      )}.` +
      `${String(date.getUTCMilliseconds()).padStart(3, "0")}`
    );
  }

  const handleInputChangeForCargoOperationTable = (rowIndex, field, value) => {
    isSaved.current = true;
    setCargoOperationTableData((prev) => {
      const newCargoList = [...prev.cargoList];
      const row = { ...newCargoList[rowIndex], [field]: value };

      if (field === "timeZone") {
        row.departureTimeZ = convertToUTC(row.departureTime, value);
        row.arrivalTimeZ = convertToUTC(row.arrivalTime, value);
      }
      const FUEL_PRICE_FIELDS = [
        "fuelPriceType0Hsfo",
        "fuelPriceType0Lsfo",
        "fuelPriceType0Mgo",
        "fuelPriceType1Hsfo",
        "fuelPriceType1Lsfo",
        "fuelPriceType1Mgo",
        "fuelPriceType2Hsfo",
        "fuelPriceType2Lsfo",
        "fuelPriceType2Mgo",
        "fuelPriceType3Hsfo",
        "fuelPriceType3Lsfo",
        "fuelPriceType3Mgo",
        "fuelPriceType4Hsfo",
        "fuelPriceType4Lsfo",
        "fuelPriceType4Mgo",
        "bunkerSuppliedHSFO",
        "bunkerSuppliedLSFO",
        "bunkerSuppliedMGO",
        "reserve",
        "paidBy",
      ];

      if (FUEL_PRICE_FIELDS.includes(field)) {
        const currentCargoDetails = newCargoList[rowIndex]?.cargoDetails || {};
        row.cargoDetails = {
          ...currentCargoDetails,
          [field]: value,
        };
      }
      newCargoList[rowIndex] = row;

      return {
        ...prev,
        cargoList: newCargoList,
      };
    });
  };

  const handlePortChange = async (rowIndex, field, value) => {
    const updatedCargoList = [...cargoOperationTableData.cargoList];
    updatedCargoList[rowIndex] = {
      ...updatedCargoList[rowIndex],
      [field]: value,
    };

    const newCargoOperationTableData = {
      ...cargoOperationTableData,
      cargoList: updatedCargoList,
    };

    setCargoOperationTableData(newCargoOperationTableData);
    setIntialCargoInvoiceDetails({
      ...cargoContractDetails,
      cargoDetails: newCargoOperationTableData,
    });
  };

  const confirmDateChange = (changeType) => {
    if (!pendingDateChange) return;

    const { rowIndex, field, date } = pendingDateChange;

    if (changeType === "current") {
      updateSingleDate(rowIndex, field, date);
    } else {
      updateDateWithCascade(rowIndex, field, date);
    }

    setPendingDateChange(null);
    setShowDateChangeModal(false);
  };

  const updateSingleDate = (rowIndex, field, date) => {
    const inputFormat = "DD/MM/YYYY HH:mm";
    const storedFormat = "YYYY-MM-DD HH:mm:ss.S";

    setCargoOperationTableData((prev) => {
      const newData = [...prev?.cargoList];
      const parsedNewDate = moment(date, inputFormat, true);

      if (!parsedNewDate.isValid()) {
        toastError("Invalid date format.");
        return prev;
      }

      const timeZoneOffset = newData[rowIndex]?.timeZone || "+0";

      if (field === "arrivalTime") {
        // Check against same row's departure time (if exists)
        const sameRowDepartureStr = newData[rowIndex]["departureTime"];
        if (sameRowDepartureStr) {
          const sameRowDeparture = moment(
            sameRowDepartureStr,
            storedFormat,
            true
          );
          if (
            sameRowDeparture.isValid() &&
            !parsedNewDate.isBefore(sameRowDeparture)
          ) {
            toastError(
              "Arrival time must be before the same row's departure time."
            );
            return prev;
          }
        }

        // Check against previous row's departure time (if exists)
        if (rowIndex > 0) {
          const prevDepartureStr = newData[rowIndex - 1]["departureTime"];
          if (prevDepartureStr) {
            const prevDeparture = moment(prevDepartureStr, storedFormat, true);
            if (
              prevDeparture.isValid() &&
              !parsedNewDate.isAfter(prevDeparture)
            ) {
              toastError(
                "Arrival time must be after the previous row's departure time."
              );
              return prev;
            }
          }
        }
      }

      if (field === "departureTime") {
        const currentArrivalStr = newData[rowIndex]["arrivalTime"];
        const currentArrival = moment(currentArrivalStr, storedFormat, true);
        if (
          currentArrival.isValid() &&
          !parsedNewDate.isAfter(currentArrival)
        ) {
          toastError(
            "Departure time must be after arrival time in the same row."
          );
          return prev;
        }
      }

      newData[rowIndex][field] = parsedNewDate.format(storedFormat);
      if (field === "arrivalTime") {
        newData[rowIndex]["arrivalTimeZ"] = convertToUTC(date, timeZoneOffset);
      } else if (field === "departureTime") {
        newData[rowIndex]["departureTimeZ"] = convertToUTC(
          date,
          timeZoneOffset
        );
      }
      return {
        ...prev,
        cargoList: newData,
      };
    });
  };

  const updateDateWithCascade = (rowIndex, field, date) => {
    const inputFormat = "DD/MM/YYYY HH:mm";
    const storedFormat = "YYYY-MM-DD HH:mm:ss.S";
    const parseFormats = [storedFormat, "YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm:ss", inputFormat];
    setCargoOperationTableData((prev) => {
      const newData = prev?.cargoList?.map((row) => ({ ...row }));
      const newDate = moment(date, inputFormat, true);

      if (!newDate.isValid()) {
        toastError("Invalid date format.");
        return prev;
      }

      if (field === "arrivalTime" && rowIndex > 0) {
        const prevDepartureStr = newData[rowIndex - 1]["departureTime"];
        const prevDeparture = moment(prevDepartureStr, parseFormats, true);
        if (prevDeparture.isValid() && !newDate.isAfter(prevDeparture)) {
          toastError(
            "Arrival time must be after the previous row's departure time."
          );
          return prev;
        }
      }

      if (field === "departureTime") {
        const currentArrivalStr = newData[rowIndex]["arrivalTime"];
        const currentArrival = moment(currentArrivalStr, parseFormats, true);
        if (currentArrival.isValid() && !newDate.isAfter(currentArrival)) {
          toastError(
            "Departure time must be after arrival time in the same row."
          );
          return prev;
        }
      }

      const originalDate = moment(newData[rowIndex][field], parseFormats, true);
      let timeDiff = 0;
      if (originalDate.isValid()) {
        timeDiff = newDate.diff(originalDate, "milliseconds");
      }

      newData[rowIndex][field] = newDate.format(storedFormat);

      const timeZoneOffset =
        newData[rowIndex].timeZone || newData[rowIndex].timeZoneOffset || "+0";
      if (field === "arrivalTime") {
        newData[rowIndex]["arrivalTimeZ"] = convertToUTC(
          newData[rowIndex][field],
          timeZoneOffset
        );
      } else if (field === "departureTime") {
        newData[rowIndex]["departureTimeZ"] = convertToUTC(
          newData[rowIndex][field],
          timeZoneOffset
        );
      }

      if (field === "arrivalTime" && timeDiff !== 0) {
        const departureField = "departureTime";
        const departureDate = moment(
          newData[rowIndex][departureField], parseFormats, true);
        if (departureDate.isValid()) {
          newData[rowIndex][departureField] = departureDate
            .add(timeDiff, "milliseconds")
            .format(storedFormat);
          newData[rowIndex]["departureTimeZ"] = convertToUTC(
            newData[rowIndex][departureField],
            timeZoneOffset
          );
        }
      }

      if (timeDiff !== 0) {
        for (let i = rowIndex + 1; i < newData.length; i++) {
          const rowTimeZoneOffset =
            newData[i].timeZone || newData[i].timeZoneOffset || "+0";

          ["arrivalTime", "departureTime"].forEach((timeField) => {
            const currentDate = moment(
              newData[i][timeField], parseFormats, true);
            if (currentDate.isValid()) {
              newData[i][timeField] = currentDate
                .add(timeDiff, "milliseconds")
                .format(storedFormat);

              if (timeField === "arrivalTime") {
                newData[i]["arrivalTimeZ"] = convertToUTC(
                  newData[i][timeField],
                  rowTimeZoneOffset
                );
              } else if (timeField === "departureTime") {
                newData[i]["departureTimeZ"] = convertToUTC(
                  newData[i][timeField],
                  rowTimeZoneOffset
                );
              }
            }
          });
        }
      }

      return {
        ...prev,
        cargoList: newData,
      };
    });
  };

  const handleVesselContractInputChange = (e) => {
    const { name, value } = e.target;
    setVesselContractDetails({
      ...vesselContractDetails,
      [name]: value,
    });
  };

  const removeVesselAttachment = (index) => {
    setVesselAttachments((prev) => (Array.isArray(prev) ? prev : []).filter((_, i) => i !== index));
  };

  const handleVesselTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setVesselTextContract(e.target.files[0]);
    }
  };

  const handleVesselContractAttachmentUpload = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        toastError("Some files exceed the 5 MB size limit and were not added.");
      }

      setVesselAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };

  const handleCargoContractInputChange = (e) => {
    const { name, value } = e.target;
    setCargoContractDetails({
      ...cargoContractDetails,
      [name]: value,
    });
  };

  const removeCargoAttachment = (index) => {
    setCargoAttachments((prev) => (Array.isArray(prev) ? prev : []).filter((_, i) => i !== index));
  };

  const handleCargoTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setCargoTextContract(e.target.files[0]);
    }
  };

  const handleCargoContractAttachmentUpload = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        toastError("Some files exceed the 5 MB size limit and were not added.");
      }

      setCargoAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };

  const handleTabChange = (tabIndex) => {
    if (activeTab !== tabIndex && !isAnimating) {
      setPrevTab(activeTab); // Store the old tab index
      setIsAnimating(true);
      setActiveTab(tabIndex);

      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }

      transitionTimeoutRef.current = setTimeout(() => {
        setIsAnimating(false);
        transitionTimeoutRef.current = null;
      }, 300);
    }
  };

  const handleFuelSettlementModeChange = (event) => {
    setFuelSettlementMode(event.target.value);
  };

  const handleOperationStatusChange = (event) => {
    setOperationStatus(event.target.value);
  };

  const calculateRevenue = async () => {
    const cargoOperation = cargoOperationTableData?.cargoList || {};
    const fuelType = cargoOperationTableData.fuelType || "TYPE0";
    const {
      bnkDelhs = 0,
      bnkDells = 0,
      bnkDelmgo = 0,
      bnkPriceDeliveryhs = 0,
      bnkPriceDeliveryls = 0,
      bnkPriceDeliverymgo = 0,
    } = vesselContractDetails.vesselDetails || {};

    const finalData = [];
    const maxLength = cargoOperation.length;

    // First loop - calculate basic revenue data
    for (let i = 0; i < maxLength; i++) {
      const item = cargoOperation[i] || {};
      const operation = cargoOperation[i] || {};
      const { cargoDetails } = item || {};

      const {
        bunkerSuppliedHSFO = null,
        bunkerSuppliedLSFO = null,
        bunkerSuppliedMGO = null,
        paidBy = "Operator",
        reserve = "Reserve",
        fuelPriceType0Hsfo = null,
        fuelPriceType0Lsfo = null,
        fuelPriceType0Mgo = null,
        fuelPriceType1Hsfo = null,
        fuelPriceType1Lsfo = null,
        fuelPriceType1Mgo = null,
        fuelPriceType3Hsfo = null,
        fuelPriceType3Lsfo = null,
        fuelPriceType3Mgo = null,
        fuelPriceType4Hsfo = null,
        fuelPriceType4Lsfo = null,
        fuelPriceType4Mgo = null,
      } = cargoDetails || {};

      // Extract and convert values once
      const freight = Number(item.freight) || 0;
      const adcomRate = Number(item.adcom) || 0;
      const otherRate = Number(item.other) || 0;
      const brokerageRate = Number(item.brokerage) || 0;
      const cargoTx = Number(operation.cargoTx) || 0;

      // Calculate fuel prices based on fuelType
      let hsfo, lsfo, mgo;

      switch (fuelType) {
        case "TYPE0":
          hsfo = fuelPriceType0Hsfo;
          lsfo = fuelPriceType0Lsfo;
          mgo = fuelPriceType0Mgo;
          break;
        case "TYPE1":
          hsfo = i === 0 ? bnkPriceDeliveryhs : fuelPriceType1Hsfo;
          lsfo = i === 0 ? bnkPriceDeliveryls : fuelPriceType1Lsfo;
          mgo = i === 0 ? bnkPriceDeliverymgo : fuelPriceType1Mgo;
          break;
        case "TYPE2":
          hsfo = bunkerSuppliedHSFO;
          lsfo = bunkerSuppliedLSFO;
          mgo = bunkerSuppliedMGO;
          break;
        case "TYPE3":
          hsfo = fuelPriceType3Hsfo;
          lsfo = fuelPriceType3Lsfo;
          mgo = fuelPriceType3Mgo;
          break;
        case "TYPE4":
          hsfo = fuelPriceType4Hsfo;
          lsfo = fuelPriceType4Lsfo;
          mgo = fuelPriceType4Mgo;
          break;
        default:
          hsfo = null;
          lsfo = null;
          mgo = null;
      }

      let fqaHsfo, fqaLsfo, fqaMgo, tsfHsfo, tsfLsfo, tsfMgo, fqaType;

      if (i === 0) {
        fqaHsfo =
          reserve && reserve?.toLowerCase() === "reserve" ? bnkDelhs : 0;
        fqaLsfo =
          reserve && reserve?.toLowerCase() === "reserve" ? bnkDells : 0;
        fqaMgo =
          reserve && reserve?.toLowerCase() === "reserve" ? bnkDelmgo : 0;
        fqaType = paidBy || "Internal";

        tsfHsfo =
          reserve && reserve?.toLowerCase() !== "reserve" ? bnkDelhs : 0;
        tsfLsfo =
          reserve && reserve?.toLowerCase() !== "reserve" ? bnkDells : 0;
        tsfMgo =
          reserve && reserve?.toLowerCase() !== "reserve" ? bnkDelmgo : 0;
      } else {
        fqaHsfo =
          reserve && reserve?.toLowerCase() === "reserve"
            ? bunkerSuppliedHSFO
            : 0;
        fqaLsfo =
          reserve && reserve?.toLowerCase() === "reserve"
            ? bunkerSuppliedLSFO
            : 0;
        fqaMgo =
          reserve && reserve?.toLowerCase() === "reserve"
            ? bunkerSuppliedMGO
            : 0;
        fqaType = paidBy || "Internal";

        tsfLsfo =
          reserve && reserve?.toLowerCase() !== "reserve"
            ? bunkerSuppliedLSFO
            : 0;
        tsfHsfo =
          reserve && reserve?.toLowerCase() !== "reserve"
            ? bunkerSuppliedHSFO
            : 0;
        tsfMgo =
          reserve && reserve?.toLowerCase() !== "reserve"
            ? bunkerSuppliedMGO
            : 0;
      }

      // Calculate rates once
      const totalCommissionRate = adcomRate + otherRate + brokerageRate;
      // Excel: (freight + additional rate) x cargo qty + lumpsum freight
      const grossRevenue =
        (freight + (Number(item.additionalRate) || 0)) * cargoTx +
        (Number(item.lumpsumFreight) || 0);

      // Calculate amounts
      const adcomAmt = grossRevenue * (adcomRate / 100);
      const otherAmt = grossRevenue * (otherRate / 100);
      const brokerageAmt = grossRevenue * (brokerageRate / 100);
      const netFrt = freight * (totalCommissionRate / 100);

      // Sum once
      const netRevenue = grossRevenue - adcomAmt - otherAmt - brokerageAmt;

      finalData.push({
        freight,
        ttlComm: totalCommissionRate,
        netFrt,
        grossRevenue,
        netRevenue,
        adcomAmt,
        otherAmt,
        brokerageAmt,
        hsfo,
        lsfo,
        mgo,
        fqaHsfo,
        fqaLsfo,
        fqaMgo,
        fcaHsfo: fqaHsfo * hsfo,
        fcaLsfo: fqaLsfo * lsfo,
        fcaMgo: fqaMgo * mgo,
        fqaType,
        tsfHsfo,
        tsfLsfo,
        tsfMgo,
        lifoQtyRemainHsfo: 0,
        lifoQtyAppliedHsfo: 0,
        fifoQtyRemainHsfo: 0,
        fifoQtyAppliedHsfo: 0,
        lifoFuelCostHsfo: 0,
        fifoFuelCostHsfo: 0,
        avgFualCostHsfo: 0,
        lifoQtyRemainLsfo: 0,
        lifoQtyAppliedLsfo: 0,
        fifoQtyRemainLsfo: 0,
        fifoQtyAppliedLsfo: 0,
        lifoFuelCostLsfo: 0,
        fifoFuelCostLsfo: 0,
        avgFualCostLsfo: 0,
        lifoQtyRemainMgo: 0,
        lifoQtyAppliedMgo: 0,
        fifoQtyRemainMgo: 0,
        fifoQtyAppliedMgo: 0,
        lifoFuelCostMgo: 0,
        fifoFuelCostMgo: 0,
        avgFualCostMgo: 0,
      });
    }

    // Reusable FIFO calculation function
    function calculateFIFO(finalData, valuesKey, fuelType, tsfField) {
      const qty = Number(values.Actual?.[valuesKey]) || 0;

      for (let i = 0; i < finalData.length; i++) {
        if (i === 0) {
          const firstTsf = finalData[0][tsfField] || 0;
          finalData[i][`fifoQtyRemain${fuelType}`] = Math.max(
            qty - firstTsf,
            0
          );
          finalData[i][`fifoQtyApplied${fuelType}`] = Math.min(qty, firstTsf);
        } else {
          const previousQtyRemain =
            finalData[i - 1][`fifoQtyRemain${fuelType}`] || 0;
          const currentTsf = finalData[i][tsfField] || 0;
          finalData[i][`fifoQtyRemain${fuelType}`] = Math.max(
            previousQtyRemain - currentTsf,
            0
          );
          finalData[i][`fifoQtyApplied${fuelType}`] = Math.min(
            previousQtyRemain,
            currentTsf
          );
        }

        finalData[i][`fifoFuelCost${fuelType}`] =
          (finalData[i][fuelType.toLowerCase()] || 0) *
          finalData[i][`fifoQtyApplied${fuelType}`];
      }
    }

    // Reusable LIFO calculation function
    function calculateLIFO(finalData, valuesKey, fuelType, tsfField) {
      const qty = Number(values.Actual?.[valuesKey]) || 0;

      for (let i = 0; i < finalData.length; i++) {
        const reverseIndex = finalData.length - 1 - i;

        if (i === 0) {
          const lastTsf = finalData[finalData.length - 1][tsfField] || 0;
          finalData[i][`lifoQtyRemain${fuelType}`] = Math.max(qty - lastTsf, 0);
          finalData[i][`lifoQtyApplied${fuelType}`] = Math.min(qty, lastTsf);
        } else {
          const previousQtyRemain =
            finalData[i - 1][`lifoQtyRemain${fuelType}`] || 0;
          const currentTsf = finalData[reverseIndex][tsfField] || 0;
          finalData[i][`lifoQtyRemain${fuelType}`] = Math.max(
            previousQtyRemain - currentTsf,
            0
          );
          finalData[i][`lifoQtyApplied${fuelType}`] = Math.min(
            previousQtyRemain,
            currentTsf
          );
        }

        finalData[i][`lifoFuelCost${fuelType}`] =
          (finalData[reverseIndex][fuelType.toLowerCase()] || 0) *
          finalData[i][`lifoQtyApplied${fuelType}`];
      }
    }

    // Reusable average cost calculation
    function calculateAvgCost(finalData, fuelType, tsfField) {
      for (let i = 0; i < finalData.length; i++) {
        finalData[i][`avgFualCost${fuelType}`] =
          (finalData[i][tsfField] || 0) *
          (finalData[i][fuelType.toLowerCase()] || 0);
      }
    }

    // HSFO calculations
    calculateFIFO(finalData, "hsfoQty", "Hsfo", "tsfHsfo");
    calculateLIFO(finalData, "hsfoQty", "Hsfo", "tsfHsfo");
    calculateAvgCost(finalData, "Hsfo", "tsfHsfo");

    // LSFO calculations
    calculateFIFO(finalData, "lsfoQty", "Lsfo", "tsfLsfo");
    calculateLIFO(finalData, "lsfoQty", "Lsfo", "tsfLsfo");
    calculateAvgCost(finalData, "Lsfo", "tsfLsfo");

    // MGO calculations
    calculateFIFO(finalData, "mgoQty", "Mgo", "tsfMgo");
    calculateLIFO(finalData, "mgoQty", "Mgo", "tsfMgo");
    calculateAvgCost(finalData, "Mgo", "tsfMgo");

    return finalData;
  };

  const calculateExpenses = async () => {
    const {
      hireGbb = 0,
      hirePerDay = 0,
      splitHire = "",
    } = vesselContractDetails?.vesselDetails;
    const { tcAdcom = 0, cargoList = [] } = cargoOperationTableData;
    const splitHireData = splitHire && JSON.parse(splitHire || "");
    const OffhireDuration = values?.Revenue?.hireDuration || 0;
    const result = [];
    let currentDayRemain = OffhireDuration;
    const format = "YYYY-MM-DD HH:mm:ss.S";

    // First loop - existing logic for hire calculations
    for (let i = 0; i < splitHireData?.length; i++) {
      const item = splitHireData[i];
      const NoDays = item.NoDays || 0;
      const hireRate = item.hireRate || 0;
      let DayRemain;
      let DayApplied;
      let Hire;
      if (i === 0) {
        DayRemain = OffhireDuration - NoDays;
        if (OffhireDuration > NoDays) {
          DayApplied = NoDays;
        } else {
          DayApplied = OffhireDuration;
        }
      } else {
        DayRemain = currentDayRemain - NoDays;
        if (currentDayRemain > NoDays) {
          DayApplied = NoDays;
        } else {
          DayApplied = currentDayRemain;
        }
      }
      Hire = hireRate * DayApplied;
      currentDayRemain = DayRemain;
      result.push({
        DayRemain,
        DayApplied,
        Hire,
      });
    }

    const travelData = [];
    let totalTravelConsumption = 0;
    let totalSeaDays = 0;
    let totalHSFO = 0;
    let totalLSFO = 0;
    let totalMGO = 0;
    let totalNormalHS = 0;
    let totalEcaLS = 0;
    let totalStayHSFO = 0;
    let totalStayLSFO = 0;
    let totalStayMGO = 0;

    // New separate totals for Ballast and Laden
    let totalBallastSeaday = 0;
    let totalBallastHSFO = 0;
    let totalBallastLSFO = 0;
    let totalBallastMGO = 0;
    let totalBallastStay = 0;
    let totalBallastStayHSFO = 0;
    let totalBallastStayLSFO = 0;
    let totalBallastStayMGO = 0;
    let totalBallast = 0;
    let totalLaden = 0;
    let totalLadenSeaday = 0;
    let totalLadenHSFO = 0;
    let totalLadenLSFO = 0;
    let totalLadenMGO = 0;
    let totalLadenStay = 0;
    let totalLadenStayHSFO = 0;
    let totalLadenStayLSFO = 0;
    let totalLadenStayMGO = 0;

    if (
      cargoOperationTableData?.cargoList &&
      Array.isArray(cargoOperationTableData?.cargoList)
    ) {
      for (let j = 0; j < cargoOperationTableData?.cargoList?.length - 1; j++) {
        const currentItem = cargoOperationTableData?.cargoList?.[j];
        const nextItem = cargoOperationTableData?.cargoList?.[j + 1] || {};
        const nextCargoDetails = nextItem?.cargoDetails || {};

        const currentTimeZone = Number(currentItem?.timeZone) || 0;
        const currentDepartureTimeLT = currentItem?.departureTime;
        const nextTimeZone = Number(nextItem?.timeZone) || 0;
        const nextArrivalTimeLT = nextItem?.arrivalTime;
        const nextDepartureTimeLT = nextItem?.departureTime;

        const currentDepartureAdjusted = moment(
          currentDepartureTimeLT,
          format
        ).isValid()
          ? moment(currentDepartureTimeLT, format).subtract(
            currentTimeZone,
            "hours"
          )
          : moment.invalid();

        const nextArrivalAdjusted = moment(nextArrivalTimeLT, format).isValid()
          ? moment(nextArrivalTimeLT, format).subtract(nextTimeZone, "hours")
          : moment.invalid();

        const travelDays =
          currentDepartureAdjusted.isValid() && nextArrivalAdjusted.isValid()
            ? nextArrivalAdjusted.diff(currentDepartureAdjusted, "days", true)
            : 0;

        const currentHSFO =
          (Number(currentItem?.departureHsfo) || 0) -
          (Number(nextItem?.arrivalHsfo) || 0);
        const currentLSFO =
          (Number(currentItem?.departureLsfo) || 0) -
          (Number(nextItem?.arrivalLsfo) || 0);
        const currentMGO =
          (Number(currentItem?.departureMgo) || 0) -
          (Number(nextItem?.arrivalMgo) || 0);

        const stayHSFO =
          (Number(nextCargoDetails?.bunkerSuppliedHSFO) || 0) +
          (Number(nextItem?.arrivalHsfo) || 0) -
          (Number(nextItem?.departureHsfo) || 0);

        const stayLSFO =
          (Number(nextCargoDetails?.bunkerSuppliedLSFO) || 0) +
          (Number(nextItem?.arrivalLsfo) || 0) -
          (Number(nextItem?.departureLsfo) || 0);

        const stayMGO =
          (Number(nextCargoDetails?.bunkerSuppliedMGO) || 0) +
          (Number(nextItem?.arrivalMgo) || 0) -
          (Number(nextItem?.departureMgo) || 0);

        const arrival = moment(nextArrivalTimeLT, format, true);
        const departure = moment(nextDepartureTimeLT, format, true);
        let totalStay = 0;

        if (arrival.isValid() && departure.isValid()) {
          totalStay = departure.diff(arrival, "days", true);
          totalStay = Math.max(Number(totalStay.toFixed(3)), 0);
        }

        let normalHS = 0;
        let ecaLS = 0;
        const cargoItem = cargoList?.[j + 1];

        if (cargoItem?.sulfur !== "ECA") {
          normalHS += totalStay;
        } else if (cargoItem?.sulfur === "ECA") {
          ecaLS += totalStay;
        }
        if (cargoItem?.lbmarker?.toLowerCase() === "ballast") {
          totalBallast += travelDays;
        } else {
          totalLaden += travelDays;
        }
        // Determine if this is Ballast or Laden
        const isBallast = cargoItem?.lbmarker?.toLowerCase() === "ballast";

        // Accumulate totals based on Ballast/Laden
        if (isBallast) {
          totalBallastSeaday += travelDays;
          totalBallastHSFO += currentHSFO;
          totalBallastLSFO += currentLSFO;
          totalBallastMGO += currentMGO;
          totalBallastStay += totalStay;
          totalBallastStayHSFO += stayHSFO;
          totalBallastStayLSFO += stayLSFO;
          totalBallastStayMGO += stayMGO;
        } else {
          totalLadenSeaday += travelDays;
          totalLadenHSFO += currentHSFO;
          totalLadenLSFO += currentLSFO;
          totalLadenMGO += currentMGO;
          totalLadenStay += totalStay;
          totalLadenStayHSFO += stayHSFO;
          totalLadenStayLSFO += stayLSFO;
          totalLadenStayMGO += stayMGO;
        }

        travelData.push({
          fromIndex: j,
          toIndex: j + 1,
          port: cargoItem?.port,
          travelDays: Math.max(0, travelDays),
          currentDeparture: currentDepartureAdjusted.isValid()
            ? currentDepartureAdjusted.format(format)
            : "",
          nextArrival: nextArrivalAdjusted.isValid()
            ? nextArrivalAdjusted.format(format)
            : "",
          consumption: Number(currentItem?.consumption) || 0,
          seaDays: Number(currentItem?.seaDays) || 0,
          HSFO: currentHSFO,
          LSFO: currentLSFO,
          MGO: currentMGO,
          stayHSFO,
          stayLSFO,
          stayMGO,
          totalStay,
        });

        totalTravelConsumption += Number(currentItem?.consumption) || 0;
        totalSeaDays += Number(currentItem?.seaDays) || 0;
        totalHSFO += currentHSFO;
        totalLSFO += currentLSFO;
        totalMGO += currentMGO;
        totalNormalHS += normalHS;
        totalEcaLS += ecaLS;
        totalStayHSFO += stayHSFO;
        totalStayLSFO += stayLSFO;
        totalStayMGO += stayMGO;
      }
    }

    const fmt = (num) => Number(Number(num).toFixed(3)) || 0;

    // Calculate base hire values
    const baseHire = fmt(result.reduce((sum, { Hire = 0 }) => sum + Hire, 0));
    const totalGrossHire = fmt(baseHire + hirePerDay * currentDayRemain);

    // Calculate commission values
    const commissionRate = tcAdcom / 100;
    const vesselAdCom = fmt(totalGrossHire * commissionRate);
    const vesselAdComGbb = fmt(hireGbb * commissionRate);

    // Calculate net values
    const brokerage = fmt(4063.277433);
    const netHire = fmt(totalGrossHire - (vesselAdCom + brokerage));
    const netHireGbb = fmt(hireGbb - vesselAdComGbb + 2.5);
    const totalNetHireExpense = fmt(netHire + netHireGbb - totalDeductions);

    // Calculate aggregate values
    const grossHireAmount = fmt(totalGrossHire + hireGbb);
    const adCom = fmt(vesselAdComGbb + vesselAdCom);
    const deduction = fmt(totalDeductions);

    return {
      totalNetHireExpense: fmt(totalNetHireExpense),
      grossHireAmount: fmt(grossHireAmount),
      adCom: fmt(adCom),
      brokerageExp: fmt(0),
      deduction: fmt(deduction),
      totalEcaLS: fmt(totalEcaLS),
      totalNormalHS: fmt(totalNormalHS),
      totalHSFO: fmt(totalHSFO),
      totalLSFO: fmt(totalLSFO),
      totalMGO: fmt(totalMGO),
      travelDetails: travelData,
      totalBallast: fmt(totalBallast),
      totalLaden: fmt(totalLaden),
      // Ballast totals
      totalBallastSeaday: fmt(totalBallastSeaday),
      totalBallastHSFO: fmt(totalBallastHSFO),
      totalBallastLSFO: fmt(totalBallastLSFO),
      totalBallastMGO: fmt(totalBallastMGO),
      totalBallastStay: fmt(totalBallastStay),
      totalBallastStayHSFO: fmt(totalBallastStayHSFO),
      totalBallastStayLSFO: fmt(totalBallastStayLSFO),
      totalBallastStayMGO: fmt(totalBallastStayMGO),

      // Laden totals
      totalLadenSeaday: fmt(totalLadenSeaday),
      totalLadenHSFO: fmt(totalLadenHSFO),
      totalLadenLSFO: fmt(totalLadenLSFO),
      totalLadenMGO: fmt(totalLadenMGO),
      totalLadenStay: fmt(totalLadenStay),
      totalLadenStayHSFO: fmt(totalLadenStayHSFO),
      totalLadenStayLSFO: fmt(totalLadenStayLSFO),
      totalLadenStayMGO: fmt(totalLadenStayMGO),

      // Combined totals
      totalStay: fmt(totalNormalHS + totalEcaLS || 0),
      totalTravelDays: fmt(totalBallastSeaday + totalLadenSeaday || 0),
      totalStayHSFO: fmt(totalStayHSFO),
      totalStayLSFO: fmt(totalStayLSFO),
      totalStayMGO: fmt(totalStayMGO),
    };
  };

  const calculateFuelExpense = async (
    calculatedExpenses,
    calculatedRevenue
  ) => {
    const fmt = (num) => Number(Number(num).toFixed(3));
    const {
      totalStayHSFO = 0,
      totalHSFO = 0,
      totalStayLSFO = 0,
      totalLSFO = 0,
      totalStayMGO = 0,
      totalMGO = 0,
    } = calculatedExpenses;
    let {
      hsfoShortfall,
      lsfoShortfall,
      mgoShortfall,
      hsfoExcess,
      lsfoExcess,
      mgoExcess,
      fuelMethodHsfo = "Average",
      fuelMethodLsfo = "LIFO",
      fuelMethodMgo = "Average",
    } = subModelData.fuelExpenseData;
    // Fuel type calculations
    const fuelTypes = ["Hsfo", "Lsfo", "Mgo"];
    const fuelData = {};

    // Calculate reserves in a single pass
    const reserves = calculatedRevenue.reduce(
      (acc, item) => {
        if (item.fqaType === "Internal") {
          acc.internal.hsfo.qty += item.fqaHsfo || 0;
          acc.internal.lsfo.qty += item.fqaLsfo || 0;
          acc.internal.mgo.qty += item.fqaMgo || 0;
          acc.internal.hsfo.cost += item.fcaHsfo || 0;
          acc.internal.lsfo.cost += item.fcaLsfo || 0;
          acc.internal.mgo.cost += item.fcaMgo || 0;
        } else {
          acc.external.hsfo += item.fqaHsfo || 0;
          acc.external.lsfo += item.fqaLsfo || 0;
          acc.external.mgo += item.fqaMgo || 0;
        }
        return acc;
      },
      {
        internal: {
          hsfo: { qty: 0, cost: 0 },
          lsfo: { qty: 0, cost: 0 },
          mgo: { qty: 0, cost: 0 },
        },
        external: { hsfo: 0, lsfo: 0, mgo: 0 },
      }
    );

    fuelTypes.forEach((fuel) => {
      const lower = fuel.toLowerCase();
      const subFuel = lower === "hsfo" ? "hs" : lower === "lsfo" ? "ls" : "mgo";

      // Trip supply quantities and costs
      fuelData[`tripSupplyQty${fuel}`] = sumProperty(`tsf${fuel}`);
      fuelData[`tripSupplyCost${fuel}`] = sumProperty(`avgFualCost${fuel}`);

      // Average prices
      fuelData[`averagePricePMT${fuel}`] =
        fuelData[`tripSupplyCost${fuel}`] / fuelData[`tripSupplyQty${fuel}`] ||
        0;

      // Voyage consumption
      fuelData[`voyageConsumptionQty${fuel}`] =
        fmt(
          fuel === "Hsfo"
            ? totalStayHSFO + totalHSFO
            : fuel === "Lsfo"
              ? totalStayLSFO + totalLSFO
              : totalStayMGO + totalMGO
        ) || 0;

      // Applied quantity
      fuelData[`appliedQuantity${fuel}`] = Math.min(
        fuelData[`tripSupplyQty${fuel}`],
        fuelData[`voyageConsumptionQty${fuel}`]
      );

      // LIFO and FIFO calculations
      const lifoData = {
        remaining: sumProperty(`lifoQtyRemain${fuel}`),
        applied: sumProperty(`lifoQtyApplied${fuel}`),
        totalCost: sumProperty(`lifoFuelCost${fuel}`),
      };

      const fifoData = {
        remaining: sumProperty(`fifoQtyRemain${fuel}`),
        applied: sumProperty(`fifoQtyApplied${fuel}`),
        totalCost: sumProperty(`fifoFuelCost${fuel}`),
      };

      // Applied costs
      fuelData[`appliedCostLIFO${fuel}`] = fmt(lifoData.totalCost) || 0;
      fuelData[`appliedCostFIFO${fuel}`] = fmt(fifoData.totalCost) || 0;
      fuelData[`appliedCostAverage${fuel}`] =
        fmt(
          fuelData[`averagePricePMT${fuel}`] *
          fuelData[`appliedQuantity${fuel}`]
        ) || 0;

      const method =
        fuel === "Hsfo"
          ? fuelMethodHsfo
          : fuel === "Lsfo"
            ? fuelMethodLsfo
            : fuelMethodMgo;
      fuelData[`selectedAppliedCost${fuel}`] =
        method === "LIFO"
          ? fuelData[`appliedCostLIFO${fuel}`]
          : method === "FIFO"
            ? fuelData[`appliedCostFIFO${fuel}`]
            : fuelData[`appliedCostAverage${fuel}`];
      fuelData[`shortageQty${fuel}`] =
        fmt(
          fuelData[`tripSupplyQty${fuel}`] -
            fuelData[`voyageConsumptionQty${fuel}`] <
            0
            ? fuelData[`voyageConsumptionQty${fuel}`] -
            fuelData[`tripSupplyQty${fuel}`]
            : 0
        ) || 0;
      fuelData[`excessQty${fuel}`] =
        fmt(
          fuelData[`tripSupplyQty${fuel}`] -
          fuelData[`voyageConsumptionQty${fuel}`]
        ) || 0;

      fuelData[`redeliveryShortagePriceQty${fuel}`] =
        fuelData[`shortageQty${fuel}`] <
          vesselContractDetails.vesselDetails[
          `bnkRedeliveryQtyTolerance${subFuel}`
          ] || 0
          ? fuelData[`shortageQty${fuel}`] || 0
          : vesselContractDetails.vesselDetails[
          `bnkRedeliveryQtyTolerance${subFuel}`
          ] || 0;

      fuelData[`settlementShortagePriceQty${fuel}`] =
        fmt(
          fuelData[`shortageQty${fuel}`] -
          fuelData[`redeliveryShortagePriceQty${fuel}`]
        ) || 0;

      fuelData[`withIntoleranceShortageCost${fuel}`] =
        fmt(
          fuelData[`redeliveryShortagePriceQty${fuel}`] *
          vesselContractDetails.vesselDetails[`bnkPriceRedelivery${subFuel}`]
        ) || 0;

      fuelData[`outSidetoleranceShortageCost${fuel}`] =
        fmt(
          fuelData[`settlementShortagePriceQty${fuel}`] *
          vesselContractDetails.vesselDetails[`bnkPriceSettlement${subFuel}`]
        ) || 0;

      fuelData[`redeliveryExcessPriceQty${fuel}`] =
        fuelData[`excessQty${fuel}`] <
          vesselContractDetails.vesselDetails[
          `bnkRedeliveryQtyTolerance${subFuel}`
          ] || 0
          ? fuelData[`excessQty${fuel}`] || 0
          : vesselContractDetails.vesselDetails[
          `bnkRedeliveryQtyTolerance${subFuel}`
          ] || 0;

      const shortfallRate =
        fuel === "Hsfo"
          ? hsfoShortfall
          : fuel === "Lsfo"
            ? lsfoShortfall
            : mgoShortfall;

      fuelData[`settlementExcessPriceQty${fuel}`] =
        fmt(
          fuelData[`excessQty${fuel}`] -
          fuelData[`redeliveryExcessPriceQty${fuel}`]
        ) || 0;

      fuelData[`withIntoleranceExcessRevenue${fuel}`] =
        fmt(
          fuelData[`redeliveryExcessPriceQty${fuel}`] *
          vesselContractDetails.vesselDetails[`bnkPriceRedelivery${subFuel}`]
        ) || 0;

      fuelData[`outSidetoleranceExcessRevenue${fuel}`] =
        fmt(
          fuelData[`settlementExcessPriceQty${fuel}`] *
          vesselContractDetails.vesselDetails[`bnkPriceSettlement${subFuel}`]
        ) || 0;

      fuelData[`costExcess${fuel}`] =
        fmt(
          fuelData[`tripSupplyCost${fuel}`] -
          fuelData[`selectedAppliedCost${fuel}`]
        ) || 0;

      fuelData[`expenditureforShortage${fuel}`] = shortfallRate
        ? fmt(shortfallRate * fuelData[`shortageQty${fuel}`])
        : 0;

      fuelData[`voyagePricePMT${fuel}`] =
        fmt(
          fuelData[`voyageFuelExpenditure${fuel}`] /
          fuelData[`voyageConsumptionQty${fuel}`]
        ) || 0;

      fuelData[`excessCost${fuel}`] =
        fmt(
          fuelData[`tripSupplyQty${fuel}`] -
          fuelData[`selectedAppliedCost${fuel}`]
        ) || 0;

      const excessRate =
        fuel === "Hsfo" ? hsfoExcess : fuel === "Lsfo" ? lsfoExcess : mgoExcess;
      fuelData[`revenueExcess${fuel}`] =
        fmt(excessRate * fuelData[`excessQty${fuel}`]) || 0;

      const reserveInternal = reserves.internal[lower];
      fuelData[`qtyBalanceOnboard${fuel}`] =
        fmt(
          reserveInternal.cost +
          fuelData[`tripSupplyQty${fuel}`] -
          fuelData[`voyageConsumptionQty${fuel}`]
        ) || 0;

      fuelData[`voyageFuelExpenditure${fuel}`] =
        fuelSettlementMode === "relay"
          ? fmt(
            fuelData[`selectedAppliedCost${fuel}`] +
            fuelData[`expenditureforShortage${fuel}`]
          )
          : fmt(
            fuelData[`selectedAppliedCost${fuel}`] +
            fuelData[`withIntoleranceShortageCost${fuel}`] -
            fuelData[`outSidetoleranceShortageCost${fuel}`]
          );

      fuelData[`fuelSettlementProfit${fuel}`] =
        fuelSettlementMode === "relay"
          ? fmt(
            fuelData[`revenueExcess${fuel}`] - fuelData[`excessCost${fuel}`]
          )
          : fmt(
            fuelData[`withIntoleranceExcessRevenue${fuel}`] +
            fuelData[`outSidetoleranceExcessRevenue${fuel}`] -
            fuelData[`costExcess${fuel}`]
          );

      const deliveryCalc =
        fuel === "Lsfo"
          ? reserveInternal.cost -
          reserveInternal.cost +
          fuelData[`revenueExcess${fuel}`]
          : reserveInternal.cost -
          fuelData[`expenditureforShortage${fuel}`] +
          fuelData[`revenueExcess${fuel}`];
      fuelData[`deliveryPrices${fuel}`] =
        fmt(deliveryCalc / fuelData[`qtyBalanceOnboard${fuel}`]) || 0;
    });

    const updateData = {
      reserveExternalQtyHsfo: reserves?.external?.hsfo || 0,
      reserveExternalQtyLsfo: reserves?.external?.lsfo || 0,
      reserveExternalQtyMgo: reserves?.external?.mgo || 0,
      reserveInternalQtyHsfo: reserves?.internal?.hsfo?.qty || 0,
      reserveInternalQtyLsfo: reserves?.internal?.lsfo?.qty || 0,
      reserveInternalQtyMgo: reserves?.internal?.mgo?.qty || 0,
      reserveInternalCostHsfo: reserves?.internal?.hsfo?.cost || 0,
      reserveInternalCostLsfo: reserves?.internal?.lsfo?.cost || 0,
      reserveInternalCostMgo: reserves?.internal?.mgo?.cost || 0,
      fuelMethodHsfo,
      fuelMethodLsfo,
      fuelMethodMgo,
    };

    // Helper function to sum a property across all items
    function sumProperty(property) {
      if (!calculatedRevenue || !Array.isArray(calculatedRevenue)) {
        return 0;
      }
      return calculatedRevenue?.reduce(
        (sum, item) => sum + (Number(item[property]) || 0),
        0
      );
    }

    Object.entries(fuelData).forEach(([key, value]) => {
      updateData[key] = fmt(value);
    });
    return { fuelData, updateData };
  };

  const handleUpdateMainTable = async (
    calculatedExpenses,
    calculatedRevenue,
    fuelData,
    updateData
  ) => {
    if (!calculatedRevenue.length) return;
    const fmt = (num) => Number(Number(num).toFixed(3));
    const keyMap = {
      grossFreight: "grossRevenue",
      charterersAdcom: "adcomAmt",
      brokerage: "brokerageAmt",
      taxesOthers: "otherAmt",
      netFreightRevenue: "netRevenue",
    };

    const {
      adCom = 0,
      grossHireAmount = 0,
      deduction = 0,
      brokerageExp = 0,
      totalNetHireExpense = 0,
      totalTravelDays = 0,
      totalStay = 0,
      totalLaden = 0,
      totalBallast = 0,
      totalStayHSFO = 0,
      totalHSFO = 0,
      totalStayLSFO = 0,
      totalLSFO = 0,
      totalStayMGO = 0,
      totalMGO = 0,
    } = calculatedExpenses;
    const { extraExpense } = vesselContractDetails.vesselDetails;

    const totalPortExpt = cargoOperationTableData?.cargoList?.reduce(
      (sum, item) => {
        return sum + (Number(item.portExp) || 0);
      },
      0
    );

    const revenueUpdates = Object.entries(keyMap).reduce(
      (acc, [targetKey, sourceKey]) => {
        const total = calculatedRevenue.reduce(
          (sum, item) => sum + (item[sourceKey] || 0),
          0
        );
        acc[targetKey] = Math.round(total * 100) / 100;
        return acc;
      },
      {}
    );

    const totalTripDuration = totalTravelDays + totalStay;
    const nonCveDailyExp =
      Number(subModelData?.expenses?.insurancePerDay || 0) ||
      Math.max(
        0,
        Number(subModelData?.expenses?.expensesPerDay || 0) -
        Number(subModelData?.expenses?.cvePerDay || 0)
      );
    const otherExp =
      Number(totalMiscExpenses || 0) +
      Number(nonCveDailyExp || 0) * Number(totalTripDuration || 0);
    const hireDuration = totalTripDuration - totalOffHireDuration;
    const cve = subModelData.expenses.cvePerDay * hireDuration || 0;

    const totalFuelExpenses = fmt(
      fuelData?.voyageFuelExpenditureHsfo +
      fuelData?.voyageFuelExpenditureLsfo +
      fuelData?.voyageFuelExpenditureMgo
    );
    const fuelSettlementProfitTotal = fmt(
      fuelData?.fuelSettlementProfitHsfo +
      fuelData?.fuelSettlementProfitLsfo +
      fuelData?.fuelSettlementProfitMgo
    );

    let { netFreightRevenue, ...rest } = revenueUpdates;
    netFreightRevenue = fmt(netFreightRevenue + Number(values.Actual.laytime));

    const totalNonHireExp =
      cve +
      totalPortExpt +
      otherExp +
      totalFuelExpenses +
      extraExpense -
      fuelSettlementProfitTotal;
    const totalTripExp = fmt(totalNetHireExpense + totalNonHireExp);
    const netProfit = fmt(netFreightRevenue - totalTripExp);
    const revAvailableTC = fmt(netFreightRevenue - totalNonHireExp);
    const tceNet = fmt(revAvailableTC / totalTripDuration);
    setSubModelData((prev) => ({
      ...prev,
      fuelExpenseData: {
        ...prev.fuelExpenseData,
        ...updateData,
      },
    }));
    setValues((prev) => ({
      ...prev,
      Actual: {
        ...prev.Actual,
        ...Object.fromEntries(
          Object.entries(rest).map(([key, value]) => [key, fmt(value)])
        ),
        netFreightRevenue: fmt(netFreightRevenue) || 0,
        additional: fmt(additionalRevenue) || 0,
        cve: fmt(cve) || 0,
        grossHireAmount: fmt(grossHireAmount) || 0,
        adCom: fmt(adCom) || 0,
        deduction: fmt(deduction) || 0,
        brokerageExp: fmt(brokerageExp) || 0,
        totalNetHireExpense: fmt(totalNetHireExpense) || 0,
        OffhireDuration: fmt(totalOffHireDuration) || 0,
        portExpenses: fmt(totalPortExpt) || 0,
        hireDuration: fmt(hireDuration) || 0,
        tceNet: fmt(tceNet) || 0,
        netProfit: fmt(netProfit) || 0,
        totalTripDuration: fmt(totalTripDuration) || 0,
        MainFuelExpHSFO: fmt(fuelData?.voyageFuelExpenditureHsfo || 0),
        ECAFuelExpLSFO: fmt(fuelData?.voyageFuelExpenditureLsfo || 0),
        lightFuelExpMGO: fmt(fuelData?.voyageFuelExpenditureMgo || 0),
        fuelSettlementProfitHSFO: fmt(fuelData?.fuelSettlementProfitHsfo || 0),
        fuelSettlementProfitLSFO: fmt(fuelData?.fuelSettlementProfitLsfo || 0),
        fuelSettlementProfitMGO: fmt(fuelData?.fuelSettlementProfitMgo || 0),
        totalTripExp: fmt(totalTripExp) || 0,
        otherExp: fmt(otherExp) || 0,
        totalFuelExpenses: fmt(totalFuelExpenses) || 0,
        fuelSettlementProfitTotal: fmt(fuelSettlementProfitTotal) || 0,
        ballastPassage: fmt(totalBallast) || 0,
        ladenPassage: fmt(totalLaden) || 0,
        portStayTotal: fmt(totalStay) || 0,
        hsfoQty: fmt(totalStayHSFO + totalHSFO) || 0,
        lsfoQty: fmt(totalStayLSFO + totalLSFO) || 0,
        mgoQty: fmt(totalStayMGO + totalMGO) || 0,
      },
    }));
  };

  // Create a memoized calculation function that combines all three calculations
  const calculateAll = useCallback(async () => {
    try {
      setLoader(true, "Calculating operation data...");
      const revenueData = await calculateRevenue();
      const expenseData = await calculateExpenses();
      setCalculatedExpenses(expenseData);
      const { fuelData, updateData } = await calculateFuelExpense(
        expenseData,
        revenueData
      );
      handleUpdateMainTable(expenseData, revenueData, fuelData, updateData);
    } catch (error) {
      console.error("Error calculating all data:", error);
    } finally {
      setLoader(false);
    }
  }, [
    cargoOperationTableData,
    vesselContractDetails,
    offHireDeductions,
    fuelDeductions,
    fuelSettlementMode,
    additionalRevenue,
    values.Actual.laytime,
    subModelData?.expenses,
    reCalculate,
  ]);

  useEffect(() => {
    if (
      JSON.stringify(values.Actual) !== JSON.stringify(unchangedValues.current)
    ) {
      isChanged.current = true;
    } else {
      isChanged.current = false;
    }
  }, [values.Actual]);

  const debouncedHandleUpdateMainTable = useMemo(
    () => debounce(calculateAll, 1500),
    [calculateAll]
  );

  useEffect(() => {
    debouncedHandleUpdateMainTable();
    return () => debouncedHandleUpdateMainTable.cancel();
  }, [debouncedHandleUpdateMainTable]);

  const hireExpenseInitializeCalculations = () => {
    // Initialize Off Hire Deductions
    const initializedOffHire = offHireDeductions.map((item) => {
      const format = "DD-MM-YYYY HH:mm";
      const updatedItem = { ...item };

      const from = updatedItem.from;
      const to = updatedItem.to;
      const fromTz = parseFloat(updatedItem.fromTz) || 0;
      const toTz = parseFloat(updatedItem.toTz) || 0;
      const deductionPercent = parseFloat(updatedItem.offHireDeducation) || 0;
      const hireRate = parseFloat(updatedItem.hireRate) || 0;

      // Validate both dates before calculation
      const isValidFrom = moment(from, format, true).isValid();
      const isValidTo = moment(to, format, true).isValid();

      if (isValidFrom && isValidTo) {
        const currentDepartureAdjusted = moment(from, format).subtract(
          fromTz,
          "hours"
        );
        const nextArrivalAdjusted = moment(to, format).subtract(toTz, "hours");

        const duration = nextArrivalAdjusted.diff(
          currentDepartureAdjusted,
          "days",
          true
        );
        updatedItem.duration = duration;

        if (!isNaN(deductionPercent)) {
          const commissionRate = deductionPercent / 100;
          updatedItem.netDaysDedn = parseFloat(
            (duration * commissionRate).toFixed(6)
          );
        }

        if (!isNaN(hireRate)) {
          const grossHireReversal = duration * hireRate;
          const vesselAdcomReversal = grossHireReversal * 0.0375;
          const brokerageReversal = grossHireReversal * 0.0125;
          const amount =
            grossHireReversal - vesselAdcomReversal - brokerageReversal;

          updatedItem.grossHireReversal = grossHireReversal;
          updatedItem.vesselAdcomReversal = vesselAdcomReversal;
          updatedItem.brokerageReversal = brokerageReversal;
          updatedItem.amount = amount;
        }
      }

      return updatedItem;
    });

    // Initialize Fuel Deductions
    const initializedFuel = fuelDeductions.map((item) => {
      const updatedItem = { ...item };
      const deductionPercent = parseFloat(updatedItem.fuelDeducation) || 0;
      const commissionRate = deductionPercent / 100;

      // Set initial price based on fuel grade
      if (updatedItem.fuelGrade === "Main") {
        updatedItem.price =
          parseFloat(
            vesselContractDetails?.vesselDetails?.bnkPriceDeliveryhs
          ) || 0;
      } else if (updatedItem.fuelGrade === "ECA") {
        updatedItem.price =
          parseFloat(
            vesselContractDetails?.vesselDetails?.bnkPriceDeliveryls
          ) || 0;
      } else if (updatedItem.fuelGrade === "MGO") {
        updatedItem.price =
          parseFloat(
            vesselContractDetails?.vesselDetails?.bnkPriceDeliverymgo
          ) || 0;
      }

      // Calculate initial amount
      const quantity = parseFloat(updatedItem.quantity) || 0;
      const price = parseFloat(updatedItem.price) || 0;
      updatedItem.amount = parseFloat(
        (quantity * price * commissionRate).toFixed(3)
      );

      return updatedItem;
    });

    // Update state with initialized data
    setOffHireDeductions(initializedOffHire);
    setFuelDeductions(initializedFuel);
  };

  useEffect(() => {
    if (
      vesselContractDetails?.vesselDetails &&
      offHireDeductions.length > 0 &&
      fuelDeductions.length > 0
    ) {
      hireExpenseInitializeCalculations();
    }
  }, [
    vesselContractDetails?.vesselDetails,
    splitHireModal,
    offHireDeductions.length,
    fuelDeductions.length,
  ]);

  const handleButtonClick = (action) => {
    switch (action) {
      case "vesselContract":
        setEditVesselContractModelOpen(true);
        break;
      case "cargoContract":
        setEditCargoContractModelOpen(true);
        break;
      case "offHire":
        setSplitHireModal(true);
        break;
      case "optimumSpeed":
        setOptimumSpeedModelOpen(true);
        break;
      case "laytimeSettlements":
        setIsLaytimeSettlementsModelOpen(true);
        break;
      case "invoices":
        setIsFinalInvoiceModelOpen(true);
        break;
      case "fuelSupplyRequest":
        setIsFuelSupplyRequestModelOpen(true);
        break;
      case "fuelExpensesReconciliation":
        setOpenFuelExpenseModel(true);
        break;
      case "sustainability":
        setOpenSustainabilityModel(true);
        break;
      default:
    }
  };

  const handleSetIntialStatementOfFactsDetails = (
    selectedOperation,
    selectedIndex
  ) => {
    const vessel = JSON.parse(
      vesselContractDetails?.vesselDetails?.vessel || "{}"
    );

    // Initialize statementOfFacts if it doesn't exist (vessel data is already in cargoList item)
    setCargoOperationTableData((prev) => {
      const newState = { ...prev };
      const updatedCargoList = [...newState.cargoList]; // Direct access to cargoList
      const currentItem = { ...updatedCargoList[selectedIndex] };

      // Initialize statementOfFacts if it doesn't exist (only non-vessel data)
      if (!currentItem.statementOfFacts) {
        currentItem.statementOfFacts = {
          sof_authors: [
            {
              id: 1,
              name: "",
              designation: "",
              details: "",
            },
          ],
          userFields: [
            { label: "User Defined Fields 1", value: 0 },
            { label: "User Defined Fields 2", value: 1 },
          ],
          events: [{ day: "", time: "", event: "" }],
          remarks: {
            general: [""],
            shippers: [""],
            shipOwners: [""],
          },
        };
      }

      // Update vessel data directly on the cargo item (not in statementOfFacts)
      currentItem.vesselName =
        vessel?.vesselLabel || currentItem.vesselName || "";
      currentItem.grade = selectedOperation?.grade || currentItem.grade || "";
      currentItem.billOfLadingDate =
        selectedOperation?.billOfLadingDate ||
        currentItem.billOfLadingDate ||
        "";
      currentItem.port = selectedOperation?.port || currentItem.port || "";
      currentItem.operation =
        selectedOperation?.operation || currentItem.operation || "";
      currentItem.cargoQty =
        selectedOperation?.cargoQty || currentItem.cargoQty || "";
      currentItem.timeZone =
        selectedOperation?.timeZone || currentItem.timeZone || "";
      // Initialize other vessel fields if they don't exist
      currentItem.voyageNo = currentItem.voyageNo || "";
      currentItem.charterer = currentItem.charterer || "";
      currentItem.shipmentId = currentItem.shipmentId || "";

      updatedCargoList[selectedIndex] = currentItem;

      return {
        ...newState,
        cargoList: updatedCargoList, // Direct update to cargoList
      };
    });

    setIsStatementOfFactsModelOpen(true);
  };

  const handleSetIntialLaytimeStatementDetails = (
    selectedOperation,
    selectedIndex
  ) => {
    const vessel = JSON.parse(
      vesselContractDetails?.vesselDetails?.vessel || "{}"
    );

    setCargoOperationTableData((prev) => {
      const newState = { ...prev };
      const updatedCargoList = [...newState.cargoList];
      const currentItem = { ...updatedCargoList[selectedIndex] };

      // Initialize laytimeStatement if it doesn't exist
      if (!currentItem.laytimeStatement) {
        currentItem.laytimeStatement = {
          cargoDesc: "",
          dischargingRate: 0,
          dischargingTerms: 0,
          turnTimeAllowed: 0,
          turnTimeClause: 0,
          demurrageRate: 0,
          despatchRate: 0,
          totalTimeAllowed: 0,
          norTendered: "",
          norTerms: "Discharging",
          laytimeStarts: "",
          commencedDischarging: "",
          completedDischarging: "",
          laytimeStops: "",
          vesselOnDemurrage: "",
          eventTable: [
            {
              id: 1,
              fromTime: null,
              fromDay: "",
              toTime: null,
              toDay: "",
              event: "",
              timeDuration: 0,
              percentTimeToCount: 0,
              timeUsed: 0,
              cumulatedTimeUsed: 0,
              comments: "",
            },
          ],
        };
      }

      // Update vessel data
      currentItem.vesselName =
        vessel?.vesselLabel || currentItem.vesselName || "";
      currentItem.grade = selectedOperation?.grade || currentItem.grade || "";
      currentItem.billOfLadingDate =
        selectedOperation?.billOfLadingDate ||
        currentItem.billOfLadingDate ||
        "";
      currentItem.port = selectedOperation?.port || currentItem.port || "";
      currentItem.operation =
        selectedOperation?.operation || currentItem.operation || "";
      currentItem.cargoQty =
        selectedOperation?.cargoQty || currentItem.cargoQty || "";
      currentItem.arrivalTime =
        selectedOperation?.arrivalTime || currentItem.arrivalTime || "";
      currentItem.departureTime =
        selectedOperation?.departureTime || currentItem.departureTime || "";

      // Initialize other fields if they don't exist
      currentItem.voyageNo = currentItem.voyageNo || "";
      currentItem.charterer = currentItem.charterer || "";
      currentItem.shipmentId = currentItem.shipmentId || "";

      updatedCargoList[selectedIndex] = currentItem;
      return { ...newState, cargoList: updatedCargoList };
    });

    setIsLaytimesModelOpen(true);
  };

  const getCurrentStatementOfFactsRowData = (cargoItem) => {
    const { _id, id, ...cleanSof } = cargoItem?.statementOfFacts || {};
    return {
      vesselData: {
        vesselName: cargoItem?.vesselName || "",
        grade: cargoItem?.grade || "",
        billOfLadingDate: cargoItem?.billOfLadingDate || "",
        voyageNo: vesselContractDetails?.voyageNumber || "",
        charterer: cargoItem?.charterer || "",
        port: cargoItem?.port || "",
        operation: cargoItem?.operation || "",
        cargoQty: cargoItem?.cargoQty || "",
        shipmentId: cargoContractDetails?.shipmentNumber || "",
        timeZone: cargoItem?.timeZone || "",
      },
      ...cleanSof,
    };
  };

  const getCurrentLaytimeStatementRowData = (cargoItem) => {
    const { _id, id, ...cleanLaytime } = cargoItem?.laytimeStatement || {};
    return {
      vesselName: cargoItem?.vesselName || "",
      grade: cargoItem?.grade || "",
      billOfLadingDate: cargoItem?.billOfLadingDate || "",
      voyageNo: vesselContractDetails?.voyageNumber || "",
      charterer: cargoItem?.charterer || "",
      port: cargoItem?.port || "",
      operation: cargoItem?.operation || "",
      cargoQty: cargoItem?.cargoQty || "",
      shipmentId: cargoContractDetails?.shipmentNumber || "",
      arrivalTime: cargoItem?.arrivalTime || "",
      departureTime: cargoItem?.departureTime || "",
      ...cleanLaytime,
    };
  };

  const handleCargoOperationSubModels = (index, row, key) => {
    setSelectedOperationIndex(index);
    switch (key) {
      case "laytimes":
        handleSetIntialLaytimeStatementDetails(row, index);
        break;
      case "statementOfFacts":
        handleSetIntialStatementOfFactsDetails(row, index);
        break;
      case "issueInvoice":
        handleSetIntialIssueInvoiceDetails(row, index);
        break;
      default:
    }
  };

  const handleSetIntialIssueInvoiceDetails = (row, index) => {
    setOpenedFromPortSelect(false);
    if (freightMode?.toLowerCase() !== "single freight") {
      setSelectedCargoIndex(index);
    } else {
      const cargoDetails = cargoOperationTableData?.cargoList?.filter(
        (item) => item.operation?.toLowerCase() === "loading"
      );
      setSelectedCargoIndex(index);
    }
    setIsIssueInvoiceModelOpen(true);
  };

  const handleUpdateVesselContract = () => {
    const { vesselContractId, ...payload } = vesselContractDetails;
    const formPayload = new FormData();

    if (vesselTextContract) {
      const fileType = vesselTextContract.type || "application/octet-stream";
      const fileName = vesselTextContract.name || "contract";

      const textBlob = new Blob([vesselTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    // Append attachments if available
    if (vesselAttachments?.length) {
      vesselAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    // Append form data
    formPayload.append(
      "data",
      JSON.stringify({
        ...payload,
        isOpsContract: true,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
      })
    );

    updateVesselContract({ _id: vesselContractId }, formPayload)
      .then(() => {
        setEditVesselContractModelOpen(false);
        setVesselAttachments([]);
        setVesselTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        fetchOperation();
        toastSuccess("Vessel Contract Updated successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const handleUpdateCargoContract = () => {
    const { cargoContractId, actualCargoContract, operationCargoContract, ...payload } = cargoContractDetails;
    const cpDate = payload.cpDate || payload.contractDate || payload.cp_date || moment().format("YYYY-MM-DD");
    const formPayload = new FormData();

    if (cargoTextContract) {
      const fileType = cargoTextContract.type || "application/octet-stream";
      const fileName = cargoTextContract.name || "contract";

      const textBlob = new Blob([cargoTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    if (cargoAttachments?.length) {
      cargoAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    formPayload.append(
      "data",
      JSON.stringify({
        ...payload,
        cpDate,
        isOpsContract: true,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
      })
    );

    updateCargoContract({ _id: cargoContractId || id }, formPayload)
      .then(() => {
        setEditCargoContractModelOpen(false);
        setCargoAttachments([]);
        setCargoTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        fetchOperation();
        toastSuccess("Cargo Contract Updated successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const handleSubmit = async (updatedCargoOperationTableData) => {
    try {
      setLoader(true, "Saving data...");
      isSaved.current = true;
      reCalculate.current = true;
      const { actualCargoContract, operationCargoContract, ...rest } =
        cargoContractDetails;
      const { actualVesselContract, operationVesselContract, ...restVessel } =
        vesselContractDetails;
      const cargoContract = {
        ...rest,
        cargoDetails: updatedCargoOperationTableData || cargoOperationTableData,
        cargoInvoices,
        laytimeSettlementDetails: finalState,
      };
      const payload = {
        cargoContract,
        vesselContractDetails: {
          ...restVessel,
          vesselInvoiceDetails: expenseInvoices,
        },
        calculatedExpenses,
        subModelCalculation: subModelData,
        fuelSettlementMode,
        operationStatus,
        sustainabilityData,
        actualCalculation: values.Actual,
        vesselCargoDetailsTableData,
      };
      await calculateOperation({ id }, payload);
      await fetchOperation();
      setWarning({});
      reCalculate.current = false;
      !updatedCargoOperationTableData &&
        toastSuccess("Operation calculation saved successfully");
    } catch (error) {
      toastError("Failed to calculate operation");
    } finally {
      setLoader(false);
    }
  };

  const handleChangeSubMenu = (section, field, value) => {
    setSubModelData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleNestedChange = (section, subsection, field, value) => {
    setSubModelData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [subsection]: {
          ...prev[section][subsection],
          [field]: value,
        },
      },
    }));
  };
  const handleSubModels = (action) => {
    switch (action) {
      case "additional":
        setOpenAdditionalRevenueModel(true);
        break;
      case "otherExp":
        setOpenOtherExpModel(true);
        break;
      case "totalFuelExpenses":
        setOpenFuelExpenseModel(true);
        break;
      default:
    }
  };

  // render ui
  const renderCompactInput = (value, onChange, endAdornment = null, forceDisabled = false) => (
    <div className="flex items-center overflow-hidden">
      <TextField
        type="number"
        size="small"
        className="text-xs w-full border bg-[#f6f8ff] border-gray-300 rounded"
        variant="outlined"
        margin="none"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        fullWidth
        disabled={isReadOnly || forceDisabled}
        InputProps={{
          style: { fontSize: "0.775rem", height: "25px" },
          classes: {
            root: "px-1",
            input: "px-[0.5px]",
          },
        }}
      />
      {endAdornment && <span className="text-xs p-1">{endAdornment}</span>}
    </div>
  );
  // useEffects
  useEffect(() => {
    return () => {
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
    };
  }, []);

  const initializSettledAmt = async () => {
    try {
      setLoader(true, "Fetching settled amounts...");
      const { data } = await getPostedInvoiceByUserId(id);
      if (!data || !Array.isArray(data)) return [];

      const labelKeyMap = {
        "Base Rate": "grossFreight",
        Demurrage: "laytime",
        Despatch: "laytime",
        "Lumpsum Charges": "additional",
        "Adcom (%)": "charterersAdcom",
        "Others (%)": "taxesOthers",
        "Brokerage (%)": "brokerage",
      };

      const allInvoiceDetails = data.flatMap((inv) =>
        (inv.invoiceDetail || []).map((detail) => ({
          ...detail,
          postedAt: inv.postedAt || null, // attach parent postedAt
        }))
      );

      // Group by label/key
      const grouped = allInvoiceDetails.reduce((acc, item) => {
        const label = item?.invoiceDetail?.label || item.label;
        const itemKey = item?.key || label;

        if (!label && !itemKey) return acc;

        const groupKey = itemKey;

        if (!acc[groupKey]) {
          acc[groupKey] = {
            label: label || "",
            key: itemKey || null,
            paymentEntries: [],
            totalSettledAmt: 0,
          };
        }

        if (Array.isArray(item.paymentEntries)) {
          const counterParty =
            item?.invoiceDetail?.counterParty || item.invoiceDetail?.name || null;
          const postedAt = item?.postedAt || null;
          const counterPartyId = item?.invoiceDetail?.counterPartyId || null;

          // attach counterParty info to each entry
          const enrichedEntries = item.paymentEntries.map((entry) => ({
            ...entry,
            counterParty,
            counterPartyId,
            postedAt,
          }));

          acc[groupKey].paymentEntries.push(...enrichedEntries);
        }

        acc[groupKey].totalSettledAmt = Number((acc[groupKey].totalSettledAmt + Number(item.totalSettledAmt || 0)).toFixed(3));

        return acc;
      }, {});

      const groupedResult = Object.values(grouped);

      const fieldMappings = [
        ...revenueFields,
        ...expensesFields,
        ...profitFileds,
      ];

      const settledData = {};

      fieldMappings.forEach((field) => {
        // 1️⃣ Check if any groupedResult.label is in labelKeyMap and maps to field.key
        let found = groupedResult.find(
          (item) => labelKeyMap[item.label] === field.key
        );

        // 2️⃣ Fallback: partial match with field.label (case-insensitive)
        if (!found) {
          found = groupedResult.find((item) =>
            item.label?.toLowerCase().includes(field.label.toLowerCase())
          );
        }

        // 3️⃣ Fallback: match groupedResult.key with field.key
        if (!found) {
          found = groupedResult.find((item) => item.key === field.key);
        }

        // 4️⃣ Default: empty
        settledData[field.key] = found
          ? {
            paymentEntries: found.paymentEntries,
            totalSettledAmt: Number(Number(found.totalSettledAmt || 0).toFixed(3)),
            key: found.key,
          }
          : {
            paymentEntries: [],
            totalSettledAmt: 0,
            key: null,
          };
      });

      setValues((prev) => ({
        ...prev,
        Settled: settledData,
      }));
    } catch (error) {
      console.error("Error initializing settled amounts:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    initializSettledAmt();
  }, []);

  const getNextMiscExpLabel = (list) => {
    const usedNums = new Set();
    (list || []).forEach((item) => {
      if (item && typeof item.label === "string") {
        const matches = item.label.match(/\d+/g);
        if (matches) {
          matches.forEach((m) => {
            const val = parseInt(m, 10);
            if (!isNaN(val) && val > 0 && val < 1000) {
              usedNums.add(val);
            }
          });
        }
      }
    });
    let n = 1;
    while (usedNums.has(n)) {
      n++;
    }
    return `Misc Exp-${n}`;
  };

  const getNextMiscRevLabel = (list) => {
    const usedNums = new Set();
    (list || []).forEach((item) => {
      if (item && typeof item.label === "string") {
        const matches = item.label.match(/\d+/g);
        if (matches) {
          matches.forEach((m) => {
            const val = parseInt(m, 10);
            if (!isNaN(val) && val > 0 && val < 1000) {
              usedNums.add(val);
            }
          });
        }
      }
    });
    let n = 1;
    while (usedNums.has(n)) {
      n++;
    }
    return `Misc ${n}`;
  };

  const handleAddMiscExpense = () => {
    setSubModelData((prev) => {
      const list = prev.expenses.miscExp || [];
      const newLabel = getNextMiscExpLabel(list);
      const newExpense = {
        id: `misc_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
        label: newLabel,
        amount: 0,
      };

      return {
        ...prev,
        expenses: {
          ...prev.expenses,
          miscExp: [...list, newExpense],
        },
      };
    });
  };

  const handleRenameMiscExpense = (index, newLabel) => {
    setSubModelData((prev) => ({
      ...prev,
      expenses: {
        ...prev.expenses,
        miscExp: (prev.expenses.miscExp || []).map((exp, idx) =>
          idx === index ? { ...exp, label: newLabel } : exp
        ),
      },
    }));
  };

  const handleRemoveMiscExpense = (index) => {
    setSubModelData((prev) => {
      const list = prev.expenses.miscExp || [];
      const updated = list.filter((_, idx) => idx !== index);

      return {
        ...prev,
        expenses: {
          ...prev.expenses,
          miscExp: updated.length > 0 ? updated : [{ id: `misc_${Date.now()}`, label: "Misc Exp-1", amount: 0 }],
        },
      };
    });
  };

  const handleChangeMiscExpenseAmount = (index, newAmount) => {
    setSubModelData((prev) => ({
      ...prev,
      expenses: {
        ...prev.expenses,
        miscExp: (prev.expenses.miscExp || []).map((exp, idx) =>
          idx === index ? { ...exp, amount: newAmount } : exp
        ),
      },
    }));
  };

  const handleAddMiscRevenue = () => {
    setSubModelData((prev) => {
      const list = prev.revenue.misc || [];
      const newLabel = getNextMiscRevLabel(list);
      const newItem = {
        id: `rev_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
        label: newLabel,
        amount: 0,
      };

      return {
        ...prev,
        revenue: {
          ...prev.revenue,
          misc: [...list, newItem],
        },
      };
    });
  };

  const handleUpdateMiscRevenueAmount = (index, newAmount) => {
    setSubModelData((prev) => ({
      ...prev,
      revenue: {
        ...prev.revenue,
        misc: (prev.revenue.misc || []).map((m, idx) =>
          idx === index ? { ...m, amount: newAmount } : m
        ),
      },
    }));
  };

  const handleRenameMiscRevenue = (index, newLabel) => {
    setSubModelData((prev) => ({
      ...prev,
      revenue: {
        ...prev.revenue,
        misc: (prev.revenue.misc || []).map((m, idx) =>
          idx === index ? { ...m, label: newLabel } : m
        ),
      },
    }));
  };

  const handleRemoveMiscRevenue = (index) => {
    setSubModelData((prev) => {
      const list = prev.revenue.misc || [];
      const updated = list.filter((_, idx) => idx !== index);

      return {
        ...prev,
        revenue: {
          ...prev.revenue,
          misc: updated.length > 0 ? updated : [{ id: `rev_${Date.now()}`, label: "Misc 1", amount: 0 }],
        },
      };
    });
  };

  const handleAddRow = (index) => {
    setOpenAddOperation({
      isOpen: true,
      index,
    });
  };

  const handleUserRefChange = (index, value) => {
    const updated = [...vesselCargoDetailsTableData.userRef];
    updated[index].value = value;
    setVesselCargoDetailsTableData((prev) => ({ ...prev, userRef: updated }));
  };

  const handleAddUserRef = (index) => {
    if (vesselCargoDetailsTableData.userRef.length >= 6) {
      toastWarning("Maximum 6 user references allowed");
      return;
    }
    const currentRefs = vesselCargoDetailsTableData.userRef;

    // Extract all existing numbers from userRef labels
    const existingNums = new Set(
      currentRefs
        .map((item) => {
          const match = item.label?.match(/\d+/);
          return match ? parseInt(match[0], 10) : null;
        })
        .filter((n) => n !== null)
    );

    // Determine the next unique number
    let nextNum = 1;
    if (existingNums.size > 0) {
      const maxNum = Math.max(...existingNums);
      if (maxNum < 6) {
        nextNum = maxNum + 1;
      } else {
        for (let i = 1; i <= 6; i++) {
          if (!existingNums.has(i)) {
            nextNum = i;
            break;
          }
        }
      }
    }

    const updated = [...currentRefs];
    const newId = Date.now();
    updated.splice(index + 1, 0, {
      id: newId,
      label: `User Ref-${nextNum}`,
      value: "",
    });
    setVesselCargoDetailsTableData((prev) => ({ ...prev, userRef: updated }));

    setTimeout(() => {
      if (vesselCargoContainerRef.current) {
        vesselCargoContainerRef.current.scrollTo({
          top: vesselCargoContainerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 50);
  };

  const handleRemoveUserRef = (index) => {
    if (vesselCargoDetailsTableData.userRef.length === 1) return;
    const updated = [...vesselCargoDetailsTableData.userRef];
    updated.splice(index, 1);
    setVesselCargoDetailsTableData((prev) => ({ ...prev, userRef: updated }));
  };

  const handleVesselCargoDetailsTableInputChange = (e, key) => {
    setVesselCargoDetailsTableData({
      ...vesselCargoDetailsTableData,
      [key]: e.target.value,
    });
  };

  const delayPortSearch = useCallback(
    _.debounce(
      (selectedOperation, search, isInitialData = false) =>
        onSearchPortList(selectedOperation, search, isInitialData),
      500
    ),
    []
  );
  const onSearchPortList = (selectedOperation, value) => {
    setInitialAddOperation({ ...selectedOperation, port: value });
    if (value) {
      setPortLoading(true);
      portsByChar(value)
        .then((res) => {
          setPortLoading(false);
          setPortOptions(
            (Array.isArray(res.data.list) &&
              res.data.list.map((item) => ({
                label: `${item.name} ${item.country ? "(" + item.country + ")" : ""
                  }`,
                value: item.name,
                lat: item?.lat,
                lng: item?.lng,
              }))) ||
            []
          );
        })
        .catch((err) => {
          setPortLoading(false);
        });
    }
  };

  const onAddOperationByModal = async () => {
    const {
      operation = "",
      port = "",
      portExp = 0,
      portStay = 0,
    } = initialAddOperation;

    if (!operation || !port) {
      return toastError("Port is required");
    }

    // Get the current cargo list
    const prevCargoList = cargoOperationTableData?.cargoList || [];
    const insertIndex = openAddOperation.index + 1;

    // Get previous row's departure time
    const prevRowDepartureTime =
      openAddOperation.index >= 0 && prevCargoList[openAddOperation.index]
        ? prevCargoList[openAddOperation.index].departureTime
        : "N/A";

    // Construct new row
    const newRow = {
      _id: uuidv4(),
      operation,
      port,
      cargoTx: 0,
      cargoDescription: "",
      remarks: null,
      statementOfFacts: null,
      laytimes: null,
      timeZone: "+0",
      arrivalTime: prevRowDepartureTime,
      arrivalTimeZ: convertToUTC(prevRowDepartureTime, "+0"),
      arrivalHsfo: 0,
      arrivalLsfo: 0,
      arrivalMgo: 0,
      cargoDetails: {
        distNormal: 728,
        distEca: 0,
        bnkrFactor: 0,
        speedReduce: 0,
        speedFactor: 0,
        arrivalBunkersHSFO: 0,
        arrivalBunkersLSFO: 0,
        arrivalBunkersMGO: 0,
        bunkerSuppliedHSFO: 0,
        bunkerSuppliedLSFO: 0,
        bunkerSuppliedMGO: 0,
        bunkerNonScrubberHSFO: 0,
        bunkerNonScrubberLSFO: 0,
        bunkerNonScrubberMGO: 0,
        bunkerScrubberHSFO: 0,
        bunkerScrubberLSFO: 0,
        bunkerScrubberMGO: 0,
        fuelPriceType0Hsfo: 0,
        fuelPriceType0Lsfo: 0,
        fuelPriceType0Mgo: 0,
        fuelPriceType1Hsfo: 0,
        fuelPriceType1Lsfo: 0,
        fuelPriceType1Mgo: 0,
        fuelPriceType2Hsfo: 0,
        fuelPriceType2Lsfo: 0,
        fuelPriceType2Mgo: 0,
        fuelPriceType3Hsfo: 0,
        fuelPriceType3Lsfo: 0,
        fuelPriceType3Mgo: 0,
        fuelPriceType4Hsfo: 0,
        fuelPriceType4Lsfo: 0,
        fuelPriceType4Mgo: 0,
        reserve: "Supply",
        paidBy: "Owner",
      },
      priceHsfo: 0,
      priceLsfo: 0,
      priceMgo: 0,
      departureTime:
        insertIndex < prevCargoList.length
          ? prevCargoList[insertIndex].arrivalTime
          : null,
      departureTimeZ:
        insertIndex < prevCargoList.length
          ? convertToUTC(prevCargoList[insertIndex].arrivalTime, "+0")
          : "N/A",
      departureHsfo: 0,
      departureLsfo: 0,
      departureMgo: 0,
      billOfLadingDate: null,
      blNumber: null,
      remarks2: null,
      portExp,
      portStay,
    };

    // Prepare the updated list
    const updatedList = [...prevCargoList];
    updatedList.splice(insertIndex, 0, newRow);

    // Update next row's arrival time if it exists
    if (insertIndex + 1 < updatedList.length) {
      updatedList[insertIndex + 1].arrivalTime = newRow.departureTime;
    }

    // Now update both states at once
    const newCargoOperationTableData = {
      ...cargoOperationTableData,
      cargoList: updatedList,
    };

    setCargoOperationTableData(newCargoOperationTableData);
    setIntialCargoInvoiceDetails({
      ...newCargoOperationTableData,
      cargoDetails: newCargoOperationTableData,
    });

    // Reset modal & form state
    setInitialAddOperation({
      operation: "Passing",
      port: "",
      portExp: 0,
      portStay: 0,
    });
    setOpenAddOperation({
      isOpen: false,
      index: null,
    });
    setPortOptions([]);
    setPortLoading(false);
  };

  const handleDeleteRow = (index) => {
    if (cargoOperationTableData?.cargoList?.length <= 1) return;

    const newCargoData = [...cargoOperationTableData?.cargoList];

    newCargoData.splice(index, 1);
    setCargoOperationTableData((prev) => ({
      ...prev,
      cargoList: newCargoData,
    }));
  };

  const handleDownloadPdf = async () => {
    try {
      setLoader(true, "Creating download...");
      let response;
      if (isLaytimesModelOpen) {
        response = await createElectricLaytimePdf(
          getCurrentLaytimeStatementRowData(
            cargoOperationTableData?.cargoList?.[selectedOperationIndex]
          )
        );
      } else if (isStatementOfFactsModelOpen) {
        response = await createElectricSofPdf(
          getCurrentStatementOfFactsRowData(
            cargoOperationTableData?.cargoList?.[selectedOperationIndex]
          )
        );
      }
      if (!response) {
        toastError(`Failed to create data`);
      }
      return response.data || response;
    } catch (err) {
      toastError(err.message);
    } finally {
      setLoader(false);
    }
  };

  const fetchDataForPdf = async () => {
    const vessel = vesselContractDetails?.vesselDetails;
    const cargo =
      cargoOperationTableData?.cargoList?.[
      cargoOperationTableData?.cargoList?.length - 1
      ];
    const {
      _id = "",
      bnkPriceDeliveryhs = 0,
      bnkPriceDeliveryls = 0,
      bnkPriceDeliverymgo = 0,
      bnkPriceRedeliveryhs = 0,
      bnkPriceRedeliveryls = 0,
      bnkPriceRedeliverymgo = 0,
      bnkPriceSettlemenths = 0,
      bnkPriceSettlementls = 0,
      bnkPriceSettlementmgo = 0,
      bnkQtyRedeliveryhs = 0,
      bnkQtyRedeliveryls = 0,
      bnkQtyRedeliverymgo = 0,
      bnkRedeliveryQtyTolerancehs = 0,
      bnkRedeliveryQtyTolerancels = 0,
      bnkRedeliveryQtyTolerancemgo = 0,
      constants = 0,
      extraExpense = 0,
    } = vessel || {};
    const vesselData = vessel?.vessel ? JSON.parse(vessel?.vessel || "{}") : {};
    const {
      vesselName = "",
      vesselDwt = 0,
      vesselIMO = 0,
      vesselDraftS = 0,
      vesselTPC,
      vesselGrainCap,
      vesselBuilt,
      vesselLOA,
      vesselBeam,
      vesselGRT,
      vesselNRT,
      vesselLightShip,
      vesselBaleCap,
      vesselGears,
      vesselGrabs,
      vesselFlag,
      vesselMMSI,
      vesselClass,
      vesselBalSpd1 = 0,
      vesselBalConsmHS1 = 0,
      vesselBalConsmLS1 = 0,
      vesselBalConsmMGO1 = 0,
      vesselBalSpd2 = 0,
      vesselBalConsmHS2 = 0,
      vesselBalConsmLS2 = 0,
      vesselBalConsmMGO2 = 0,
      vesselBalSpd3 = 0,
      vesselBalConsmHS3 = 0,
      vesselBalConsmLS3 = 0,
      vesselBalConsmMGO3 = 0,
      vesselBalSpd4 = 0,
      vesselBalConsmHS4 = 0,
      vesselBalConsmLS4 = 0,
      vesselBalConsmMGO4 = 0,
      vesselLdnSpd1 = 0,
      vesselLdnConsmHS1 = 0,
      vesselLdnConsmLS1 = 0,
      vesselLdnConsmMGO1 = 0,
      vesselLdnSpd2 = 0,
      vesselLdnConsmHS2 = 0,
      vesselLdnConsmLS2 = 0,
      vesselLdnConsmMGO2 = 0,
      vesselLdnSpd3 = 0,
      vesselLdnConsmHS3 = 0,
      vesselLdnConsmLS3 = 0,
      vesselLdnConsmMGO3 = 0,
      vesselLdnSpd4 = 0,
      vesselLdnConsmHS4 = 0,
      vesselLdnConsmLS4 = 0,
      vesselLdnConsmMGO4 = 0,
      vesselPIdleConsmHS = 0,
      vesselPIdleConsmLS = 0,
      vesselPIdleConsmMGO = 0,
      vesselPLdgConsmHS = 0,
      vesselPLdgConsmLS = 0,
      vesselPLdgConsmMGO = 0,
      vesselPDischConsmHS = 0,
      vesselPDischConsmLS = 0,
      vesselPDischConsmMGO = 0,
      vesselVExtraConsmHS = 0,
      vesselVExtraConsmLS = 0,
      vesselVExtraConsmMGO = 0,
      vesselBalComb1Selected = false,
      vesselBalComb2Selected = false,
      vesselBalComb3Selected = false,
      vesselBalComb4Selected = false,
      vesselLadComb1Selected = false,
      vesselLadComb2Selected = false,
      vesselLadComb3Selected = false,
      vesselLadComb4Selected = false,
    } = vesselData || {};
    const splitData = JSON.parse(vessel?.splitHire || "[]") || [];

    // Construct the PDF data
    const data = {
      first_section: {
        _id,
        vesselName,
        port: cargo?.port,
        remark: vessel?.remark,
        DWT: vesselDwt,
        Draft: vesselDraftS,
        TPC: vesselTPC,
        grain: vesselGrainCap,
        built: vesselBuilt,
        LOA: vesselLOA,
        Beam: vesselBeam,
        GRT: vesselGRT,
        NRT: vesselNRT,
        light_ship: vesselLightShip,
        bale_capacity: vesselBaleCap,
        Gears: vesselGears,
        Grabs: vesselGrabs,
        Flag: vesselFlag,
        MMSI: vesselMMSI,
        Class: vesselClass,
      },
      second_section: {
        DWT: vesselDwt,
        IMO: vesselIMO,
        BalComb1: vesselBalComb1Selected,
        BalComb2: vesselBalComb2Selected,
        BalComb3: vesselBalComb3Selected,
        BalComb4: vesselBalComb4Selected,
        LadComb1: vesselLadComb1Selected,
        LadComb2: vesselLadComb2Selected,
        LadComb3: vesselLadComb3Selected,
        LadComb4: vesselLadComb4Selected,
        Ballast_Sea_Consumptions: {
          col_1: {
            Speed: vesselBalSpd1,
            HS: vesselBalConsmHS1,
            LS: vesselBalConsmLS1,
            MGO: vesselBalConsmMGO1,
          },
          col_2: {
            Speed: vesselBalSpd2,
            HS: vesselBalConsmHS2,
            LS: vesselBalConsmLS2,
            MGO: vesselBalConsmMGO2,
          },
          col_3: {
            Speed: vesselBalSpd3,
            HS: vesselBalConsmHS3,
            LS: vesselBalConsmLS3,
            MGO: vesselBalConsmMGO3,
          },
          col_4: {
            Speed: vesselBalSpd4,
            HS: vesselBalConsmHS4,
            LS: vesselBalConsmLS4,
            MGO: vesselBalConsmMGO4,
          },
        },
        Laden_Sea_Consumptions: {
          col_1: {
            Speed: vesselLdnSpd1,
            HS: vesselLdnConsmHS1,
            LS: vesselLdnConsmLS1,
            MGO: vesselLdnConsmMGO1,
          },
          col_2: {
            Speed: vesselLdnSpd2,
            HS: vesselLdnConsmHS2,
            LS: vesselLdnConsmLS2,
            MGO: vesselLdnConsmMGO2,
          },
          col_3: {
            Speed: vesselLdnSpd3,
            HS: vesselLdnConsmHS3,
            LS: vesselLdnConsmLS3,
            MGO: vesselLdnConsmMGO3,
          },
          col_4: {
            Speed: vesselLdnSpd4,
            HS: vesselLdnConsmHS4,
            LS: vesselLdnConsmLS4,
            MGO: vesselLdnConsmMGO4,
          },
        },
        Port_Consumptions: {
          Idle: {
            HS: vesselPIdleConsmHS,
            LS: vesselPIdleConsmLS,
            MGO: vesselPIdleConsmMGO,
          },
          Loading: {
            HS: vesselPLdgConsmHS,
            LS: vesselPLdgConsmLS,
            MGO: vesselPLdgConsmMGO,
          },
          Disch: {
            HS: vesselPDischConsmHS,
            LS: vesselPDischConsmLS,
            MGO: vesselPDischConsmMGO,
          },
          Extra: {
            HS: vesselVExtraConsmHS,
            LS: vesselVExtraConsmLS,
            MGO: vesselVExtraConsmMGO,
          },
        },
      },
      third_section: {
        split_hire: splitData || [],
        bunker_qty: {
          bnkDelhs: cargo?.departureHsfo?.toFixed(2) || 0,
          bnkDells: cargo?.departureLsfo?.toFixed(2) || 0,
          bnkDelmgo: cargo?.departureMgo?.toFixed(2) || 0,
          bnkQtyRedeliveryhs:
            cargo?.redeliveryHsfo?.toFixed(2) || bnkQtyRedeliveryhs || 0,
          bnkQtyRedeliveryls:
            cargo?.redeliveryLsfo?.toFixed(2) || bnkQtyRedeliveryls || 0,
          bnkQtyRedeliverymgo:
            cargo?.redeliveryMgo?.toFixed(2) || bnkQtyRedeliverymgo || 0,
          bnkRedeliveryQtyTolerancehs,
          bnkRedeliveryQtyTolerancels,
          bnkRedeliveryQtyTolerancemgo,
        },
        bunker_price: {
          bnkPriceDeliveryhs,
          bnkPriceDeliveryls,
          bnkPriceDeliverymgo,
          bnkPriceRedeliveryhs,
          bnkPriceRedeliveryls,
          bnkPriceRedeliverymgo,
          bnkPriceSettlemenths,
          bnkPriceSettlementls,
          bnkPriceSettlementmgo,
        },
      },
      fourth_section: {
        extraExpense,
        constants,
        dateOpen: cargo?.departureTime || vessel?.dateOpen,
        Gbb: vessel?.gbb,
        hirePerDay: vessel?.hirePerDay,
        hireGbb: vessel?.hireGbb,
      },
    };

    return data;
  };
  const pdfTemplate = async () => {
    try {
      const generatedData = await fetchDataForPdf();
      setPdfData(generatedData);
    } catch (error) {
      console.error("Error generating PDF template:", error);
    }
  };

  useEffect(() => {
    pdfTemplate();
  }, [vesselContractDetails, cargoOperationTableData, cargoContractDetails]);

  const tabs = [
    {
      key: 0,
      label: "First Estimate",
      tooltip: isRevised
        ? "Contracts that were created but are now locked after revision."
        : "New contracts that are active and editable until revised.",
    },
    isRevised && {
      key: 1,
      label: "Revised Estimate",
      tooltip: "Edited contracts that have been revised.",
    },
    {
      key: 2,
      label: "Actual Operations",
      tooltip: "View and manage operations assigned to you.",
    },
  ];

  const handleSetRows = useCallback(
    (newRowsOrUpdater) => {
      setCargoOperationTableData((prev) => {
        const updated = { ...prev };
        const currentRows =
          updated.cargoList[selectedCargoIndex]?.invoiceDetails || [];

        // Handle functional updates from handleChange
        const newRows =
          typeof newRowsOrUpdater === "function"
            ? newRowsOrUpdater(currentRows)
            : newRowsOrUpdater;

        // Update cargoOperationTableData
        updated.cargoList[selectedCargoIndex] = {
          ...updated.cargoList[selectedCargoIndex],
          invoiceDetails: newRows,
        };

        // Sync cargoInvoices
        const selectedCargo = updated.cargoList[selectedCargoIndex];

        setCargoInvoices((prevInvoices) => {
          const existingIndex = prevInvoices.findIndex(
            (invoice) =>
              invoice.cargoId === selectedCargo?._id &&
              invoice.port === selectedCargo?.port
          );

          if (existingIndex !== -1) {
            const updatedInvoices = [...prevInvoices];
            updatedInvoices[existingIndex] = {
              ...updatedInvoices[existingIndex],
              cargoName: updated?.name,
              invoiceDetails: newRows,
              totalAmt: newRows.reduce(
                (sum, row) => sum + (row.amount || 0),
                0
              ), // recalc
            };
            return updatedInvoices;
          } else {
            return [
              ...prevInvoices,
              {
                cargoId: selectedCargo?._id,
                port: selectedCargo?.port,
                operation: selectedCargo?.operation,
                cargoName: updated?.name,
                totalAmt: newRows.reduce(
                  (sum, row) => sum + (row.amount || 0),
                  0
                ),
                invoiceDetails: newRows,
              },
            ];
          }
        });

        handleSubmit(updated);
        return updated;
      });
    },
    [selectedCargoIndex]
  );

  const vesselDetailsViewTabs = [
    {
      key: 0,
      label: "Vessel Contract",
    },
    {
      key: 1,
      label: "Vessel Details",
    },
  ];

  const cargoDetailsViewTabs = [
    {
      key: 0,
      label: "Cargo Contract",
    },
    {
      key: 1,
      label: "Cargo Details",
    },
  ];

  const handleViewNextTrip = () => {
    if (!nextOperationId) return;
    // Next Trip is an Estimate (status: "open"), navigate to estimate view
    window.open(`/saved-contracts/${nextOperationId}`, "_blank");
  };

  const handleCreateNextTrip = async () => {
    if (vesselContractDetails?.tripEnded) {
      setTripEndWarningReason(vesselContractDetails.tripEndReason || "trip_end");
      setTripEndWarningMode("blocked");
      setTripEndWarningOpen(true);
      return;
    }
    if (nextOperationId) {
      handleViewNextTrip();
      return;
    }

    try {
      if (typeof props.setLoader === "function") {
        props.setLoader(true, "Checking trip eligibility...");
      }
      const res = await checkTripEligibility(id);
      if (typeof props.setLoader === "function") {
        props.setLoader(false);
      }

      const { eligible, reason } = normalizeTripEligibilityResponse(res);
      if (eligible) {
        setNextTripModalOpen(true);
      } else {
        setTripEndWarningReason(reason);
        setTripEndWarningMode("blocked");
        setTripEndWarningOpen(true);
      }
    } catch (err) {
      if (typeof props.setLoader === "function") {
        props.setLoader(false);
      }
      console.error(err);
      toastError(err?.message || "Failed to check trip eligibility");
    }
  };

  const handleConfirmEndTrip = async () => {
    if (!id) {
      toastError("Operation ID not found");
      return;
    }
    try {
      const res = await endTrip({ operationId: id });
      if (res?.success) {
        toastSuccess("Trip ended successfully");
        if (typeof fetchOperation === "function") {
          fetchOperation();
        }
      } else {
        toastError(res?.message || "Failed to end trip");
      }
    } catch (err) {
      toastError(err?.message || "Failed to end trip");
    }
  };

  const { setIsFullScreen } = props;

  useEffect(() => {
    if (typeof setIsFullScreen === "function") {
      setIsFullScreen(true);
      return () => setIsFullScreen(false);
    }
  }, [setIsFullScreen]);

  return (
    <div className="w-full max-w-full min-w-0 overflow-x-hidden h-[calc(100vh-56px)] overflow-y-auto scroll-thin box-border">
      {mainTab === 2 && (
        <div className="actual-ops bg-[#c8dcf6] min-h-full w-full max-w-full min-w-0 p-2 flex flex-col box-border">
          <div className="mb-2 overflow-x-auto overflow-y-hidden scroll-thin pb-1 w-full max-w-full min-w-0 shrink-0">
            <div className="min-w-[960px]">
              <div className="flex justify-between gap-x-10 gap-y-2 items-center mb-1.5 flex-wrap">
                <div className="flex items-center gap-3 self-center">
                  <Box display="flex" alignItems="center" className="shadow-lg rounded-md">
                    <CustomTabs
                      tabs={tabs}
                      active={mainTab}
                      onChange={handleMainTabChange}
                      isCompact
                    />
                  </Box>
                  <div className="inline-flex items-center border border-[#cbd5e1] rounded-none overflow-hidden h-[24px] text-[11px]">
                    <span className="bg-[#f8fafc] text-[#1e293b] font-medium px-2 h-full flex items-center border-r border-[#cbd5e1] whitespace-nowrap">
                      Fuel Settlement Mode :
                    </span>
                    <div className="bg-[#ffffd6] h-full flex items-center px-1">
                      <select
                        value={fuelSettlementMode}
                        disabled={isReadOnly}
                        onChange={handleFuelSettlementModeChange}
                        name="fuelSettlementMode"
                        className="bg-transparent text-[#1e293b] text-[11px] font-medium border-none outline-none cursor-pointer capitalize h-full pr-1 disabled:cursor-not-allowed"
                      >
                        {fuelSettlementList.map((item, i) => (
                          <option value={item.value} key={i} className="text-[#1e293b] capitalize bg-white">
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="inline-flex items-center border border-[#cbd5e1] rounded-none overflow-hidden h-[24px] text-[11px]">
                    <span className="bg-[#f8fafc] text-[#1e293b] font-medium px-2 h-full flex items-center border-r border-[#cbd5e1] whitespace-nowrap">
                      Operation Status :
                    </span>
                    <div className="bg-[#ffffd6] h-full flex items-center px-1">
                      <select
                        value={operationStatus}
                        disabled={isReadOnly}
                        onChange={handleOperationStatusChange}
                        name="operationStatus"
                        className="bg-transparent text-[#1e293b] text-[11px] font-medium border-none outline-none cursor-pointer capitalize h-full pr-1 disabled:cursor-not-allowed"
                      >
                        {operationStatusList.map((item, i) => (
                          <option value={item.value} key={i} className="text-[#1e293b] capitalize bg-white">
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {!isReadOnly && (
                    <div className="flex items-center gap-1">
                    {fuelSettlementMode?.toLowerCase() === "relay" && (nextOperationId ? (
                      <button
                        type="button"
                        onClick={handleViewNextTrip}
                        style={{ backgroundColor: "#313C4C", borderColor: "#313C4C", color: "#ffffff" }}
                        className="h-[24px] px-2 text-[11px] font-medium whitespace-nowrap rounded-none transition-colors border text-white cursor-pointer uppercase flex items-center gap-1 hover:opacity-90"
                        title="A Next Trip has already been created for this voyage. Click to view it."
                      >
                        <span>View Next Trip</span>
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </button>
                    ) : (
                        <button
                          type="button"
                          onClick={handleCreateNextTrip}
                          disabled={vesselContractDetails?.tripEnded}
                          className="h-[24px] px-2 text-[11px] font-medium whitespace-nowrap rounded-none transition-colors border border-[#313C4C] text-white bg-[#313C4C] hover:bg-[#1e2632] cursor-pointer uppercase"
                        >
                          Create Next Trip
                        </button>
                    ))}
                      <button
                        type="button"
                        onClick={() => {
                          setTripEndWarningMode("confirm_end");
                          setTripEndWarningOpen(true);
                        }}
                        disabled={vesselContractDetails?.tripEnded}
                        style={{
                          backgroundColor: vesselContractDetails?.tripEnded ? "#9ca3af" : "#313C4C",
                          borderColor: vesselContractDetails?.tripEnded ? "#9ca3af" : "#313C4C",
                          color: "#ffffff"
                        }}
                        className="h-[24px] px-2 text-[11px] font-medium whitespace-nowrap rounded-none transition-colors border text-white cursor-pointer uppercase disabled:opacity-50 disabled:cursor-not-allowed"
                        title="End this trip and block future Next Trip creation"
                      >
                        {vesselContractDetails?.tripEnded ? "Trip Ended" : "Trip End"}
                      </button>
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-3">
                  {/* Save Button Section */}
                  <div className="flex items-center justify-end">
                    {!isReadOnly && isChanged.current && isSaved.current && (
                      <span className="mr-2">
                        <CustomTooltip
                          position="left"
                          text="Unsaved changes detected"
                        >
                          <div className="relative">
                            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-rose-50 border border-rose-200">
                              <div className="w-2 h-2 rounded-full bg-rose-500 animate-pulse"></div>
                            </div>
                          </div>
                        </CustomTooltip>
                      </span>
                    )}
                    {!isReadOnly && (
                      <button
                        type="button"
                        onClick={() => { handleSubmit() }}
                        className={`h-[24px] px-2 text-[11px] font-medium whitespace-nowrap rounded-none transition-colors border cursor-pointer uppercase ${!isChanged.current || !isSaved.current ? "border-[#313C4C] text-white bg-[#313C4C] hover:bg-[#1e2632]" : "border-rose-500 text-white bg-rose-500 hover:bg-rose-600"}`}
                      >
                        Calculate and Save
                      </button>
                    )}
                  </div>

                  {/* Download PDF Section */}
                  {/* <div className="flex justify-end">
                    <DownloadPdf
                      pdfData={pdfData}
                      onDownloadPdf={onDownloadPdf}
                      isOperationTab
                    />
                  </div> */}
                </div>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full">
                <div className="flex flex-row gap-2.5 items-center flex-1 min-w-0 mr-2">
                  <div className="flex-[1.75] min-w-[420px] max-w-[800px] rounded-none max-h-[calc(100vh-370px)] overflow-y-auto scroll-thin bg-white border border-[#cbd5e1]">
                    <table className="w-full border-collapse text-[11px]">
                      {/* Table Header */}
                      <thead className="sticky top-0 z-[99]">
                        <tr className="bg-[#313C4C] text-white h-[24px]">
                          <th className="px-2 py-1 text-left w-[32%] min-w-[130px] font-medium text-[11px] align-middle border-r border-b border-[#5b6779] bg-[#313C4C]">
                            Label
                          </th>
                          <th className="px-2 py-1 text-left w-[17%] min-w-[55px] font-medium text-[11px] align-middle border-r border-b border-[#5b6779] bg-[#313C4C]">
                            First Estimate
                          </th>
                          <th className="px-2 py-1 text-left w-[17%] min-w-[55px] font-medium text-[11px] align-middle border-r border-b border-[#5b6779] bg-[#313C4C]">
                            Revised
                          </th>
                          <th className="px-2 py-1 text-left w-[17%] min-w-[55px] font-medium text-[11px] align-middle border-r border-b border-[#5b6779] bg-[#313C4C]">
                            Actual
                          </th>
                          <th className="px-2 py-1 text-left w-[17%] min-w-[55px] font-medium text-[11px] align-middle border-b border-[#5b6779] bg-[#313C4C]">
                            Settled
                          </th>
                        </tr>
                      </thead>

                      <tbody className="divide-y-0">
                        <tr>
                          <td
                            colSpan={6}
                            className="bg-[#dbe4ef] px-2 py-1 text-[11px] font-semibold text-black border-y border-[#b4bbc4] shadow-[inset_0_1px_0_#b4bbc4] h-[24px] align-middle"
                          >
                            <div className="flex gap-5 items-center">
                              <span className="section-title relative z-10 font-semibold text-black">
                                Revenue
                              </span>
                              <Tooltip
                                arrow
                                title={
                                  <span className="text-[11px]">Generate Invoice</span>
                                }
                              >
                                <button
                                  className="text-[11px] bg-white border border-[#94a3b8] text-black shadow-sm font-medium px-2 py-0.5 rounded-none hover:bg-[#313C4C] hover:text-white transition-all cursor-pointer"
                                  onClick={() => setIsPortSelectModalOpen(true)}
                                >
                                  Generate Invoice
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>

                        {revenueFields.map((field, i) => (
                          <tr
                            key={`rev-${i}`}
                            className="h-[20px] hover:bg-amber-50/60 transition-colors"
                          >
                            <td
                              className={`px-2 py-0.5 border-r border-b border-[#cbd5e1] bg-white h-[20px] align-middle text-[11px]
                                ${field.link
                                  ? "cursor-pointer font-medium text-black underline"
                                  : "text-black font-medium"
                                }`}
                              onClick={() => field.link && handleSubModels(field.key)}
                            >
                              {field.label}
                            </td>

                            <td className="bg-[#f1f5f9] border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <input
                                className="w-full h-full text-[11px] px-1.5 bg-[#f1f5f9] disabled:bg-[#f1f5f9] font-medium text-black border-none outline-none tabular-nums"
                                value={values.Revenue[field.key] ?? ""}
                                disabled
                                type="text"
                              />
                            </td>

                            <td className="bg-[#f8fafc] border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <input
                                className="w-full h-full text-[11px] px-1.5 bg-[#f8fafc] disabled:bg-[#f8fafc] font-medium text-black border-none outline-none tabular-nums"
                                value={values.Revised[field.key] ?? ""}
                                disabled
                                type="text"
                              />
                            </td>

                            <td
                              className={`border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle ${field.key !== "laytime" ? "bg-white" : "bg-[#ffffd6]"
                                }`}
                            >
                              <input
                                className={`w-full h-full text-[11px] px-1.5 tabular-nums font-medium text-black border-none outline-none
                                  ${field.key === "laytime"
                                    ? "bg-[#ffffd6] disabled:bg-[#ffffd6] focus:ring-1 focus:ring-inset focus:ring-amber-500 focus:bg-white cursor-text"
                                    : "bg-white disabled:bg-white cursor-not-allowed text-black"
                                  }`}
                                value={values.Actual[field.key] || ""}
                                onChange={handleChange("Actual", field.key)}
                                disabled={field.key !== "laytime"}
                                type="number"
                              />
                            </td>

                            <td className="bg-white border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <button
                                className={`w-full h-full text-left text-[11px] px-1.5 font-medium flex items-center bg-transparent border-none outline-none
                                  ${values?.Settled?.[field.key]?.totalSettledAmt > 0
                                    ? "text-black font-medium underline"
                                    : "text-black cursor-default"
                                  }`}
                                onClick={() =>
                                  setSelectedSettledAmt(values?.Settled?.[field.key])
                                }
                                disabled={
                                  !values?.Settled?.[field.key]?.totalSettledAmt
                                }
                              >
                                {values?.Settled?.[field.key]?.totalSettledAmt ? Number(Number(values?.Settled?.[field.key]?.totalSettledAmt).toFixed(3)) : 0}
                              </button>
                            </td>
                          </tr>
                        ))}

                        <tr>
                          <td
                            colSpan={6}
                            className="bg-[#dbe4ef] px-2 py-1 text-[11px] font-semibold text-black border-y border-[#b4bbc4] shadow-[inset_0_1px_0_#b4bbc4] h-[24px] align-middle"
                          >
                            <div className="flex gap-5 items-center">
                              <span className="section-title font-semibold text-black">
                                Expenses
                              </span>
                              <Tooltip
                                arrow
                                title={
                                  <span className="text-[11px]">Generate Payment Instruction</span>
                                }
                              >
                                <button
                                  className="text-[11px] bg-white border border-[#94a3b8] text-black shadow-sm font-medium px-2 py-0.5 rounded-none hover:bg-[#313C4C] hover:text-white transition-all cursor-pointer"
                                  onClick={() => setOpenExpensesInvoiceModel(true)}
                                >
                                  Generate Payment Instruction
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>

                        {expensesFields.map((field, i) => (
                          <tr
                            key={`exp-${i}`}
                            className="h-[20px] hover:bg-amber-50/60 transition-colors"
                          >
                            <td
                              className={`px-2 py-0.5 border-r border-b border-[#cbd5e1] bg-white h-[20px] align-middle text-[11px]
                                ${field.link
                                  ? "cursor-pointer font-medium text-black underline"
                                  : "text-black font-medium"
                                }`}
                              onClick={() => field.link && handleSubModels(field.key)}
                            >
                              {field.label}
                            </td>

                            <td className="bg-[#f1f5f9] border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <input
                                className="w-full h-full text-[11px] px-1.5 bg-[#f1f5f9] disabled:bg-[#f1f5f9] font-medium text-black border-none outline-none tabular-nums"
                                value={values.Revenue[field.key] ?? ""}
                                disabled
                                type="text"
                              />
                            </td>

                            <td className="bg-[#f8fafc] border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <input
                                className="w-full h-full text-[11px] px-1.5 bg-[#f8fafc] disabled:bg-[#f8fafc] font-medium text-black border-none outline-none tabular-nums"
                                value={values.Revised[field.key] ?? ""}
                                disabled
                                type="text"
                              />
                            </td>

                            <td
                              className={`border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle ${field.key !== "laytime" ? "bg-white" : "bg-[#ffffd6]"
                                }`}
                            >
                              <input
                                className={`w-full h-full text-[11px] px-1.5 tabular-nums font-medium text-black border-none outline-none
                                  ${field.key === "laytime"
                                    ? "bg-[#ffffd6] disabled:bg-[#ffffd6] focus:ring-1 focus:ring-inset focus:ring-amber-500 focus:bg-white cursor-text"
                                    : "bg-white disabled:bg-white cursor-not-allowed text-black"
                                  }`}
                                value={values.Actual[field.key] || ""}
                                onChange={handleChange("Actual", field.key)}
                                disabled={field.key !== "laytime"}
                                type="number"
                              />
                            </td>

                            <td className="bg-white border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <button
                                className={`w-full h-full text-left text-[11px] px-1.5 font-medium flex items-center bg-transparent border-none outline-none
                                  ${values?.Settled?.[field.key]?.totalSettledAmt > 0
                                    ? "text-black font-medium underline"
                                    : "text-black cursor-default"
                                  }`}
                                onClick={() =>
                                  setSelectedSettledAmt(values?.Settled?.[field.key])
                                }
                                disabled={
                                  !values?.Settled?.[field.key]?.totalSettledAmt
                                }
                              >
                                {values?.Settled?.[field.key]?.totalSettledAmt ? Number(Number(values?.Settled?.[field.key]?.totalSettledAmt).toFixed(3)) : 0}
                              </button>
                            </td>
                          </tr>
                        ))}

                        <tr>
                          <td
                            colSpan={6}
                            className="bg-[#dbe4ef] px-2 py-1 text-[11px] font-semibold text-black border-y border-[#b4bbc4] shadow-[inset_0_1px_0_#b4bbc4] h-[24px] align-middle"
                          >
                            <span className="section-title font-semibold text-black">
                              Profit
                            </span>
                          </td>
                        </tr>

                        {profitFileds.map((field, i) => (
                          <tr
                            key={`pro-${i}`}
                            className="h-[20px] hover:bg-amber-50/60 transition-colors"
                          >
                            <td
                              className={`px-2 py-0.5 border-r border-b border-[#cbd5e1] bg-white h-[20px] align-middle text-[11px]
                                ${field.link
                                  ? "cursor-pointer font-medium text-black underline"
                                  : "text-black font-medium"
                                }`}
                              onClick={() => field.link && handleSubModels(field.key)}
                            >
                              <span>{field.label}</span>
                            </td>

                            <td className="bg-[#f1f5f9] border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <input
                                className="w-full h-full text-[11px] px-1.5 bg-[#f1f5f9] disabled:bg-[#f1f5f9] font-medium text-black border-none outline-none tabular-nums"
                                value={values.Revenue[field.key] ?? ""}
                                disabled
                                type="text"
                              />
                            </td>

                            <td className="bg-[#f8fafc] border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <input
                                className="w-full h-full text-[11px] px-1.5 bg-[#f8fafc] disabled:bg-[#f8fafc] font-medium text-black border-none outline-none tabular-nums"
                                value={values.Revised[field.key] ?? ""}
                                disabled
                                type="text"
                              />
                            </td>

                            <td
                              className={`border-r border-b border-[#cbd5e1] p-0 h-[20px] align-middle ${field.key !== "laytime" ? "bg-white" : "bg-[#ffffd6]"
                                }`}
                            >
                              <input
                                className={`w-full h-full text-[11px] px-1.5 tabular-nums font-medium text-black border-none outline-none
                                  ${field.key === "laytime"
                                    ? "bg-[#ffffd6] disabled:bg-[#ffffd6] focus:ring-1 focus:ring-inset focus:ring-amber-500 focus:bg-white cursor-text"
                                    : "bg-white disabled:bg-white cursor-not-allowed text-black"
                                  }`}
                                value={values.Actual[field.key] || ""}
                                onChange={handleChange("Actual", field.key)}
                                disabled={field.key !== "laytime"}
                                type="number"
                              />
                            </td>

                            <td className="bg-white border-b border-[#cbd5e1] p-0 h-[20px] align-middle">
                              <button
                                className={`w-full h-full text-left text-[11px] px-1.5 font-medium flex items-center bg-transparent border-none outline-none
                                  ${values?.Settled?.[field.key]?.totalSettledAmt > 0
                                    ? "text-[#1e293b] font-medium hover:underline"
                                    : "text-black cursor-default"
                                  }`}
                                onClick={() =>
                                  setSelectedSettledAmt(values?.Settled?.[field.key])
                                }
                                disabled={
                                  !values?.Settled?.[field.key]?.totalSettledAmt
                                }
                              >
                                {values?.Settled?.[field.key]?.totalSettledAmt ? Number(Number(values?.Settled?.[field.key]?.totalSettledAmt).toFixed(3)) : 0}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div
                    ref={vesselCargoContainerRef}
                    className="flex-[0.75] min-w-[220px] max-w-[360px] overflow-y-auto overflow-x-hidden border border-[#cbd5e1] rounded-none scroll-thin bg-white h-fit max-h-[calc(100vh-370px)]"
                  >
                    <div className="w-full">
                      <table className="w-full border-collapse text-[11px]">
                        <tbody>
                          <tr>
                            <td
                              colSpan={2}
                              className="bg-[#313C4C] text-white px-2 py-1 text-[11px] text-left font-semibold border-b border-[#1e293b] h-[24px] align-middle"
                            >
                              Vessel Information
                            </td>
                          </tr>

                          {expenseVesselFields.map((item) => {
                            const getFieldValue = (key) =>
                              vesselCargoDetailsTableData[key] || "";

                            return (
                              <tr
                                key={item.key}
                                className="h-[20px] hover:bg-amber-50/60 transition-colors"
                              >
                                <td className="w-[42%] min-w-[110px] whitespace-nowrap px-2 py-0.5 bg-white text-black font-medium border-r border-b border-[#cbd5e1] text-[11px] align-middle h-[20px]">
                                  {item.label}
                                </td>

                                <td className={`p-0 border-b border-[#cbd5e1] w-[58%] min-w-[110px] h-[20px] align-middle ${item.disabled ? 'bg-white' : 'bg-[#ffffd6]'}`}>
                                  <input
                                    type="text"
                                    disabled={item.disabled}
                                    className="w-full h-full text-[11px] border-none outline-none px-1.5 py-0 font-medium bg-transparent text-black disabled:text-black disabled:cursor-not-allowed focus:ring-1 focus:ring-inset focus:ring-amber-500"
                                    value={getFieldValue(item.key)}
                                    onChange={(e) =>
                                      handleVesselCargoDetailsTableInputChange(e, item.key)
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })}

                          <tr>
                            <td
                              colSpan={2}
                              className="bg-[#313C4C] text-white px-2 py-1 text-[11px] text-left font-semibold border-y border-[#1e293b] h-[24px] align-middle"
                            >
                              <span className="font-semibold text-white">
                                Shipment Information
                              </span>
                            </td>
                          </tr>

                          {shipmentsFileds.map((item) => {
                            const getFieldValue = (key) =>
                              vesselCargoDetailsTableData[key] || "";

                            return (
                              <tr
                                key={item.key}
                                className="h-[20px] hover:bg-amber-50/60 transition-colors"
                              >
                                <td className="w-[42%] min-w-[110px] whitespace-nowrap px-2 py-0.5 bg-white text-black font-medium border-r border-b border-[#cbd5e1] text-[11px] align-middle h-[20px]">
                                  {item.label}
                                </td>

                                <td className={`p-0 border-b border-[#cbd5e1] w-[58%] min-w-[110px] h-[20px] align-middle ${item.disabled ? 'bg-white' : 'bg-[#ffffd6]'}`}>
                                  <input
                                    type="text"
                                    disabled={item.disabled}
                                    className="w-full h-full text-[11px] border-none outline-none px-1.5 py-0 font-medium bg-transparent text-black disabled:text-black disabled:cursor-not-allowed focus:ring-1 focus:ring-inset focus:ring-amber-500"
                                    value={getFieldValue(item.key)}
                                    onChange={(e) =>
                                      handleVesselCargoDetailsTableInputChange(e, item.key)
                                    }
                                    readOnly={item.disabled}
                                  />
                                </td>
                              </tr>
                            );
                          })}

                          <tr>
                            <td
                              colSpan={2}
                              className="bg-[#313C4C] text-white px-2 py-1 text-[11px] text-left font-semibold border-y border-[#1e293b] h-[24px] align-middle"
                            >
                              <span className="font-semibold text-white">
                                Revenue Information
                              </span>
                            </td>
                          </tr>

                          {revenueCargoFields.map((item) => {
                            if (item.key === "userRef") {
                              return vesselCargoDetailsTableData.userRef.map((refItem, index) => (
                                <tr
                                  key={refItem.id}
                                  className="h-[20px] hover:bg-amber-50/60 transition-colors"
                                >
                                  <td className="w-[42%] min-w-[110px] whitespace-nowrap px-2 py-0.5 bg-white text-black font-medium border-r border-b border-[#cbd5e1] text-[11px] align-middle h-[20px]">
                                    {refItem.label || `User Ref-${index + 1}`}
                                  </td>

                                  <td className={`p-0 border-b border-[#cbd5e1] w-[58%] min-w-[110px] h-[20px] align-middle ${item.disabled ? 'bg-white' : 'bg-[#ffffd6]'}`}>
                                    <div className="flex gap-1 items-center pr-1 h-full">
                                      <input
                                        type="text"
                                        disabled={item.disabled}
                                        className="w-full h-full text-[11px] border-none outline-none px-1.5 py-0 font-medium bg-transparent text-black disabled:text-black disabled:cursor-not-allowed focus:ring-1 focus:ring-inset focus:ring-amber-500"
                                        value={refItem.value || ""}
                                        onChange={(e) =>
                                          handleUserRefChange(index, e.target.value)
                                        }
                                      />

                                      <button
                                        type="button"
                                        className="text-emerald-700 bg-emerald-50 hover:bg-emerald-600 hover:text-white border border-emerald-400 hover:border-emerald-600 w-[18px] h-[18px] rounded flex items-center justify-center transition-colors active:scale-95 flex-shrink-0 cursor-pointer"
                                        onClick={() => handleAddUserRef(index)}
                                        title="Add User Ref"
                                      >
                                        <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                          <line x1="12" y1="5" x2="12" y2="19" />
                                          <line x1="5" y1="12" x2="19" y2="12" />
                                        </svg>
                                      </button>

                                      <button
                                        type="button"
                                        className={`${vesselCargoDetailsTableData.userRef.length === 1
                                          ? "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed"
                                          : "text-rose-600 bg-rose-50 hover:bg-rose-600 hover:text-white border-rose-300 hover:border-rose-600 active:scale-95 cursor-pointer"
                                          } border w-[18px] h-[18px] rounded flex items-center justify-center transition-all flex-shrink-0`}
                                        onClick={() => handleRemoveUserRef(index)}
                                        disabled={
                                          vesselCargoDetailsTableData.userRef.length === 1
                                        }
                                        title="Remove User Ref"
                                      >
                                        <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                          <line x1="5" y1="12" x2="19" y2="12" />
                                        </svg>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ));
                            }

                            const getFieldValue = (key) =>
                              vesselCargoDetailsTableData[key] || "";

                            return (
                              <tr
                                key={item.key}
                                className="h-[22px] hover:bg-amber-50/60 transition-colors"
                              >
                                <td className="w-[42%] min-w-[110px] whitespace-nowrap px-2 py-0 bg-white text-black font-medium border-r border-b border-[#cbd5e1] text-[11px] align-middle h-[22px]">
                                  {item.label}
                                </td>

                                <td className={`p-0 border-b border-[#cbd5e1] w-[58%] min-w-[110px] h-[22px] align-middle ${item.disabled ? 'bg-white' : 'bg-[#ffffd6]'}`}>
                                  <input
                                    type="text"
                                    disabled={item.disabled}
                                    className="w-full h-full text-[11px] border-none outline-none px-1.5 py-0 font-medium bg-transparent text-black disabled:text-black disabled:cursor-not-allowed focus:ring-1 focus:ring-inset focus:ring-amber-500"
                                    value={getFieldValue(item.key)}
                                    onChange={(e) =>
                                      handleVesselCargoDetailsTableInputChange(e, item.key)
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="w-[190px] shrink-0 flex flex-col gap-1 mt-0 ml-auto">
                  <div className="flex flex-col h-fit my-auto w-full bg-slate-50/50 rounded-lg border border-gray-200 p-1.5 shadow-xs">
                    <div className="flex flex-col gap-1">
                      {[
                        { label: "View Vessel Contract", key: "vesselContract" },
                        { label: "View Cargo Contract", key: "cargoContract" },
                        { label: "View Off-Hire", key: "offHire" },
                        { label: "Laytime Settlements", key: "laytimeSettlements" },
                        { label: "View Invoices", key: "invoices" },
                        { label: "View Payment Orders", key: "paymentOrders" },
                        { label: "Sustainability", key: "sustainability" },
                        { label: "Optimum Speed", key: "optimumSpeed" },
                        { label: "Fuel Supply Request", key: "fuelSupplyRequest" },
                        { label: "Fuel Expenses Reconciliation", key: "fuelExpensesReconciliation" },
                      ].map(({ label, key }) => (
                        <button
                          key={key}
                          onClick={() => handleButtonClick(key)}
                          className="
            group relative w-full flex items-center justify-between
            px-2 py-1 h-[24px]
            bg-white hover:bg-sky-50/80
            border border-slate-200 hover:border-[#2a3990]/50
            rounded
            shadow-2xs
            transition-all duration-150 ease-out
            active:scale-[0.98]
            cursor-pointer
          "
                        >
                          {/* Label */}
                          <span className="text-[11px] font-medium text-slate-700 group-hover:text-[#2a3990] transition-colors duration-150 text-left truncate pr-1">
                            {label}
                          </span>

                          {/* Right Icon */}
                          <svg
                            className="w-3 h-3 text-slate-400 group-hover:text-[#2a3990] transition-all duration-150 transform group-hover:translate-x-0.5 shrink-0"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>

                          {/* Left Active Indicator */}
                          <div className="absolute left-0 top-1/2 -translate-y-1/2 h-3 w-[2.5px] bg-[#2a3990] rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity duration-150"></div>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full max-w-full min-w-0 mt-3 shrink-0 overflow-hidden">
            <div className="flex items-end border-b border-[#cbd5e1] bg-transparent px-4 pl-16 pt-1 gap-1.5 overflow-x-auto overflow-y-hidden max-w-full min-w-0 scroll-thin">
              {[
                "Cargo Operations",
                "Itinerary & Fuel Supply",
                "Pricing",
                "Sea Table",
                "Insights",
              ].map((tabLabel, tabIndex) => {
                const isActive = activeTab === tabIndex;
                return (
                  <button
                    key={tabIndex}
                    type="button"
                    onClick={() => handleTabChange(tabIndex)}
                    disabled={isAnimating}
                    className={`px-3 py-1.5 text-[11px] transition-all duration-100 rounded-none cursor-pointer relative -mb-[1px] ${isActive
                      ? "bg-white text-[#103f6b] font-semibold border-t-2 border-t-[#103f6b] border-l border-r border-b-0 border-l-[#cbd5e1] border-r-[#cbd5e1] z-10"
                      : "bg-[#f1f5f9] text-slate-600 font-medium border border-[#cbd5e1] hover:bg-[#e2e8f0] hover:text-slate-900"
                      }`}
                  >
                    {tabLabel}
                  </button>
                );
              })}
            </div>

            <div
              key={`tab-${activeTab}`}
              className="bg-white border border-t-0 border-[#cbd5e1] rounded-none p-0 shadow-none overflow-hidden w-full max-w-full min-w-0"
              style={{
                animation: isAnimating
                  ? `${activeTab > prevTab ? "slideInRight" : "slideInLeft"} 200ms ease-in-out forwards`
                  : "",
              }}
            >
              <div className="bg-white rounded-none overflow-hidden w-full max-w-full min-w-0">
                {activeTab === 0 ? (
                  <div className="w-full max-w-full min-w-0 overflow-x-auto">
                    <CargoOperationTable
                      isReadOnly={isReadOnly}
                      handleDateChange={handleDateChangeForCargoOperationTable}
                      columns={columns}
                      handleInputChanges={
                        handleInputChangeForCargoOperationTable
                      }
                      data={cargoOperationTableData?.cargoList}
                      onAddRow={handleAddRow}
                      onPortChange={handlePortChange}
                      onDeleteRow={handleDeleteRow}
                      onButtonClick={handleCargoOperationSubModels}
                      freightMode={freightMode}
                    />
                  </div>
                ) : activeTab === 1 ? (
                  <div className="w-full max-w-full min-w-0 overflow-x-auto">
                    <FualSupplyTable
                      isReadOnly={isReadOnly}
                      handleDateChange={handleDateChangeForFualSupplyTable}
                      handleInputChanges={handleInputChangeForCargoOperationTable}
                      data={cargoOperationTableData}
                      onAddRow={handleAddRow}
                      onDeleteRow={handleDeleteRow}
                      onPortChange={handlePortChange}
                    />
                  </div>

                ) : activeTab === 2 ? (
                  <div className="w-full max-w-full min-w-0 overflow-x-auto">
                    <PricingTable
                      isReadOnly={isReadOnly}
                      columns={pricingColumns}
                      handleInputChanges={handleInputChangeForCargoOperationTable}
                      handleDateChange={handleDateChangeForCargoOperationTable}
                      data={cargoOperationTableData}
                      onAddRow={handleAddRow}
                      onDeleteRow={handleDeleteRow}
                      onPortChange={handlePortChange}
                    />
                  </div>

                ) : activeTab === 3 ? (
                  <div className="w-full max-w-full min-w-0 overflow-x-auto">
                    <SeaTable
                      isReadOnly={isReadOnly}
                      columns={seaTableColumns}
                      handleInputChanges={handleInputChangeForCargoOperationTable}
                      handleDateChange={handleDateChangeForCargoOperationTable}
                      data={cargoOperationTableData}
                      onAddRow={handleAddRow}
                      onDeleteRow={handleDeleteRow}
                      onPortChange={handlePortChange}
                    />
                  </div>

                ) : (
                  <div className="w-full max-w-full min-w-0 overflow-x-auto">
                    <InsightsTable
                      isReadOnly={isReadOnly}
                      columns={insightsColumns}
                      data={{
                        ...calculatedExpenses,
                        cargoList: [...cargoOperationTableData?.cargoList],
                      }}
                      onAddRow={handleAddRow}
                      onDeleteRow={handleDeleteRow}
                      onPortChange={handlePortChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <CustomShowModal
            open={isLaytimeSettlementsModelOpen}
            handleClose={() => setIsLaytimeSettlementsModelOpen(false)}
            maxWidth="lg"
            title="Laytime Settlements"
          >
            <LaytimeSettlementModel
              isReadOnly={isReadOnly}
              finalState={finalState}
              calculateStats={calculateStats}
              updateFinalState={updateFinalState}
            />
          </CustomShowModal>

          <CustomShowModal
            open={isLaytimesModelOpen}
            handleClose={() => setIsLaytimesModelOpen(false)}
            maxWidth="lg"
            title="Laytime Statement"
          >
            <LaytimeStatement
              isReadOnly={isReadOnly}
              laytimeStatementDetails={getCurrentLaytimeStatementRowData(
                cargoOperationTableData?.cargoList?.[selectedOperationIndex]
              )}
              selectedOperationIndex={selectedOperationIndex}
              setCargoOperationTableData={setCargoOperationTableData}
              warning={warning}
              setWarning={setWarning}
              currentItemId={
                cargoOperationTableData?.cargoList?.[selectedOperationIndex]
                  ?._id
              }
              onDownloadPdf={handleDownloadPdf}
            />
          </CustomShowModal>

          <CustomShowModal
            open={isStatementOfFactsModelOpen}
            handleClose={() => setIsStatementOfFactsModelOpen(false)}
            maxWidth="lg"
            title="Statement of Facts"
          >
            <StatementOfFactsModel
              isReadOnly={isReadOnly}
              state={getCurrentStatementOfFactsRowData(
                cargoOperationTableData?.cargoList?.[selectedOperationIndex]
              )}
              selectedOperationIndex={selectedOperationIndex}
              setCargoOperationTableData={setCargoOperationTableData}
              onDownloadPdf={handleDownloadPdf}
            />
          </CustomShowModal>

          <CustomShowModal
            open={isFinalInvoiceModelOpen}
            handleClose={() => setIsFinalInvoiceModelOpen(false)}
            maxWidth="lg"
            title="Final Invoice"
          >
            <FinalInvoiceModel
              opsId={id}
              isReadOnly={isReadOnly}
              finalInvoiceDetails={[...cargoInvoices, ...expenseInvoices]}
              refetch={() => fetchOperation()}
            />
          </CustomShowModal>

          <CustomShowModal
            open={isFuelSupplyRequestModelOpen}
            handleClose={() => setIsFuelSupplyRequestModelOpen(false)}
            maxWidth="lg"
            title="Fuel Supply Request"
          >
            <FuelSupplyReqModel
              uniqIds={uniqIds}
              isReadOnly={isReadOnly}
              data={cargoOperationTableData}
              vesselContractDetails={vesselContractDetails}
              refetch={() => fetchOperation()}
              operationId={id}
            />
          </CustomShowModal>

          <CustomShowModal
            open={isIssueInvoiceModelOpen}
            handleClose={() => {
              setIsIssueInvoiceModelOpen(false);
              if (openedFromPortSelect) {
                setIsPortSelectModalOpen(true);
              }
            }}
            maxWidth="none"
            title={
              cargoOperationTableData?.cargoList?.[selectedCargoIndex]?.port
                ? `Issue Invoice — ${cargoOperationTableData?.cargoList?.[selectedCargoIndex]?.port}`
                : "Issue Invoice"
            }
          >
            <IssueInvoiceModel
              opsId={id}
              isReadOnly={isReadOnly}
              setInitialRows={handleSetRows}
              initialRows={
                cargoOperationTableData?.cargoList?.[selectedCargoIndex]
                  ?.invoiceDetails || []
              }
              cargoDetails={cargoOperationTableData}
              selectedPort={
                cargoOperationTableData?.cargoList?.[selectedCargoIndex]
              }
            />
          </CustomShowModal>

          <PortSelectInvoiceModal
            open={isPortSelectModalOpen}
            handleClose={() => setIsPortSelectModalOpen(false)}
            cargoList={cargoOperationTableData?.cargoList || []}
            onSelectPort={handleSelectPortForInvoice}
            freightMode={freightMode}
          />

          <CustomAddModal
            open={openExpensesInvoiceModel}
            handleClose={() => setOpenExpensesInvoiceModel(false)}
            onSubmitConfirm={() => setOpenExpensesInvoiceModel(false)}
            saveLabel="Save"
            maxWidth="md"
            title="Expenses Invoice"
          >
            <ExpensesInvoiceModel
              isReadOnly={isReadOnly}
              expensesInvoiceDetails={values.Actual}
              vesselDetails={vesselContractDetails}
              usedCounterparties={usedCounterparties}
              setUsedCounterparties={setUsedCounterparties}
              expenseAllocations={expenseInvoices}
              setExpenseAllocations={setExpenseInvoices}
            />
          </CustomAddModal>

          <CustomShowModal
            open={openAddOperation.isOpen}
            handleClose={() =>
              setOpenAddOperation({
                isOpen: false,
                index: null,
              })
            }
            maxWidth="xs"
            title="Add Operation"
          >
            <AddOperationsModal
              delayPortsSearch={delayPortSearch}
              portOptions={portOptions}
              portLoading={portLoading}
              initialAddOperation={initialAddOperation}
              setInitialAddOperation={setInitialAddOperation}
              onAddOperationByModal={onAddOperationByModal}
              isOperationTab
            />
          </CustomShowModal>
          <CustomShowModal
            open={splitHireModal}
            handleClose={() => setSplitHireModal(false)}
            maxWidth="lg"
            title="Hire Expense Analyzer"
          >
            <HireExpenseCalculations
              isReadOnly={isReadOnly}
              fuelDeductions={fuelDeductions}
              setFuelDeductions={setFuelDeductions}
              offHireDeductions={offHireDeductions}
              setExtraDetails={(newDetails) => {
                setSubModelData((prevData) => ({
                  ...prevData,
                  expenses: newDetails,
                }));
              }}
              extraDetails={subModelData?.expenses}
              miscDeductions={miscDeductions}
              setOffHireDeductions={setOffHireDeductions}
              setMiscDeductions={setMiscDeductions}
              totalDeductions={totalDeductions}
              totalOffHireDuration={totalOffHireDuration}
              totalMiscDeductions={totalMiscDeductions}
              totalFuelDeductions={totalFuelDeductions}
              vesselData={vesselContractDetails?.vesselDetails}
            />
          </CustomShowModal>
          <CustomShowModal
            open={editCargoContractModelOpen}
            title={"Cargo Details"}
            maxWidth="md"
            saveLabel="Update"
            handleClose={() => setEditCargoContractModelOpen(false)}
          >
            <div className="flex justify-between items-center mb-4">
              <CustomTabs
                tabs={cargoDetailsViewTabs}
                active={activeCargoModelTab}
                setActive={setActiveCargoModelTab}
              />
              <button
                type="button"
                onClick={() => {
                  if (activeCargoModelTab === 1) {
                    addQueryModalRef.current?.onSubmitQuery();
                  } else {
                    handleUpdateCargoContract();
                  }
                }}
                className="h-[26px] px-3.5 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#1e2632] border border-[#313C4C] rounded shadow-2xs transition-all duration-150 active:scale-95 cursor-pointer whitespace-nowrap"
              >
                Update
              </button>
            </div>

            {activeCargoModelTab === 1 && (
              <CargoViewModel
                ref={addQueryModalRef}
                setLoader={setLoader}
                cargoAnalysisData={cargoOperationTableData}
                setSelectedPortsCommence={setSelectedPortsCommence}
                selectedQuery={{
                  ...cargoOperationTableData,
                  cargoContractId: cargoContractDetails?.cargoContractId || cargoContractDetails?._id || id || cargoOperationTableData?.cargoContractId,
                  _id: cargoContractDetails?.cargoContractId || cargoContractDetails?._id || id || cargoOperationTableData?._id,
                  contractId: cargoContractDetails?.cargoContractId || cargoContractDetails?._id || id || cargoOperationTableData?.contractId,
                }}
                cargoContractId={cargoContractDetails?.cargoContractId || cargoContractDetails?._id || id}
                selectedPorts={selectedPorts}
                refetch={() => fetchOperation()}
              />
            )}

            {activeCargoModelTab === 0 && (
              <CreateCargoContractForm
                isReadOnly={isReadOnly}
                formData={cargoContractDetails}
                setFormData={setCargoContractDetails}
                handleChange={handleCargoContractInputChange}
                removeAttachment={removeCargoAttachment}
                textContract={cargoTextContract}
                handleTextContractUpload={handleCargoTextContractUpload}
                handleAttachmentUpload={handleCargoContractAttachmentUpload}
                attachments={cargoAttachments}
                setTextContract={setCargoTextContract}
                prevAttachments={prevAttachments}
                setPrevAttachments={setPrevAttachments}
              />
            )}
          </CustomShowModal>
          <CustomShowModal
            open={!!selectedSettledAmt}
            handleClose={() => setSelectedSettledAmt(null)}
            title="Settled Amount Details"
            maxWidth="sm"
          >
            {selectedSettledAmt && (
              <div className="space-y-2 py-1">
                {/* Header Info Card */}
                <div className="bg-[#f8fafc] rounded-none p-2 border border-slate-200">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-[11px] text-slate-500 font-medium uppercase tracking-wider mb-0.5">
                        Reference Key
                      </p>
                      <p className="text-[11px] font-medium text-slate-900">
                        {[
                          ...expensesFields,
                          ...profitFileds,
                          ...revenueFields,
                        ].find((f) => f.key === selectedSettledAmt.key)
                          ?.label || selectedSettledAmt.key}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="text-[11px] text-slate-500 font-medium uppercase tracking-wider mb-0.5">
                        Total Settled
                      </p>
                      <p className="text-[11px] font-medium text-slate-900">
                        {Number(Number(selectedSettledAmt.totalSettledAmt || 0).toFixed(3))}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Compact Table */}
                <div className="border border-slate-200 rounded-none overflow-hidden">
                  <table className="w-full text-[11px] font-medium border-collapse">
                    <thead>
                      <tr className="bg-[#f8fafc] border-b border-slate-200 h-6">
                        <th className="px-2 py-0.5 w-[15%] text-left font-medium text-[11px] text-slate-700 border-r border-slate-200">
                          Amount
                        </th>
                        <th className="px-2 py-0.5 w-[20%] text-left font-medium text-[11px] text-slate-700 border-r border-slate-200">
                          Counter Party
                        </th>
                        <th className="px-2 py-0.5 w-[35%] text-left font-medium text-[11px] text-slate-700 border-r border-slate-200">
                          Remarks
                        </th>
                        <th className="px-2 py-0.5 w-[15%] text-left font-medium text-[11px] text-slate-700 border-r border-slate-200">
                          Received At
                        </th>
                        <th className="px-2 py-0.5 w-[15%] text-left font-medium text-[11px] text-slate-700">
                          Posted At
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {selectedSettledAmt.paymentEntries.map((entry, idx) => (
                        <tr
                          key={idx}
                          className="h-6 hover:bg-slate-50 transition-colors"
                        >
                          <td className="px-2 py-0.5 text-left font-medium text-[11px] text-slate-900 border-r border-slate-200">
                            {entry.amount}
                          </td>
                          <td className="px-2 py-0.5 text-slate-700 font-medium text-[11px] border-r border-slate-200">
                            {entry.counterParty}
                          </td>
                          <td className="px-2 py-0.5 text-slate-700 font-medium text-[11px] border-r border-slate-200">
                            {entry.remarks || "—"}
                          </td>
                          <td className="px-2 py-0.5 text-slate-700 font-medium text-[11px] border-r border-slate-200 whitespace-nowrap">
                            {moment(entry.date).isValid()
                              ? moment(entry.date).format("DD-MM-YYYY")
                              : "-"}
                          </td>
                          <td className="px-2 py-0.5 text-left text-slate-700 font-medium text-[11px] whitespace-nowrap">
                            {moment(entry.postedAt).isValid()
                              ? moment(entry.postedAt).format("DD-MM-YYYY")
                              : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </CustomShowModal>

          <CustomShowModal
            open={editVesselContractModelOpen}
            handleClose={() => setEditVesselContractModelOpen(false)}
            title="Vessel Contract"
            maxWidth="md"
          >
            <div className="flex justify-between items-center mb-4">
              <CustomTabs
                tabs={vesselDetailsViewTabs}
                active={vesselActiveTab}
                setActive={setVesselActiveTab}
              />
              <button
                type="button"
                onClick={() =>
                  vesselActiveTab === 1
                    ? handleUpdateVesselDetails()
                    : handleUpdateVesselContract()
                }
                className="h-[26px] px-3.5 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#1e2632] border border-[#313C4C] rounded shadow-2xs transition-all duration-150 active:scale-95 cursor-pointer whitespace-nowrap"
              >
                Update
              </button>
            </div>

            {vesselActiveTab === 0 && (
              <VesselContractForm
                isReadOnly={isReadOnly}
                formData={vesselContractDetails}
                setFormData={setVesselContractDetails}
                handleChange={handleVesselContractInputChange}
                isEditing
                attachments={vesselAttachments}
                textContract={vesselTextContract}
                removeAttachment={removeVesselAttachment}
                handleTextContractUpload={handleVesselTextContractUpload}
                handleAttachmentUpload={handleVesselContractAttachmentUpload}
                setTextContract={setVesselTextContract}
                prevAttachments={prevAttachments}
                setPrevAttachments={setPrevAttachments}
              />
            )}

            {vesselActiveTab === 1 && (
              <VesselViewModel
                ref={vesselRef}
                currentContract={{
                  ...vesselContractDetails.vesselDetails,
                  contractId: vesselContractDetails.vesselContractId,
                }}
                setCurrentContract={setVesselContractDetails}
                handleClose={() => setEditVesselContractModelOpen(false)}
                refetch={() => fetchOperation()}
                isFromOperation
              />
            )}
          </CustomShowModal>
          <CustomShowModal
            open={openFuelExpenseModel}
            handleClose={() => setOpenFuelExpenseModel(false)}
            title="View Fuel Expense"
            maxWidth="md"
          >
            <FuelExpenseTable
              isReadOnly={isReadOnly}
              fuelSettlementMode={fuelSettlementMode}
              fuelExpenseData={subModelData.fuelExpenseData}
              setfuelExpenseData={setSubModelData}
            />
          </CustomShowModal>
          <CustomShowModal
            open={openSustainabilityModel}
            handleClose={() => setOpenSustainabilityModel(false)}
            title="Add Sustainability"
            maxWidth="lg"
          >
            <SustainabilityModel
              formData={sustainabilityData}
              setFormData={setSustainabilityData}
              cargoDetails={cargoOperationTableData}
              calculatedExpenses={calculatedExpenses}
            />
          </CustomShowModal>
          <CustomShowModal
            open={optimumSpeedModelOpen}
            handleClose={() => setOptimumSpeedModelOpen(false)}
            title="View Optimum Speeds"
            maxWidth="sm"
          >
            <div className="rounded-none border border-[#cbd5e1] overflow-hidden my-1">
              <div className="overflow-x-auto scroll-thin w-full">
                <table className="w-full border-collapse text-[11px] font-medium">
                  <thead className="bg-[#e2e8f0] text-[#1e293b] h-[24px]">
                    <tr>
                      <Tooltip title="Ballast or laden" placement="top" arrow>
                        <th className="px-2.5 py-1 text-center font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">B/L</th>
                      </Tooltip>
                      <Tooltip title="Operation" placement="top" arrow>
                        <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">Operation</th>
                      </Tooltip>
                      <Tooltip title="Port" placement="top" arrow>
                        <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">Port</th>
                      </Tooltip>
                      <Tooltip title="Speed (Normal)" placement="top" arrow>
                        <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-r border-b border-[#cbd5e1]">
                          Speed (Normal)
                        </th>
                      </Tooltip>
                      <Tooltip title="Speed (ECA)" placement="top" arrow>
                        <th className="px-2.5 py-1 text-left font-medium capitalize tracking-wider text-[11px] text-[#1e293b] border-b border-[#cbd5e1]">
                          Speed (ECA)
                        </th>
                      </Tooltip>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {cargoOperationTableData?.cargoList?.length > 0 ? (
                      cargoOperationTableData.cargoList.map((item, i) => (
                        <tr
                          key={item?.id || i}
                          className="h-[20px] hover:bg-amber-50/50 transition-colors"
                        >
                          <td className={`px-2.5 py-0.5 whitespace-nowrap border-r border-b border-[#cbd5e1] align-middle text-center text-[11px] font-medium ${item?.lbmarker?.toLowerCase() === "laden"
                            ? "bg-emerald-50 text-emerald-800"
                            : "bg-amber-50 text-amber-800"
                            }`}>
                            {item?.lbmarker?.toLowerCase() === "laden" ? "Laden" : "Ballast"}
                          </td>
                          <td className="px-2.5 py-0.5 text-slate-800 font-medium text-[11px] border-r border-b border-[#cbd5e1] align-middle">
                            {item?.operation || "-"}
                          </td>
                          <td className="px-2.5 py-0.5 text-slate-800 font-medium text-[11px] border-r border-b border-[#cbd5e1] align-middle">
                            {item?.port || "-"}
                          </td>
                          <td className="px-2.5 py-0.5 text-slate-900 font-medium text-[11px] border-r border-b border-[#cbd5e1] bg-[#f0f4f9] align-middle">
                            {item?.speedNormal || "-"}
                          </td>
                          <td className="px-2.5 py-0.5 text-slate-900 font-medium text-[11px] border-b border-[#cbd5e1] bg-[#f0f4f9] align-middle">
                            {item?.speedECA || "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="px-2.5 py-4 text-center text-slate-400 italic text-[11px] font-medium border-b border-[#cbd5e1]">
                          No optimum speeds data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </CustomShowModal>
          <AdditionalRevenueModel
            open={openAdditionalRevenueModel}
            onClose={() => setOpenAdditionalRevenueModel(false)}
            isReadOnly={isReadOnly}
            items={subModelData.revenue.misc || []}
            onAdd={handleAddMiscRevenue}
            onRemove={(item, index) => handleRemoveMiscRevenue(index)}
            onRename={(item, index, value) => handleRenameMiscRevenue(index, value)}
            onUpdateAmount={(item, index, value) => handleUpdateMiscRevenueAmount(item.id ?? index, value)}
          />

          <OtherExpensesModal
            open={openOtherExpModel}
            onClose={() => setOpenOtherExpModel(false)}
            isReadOnly={isReadOnly}
            expensesData={subModelData.expenses || {}}
            onOpenBreakdown={({ label, key, itemsKey }) => {
              const existing = subModelData.expenses[itemsKey];
              if (!existing || !Array.isArray(existing)) {
                const currentVal = Number(subModelData.expenses[key]) || 0;
                setSubModelData((prev) => ({
                  ...prev,
                  expenses: {
                    ...prev.expenses,
                    [itemsKey]: [{ label, value: currentVal }],
                  },
                }));
              }
              setExpenseModalField({ label, value: key, itemsKey });
            }}
            onAddMisc={handleAddMiscExpense}
            onRemoveMisc={(item, index) => handleRemoveMiscExpense(index)}
            onRenameMisc={(item, index, value) => handleRenameMiscExpense(index, value)}
            onUpdateMiscAmount={(item, index, value) => handleChangeMiscExpenseAmount(index, value)}
            totalAmount={totalMiscExpenses + Number(subModelData?.expenses?.expensesPerDay || 0)}
          />
          <div>
            <DateChangeModal
              open={showDateChangeModal}
              onClose={() => setShowDateChangeModal(false)}
              onConfirm={confirmDateChange}
            />
          </div>

          {/* Expense Breakdown Modal (rendered on top of Other Expenses modal) */}
          {expenseModalField && (
            <CustomShowModal
              open={Boolean(expenseModalField)}
              handleClose={() => setExpenseModalField(null)}
              maxWidth="sm"
              title={expenseModalField.label}
            >
              <ExpenseBreakdownModal
                expenseLabel={expenseModalField.label}
                items={
                  subModelData.expenses[expenseModalField.itemsKey] ||
                  [{ label: expenseModalField.label, value: Number(subModelData.expenses[expenseModalField.value]) || 0 }]
                }
                onChange={(updatedItems, sum) => {
                  setSubModelData((prev) => {
                    const newExpenses = {
                      ...prev.expenses,
                      [expenseModalField.itemsKey]: updatedItems,
                      [expenseModalField.value]: sum,
                    };
                    if (expenseModalField.itemsKey === "dailyExpenses") {
                      newExpenses.cvePerDay = updatedItems
                        .filter((i) => i.label?.toLowerCase().includes("cve"))
                        .reduce((acc, i) => acc + (Number(i.value) || 0), 0);
                      newExpenses.insurancePerDay = updatedItems
                        .filter((i) => i.label?.toLowerCase().includes("insurance"))
                        .reduce((acc, i) => acc + (Number(i.value) || 0), 0);
                    }
                    return {
                      ...prev,
                      expenses: newExpenses,
                    };
                  });
                }}
              />
            </CustomShowModal>
          )}
          <style jsx>{`
            @keyframes slideInRight {
              from {
                transform: translateX(100%);
              }
              to {
                transform: translateX(0);
              }
            }

            @keyframes slideInLeft {
              from {
                transform: translateX(-100%);
              }
              to {
                transform: translateX(0);
              }
            }

            @keyframes slideOutRight {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(100%);
              }
            }

            @keyframes slideOutLeft {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(-100%);
              }
            }
          `}</style>
        </div>
      )}
      {mainTab === 0 &&
        (isRevised ? (
          <>
            <SavedContracts setLoader={setLoader} loader={loader} id={id} tabs={tabs}
              active={mainTab}
              handleMainTabChange={handleMainTabChange} />
          </>
        ) : (
          <>
            <SavedOperation
              setLoader={setLoader}
              loader={loader}
              id={id}
              isRevised={isRevised}
              setIsRevised={setIsRevised}
              tabs={tabs}
              active={mainTab}
              handleMainTabChange={handleMainTabChange}
            />
          </>
        ))}
      {mainTab === 1 && isRevised && (
        <>
          <SavedOperation
            setLoader={setLoader}
            loader={loader}
            id={id}
            isRevised={isRevised}
            setIsRevised={setIsRevised}
            tabs={tabs}
            active={mainTab}
            handleMainTabChange={handleMainTabChange}
          />
        </>
      )}
      <NextTripCargoSelectionModal
        open={nextTripModalOpen}
        onClose={() => setNextTripModalOpen(false)}
        previousOperationId={id}
        onSuccess={async (createdOp) => {
          const newOpId = createdOp?._id;
          if (newOpId) {
            setNextOperationId(newOpId);
            await fetchOperation();
            // Next Trip creates an Estimate (status: "open"), navigate to estimate view
            window.open(
              createdOp?.contractType === "vessel-vessel"
                ? `/vessel-vessel-contract/${newOpId}`
                : `/saved-contracts/${newOpId}`,
              "_blank",
            );
          }
        }}
      />
      <TripEndWarningModal
        open={tripEndWarningOpen}
        onClose={() => setTripEndWarningOpen(false)}
        mode={tripEndWarningMode}
        reason={tripEndWarningReason}
        onConfirmEndTrip={handleConfirmEndTrip}
      />
    </div>
  );
};

export default OperationCalc;
